
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0dd2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0dd2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4oKKP", function(module, exports) {
/**
 * WEBMIDI.js v3.3.1
 * A JavaScript library to kickstart your MIDI projects
 * https://webmidijs.org
 * Build generated on September 15th, 2026.
 *
 * © Copyright 2015-2026, Jean-Philippe Cô.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ "use strict";
class EventEmitter {
    constructor(e = !1){
        this.eventMap = {}, this.eventsSuspended = 1 == e;
    }
    addListener(e, t, n = {}) {
        if ("string" == typeof e && e.length < 1 || e instanceof String && e.length < 1 || "string" != typeof e && !(e instanceof String) && e !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if ("function" != typeof t) throw new TypeError("The callback must be a function.");
        const r = new Listener(e, this, t, n);
        return this.eventMap[e] || (this.eventMap[e] = []), n.prepend ? this.eventMap[e].unshift(r) : this.eventMap[e].push(r), r;
    }
    addOneTimeListener(e, t, n = {}) {
        n.remaining = 1, this.addListener(e, t, n);
    }
    static get ANY_EVENT() {
        return Symbol.for("Any event");
    }
    hasListener(e, t) {
        if (void 0 === e) return !!(this.eventMap[EventEmitter.ANY_EVENT] && this.eventMap[EventEmitter.ANY_EVENT].length > 0) || Object.entries(this.eventMap).some(([, e])=>e.length > 0);
        if (this.eventMap[e] && this.eventMap[e].length > 0) {
            if (t instanceof Listener) return this.eventMap[e].filter((e)=>e === t).length > 0;
            if ("function" == typeof t) return this.eventMap[e].filter((e)=>e.callback === t).length > 0;
            return null == t;
        }
        return !1;
    }
    get eventNames() {
        return Object.keys(this.eventMap);
    }
    getListeners(e) {
        return this.eventMap[e] || [];
    }
    suspendEvent(e) {
        this.getListeners(e).forEach((e)=>{
            e.suspended = !0;
        });
    }
    unsuspendEvent(e) {
        this.getListeners(e).forEach((e)=>{
            e.suspended = !1;
        });
    }
    getListenerCount(e) {
        return this.getListeners(e).length;
    }
    emit(e, ...t) {
        if ("string" != typeof e && !(e instanceof String)) throw new TypeError("The 'event' parameter must be a string.");
        if (this.eventsSuspended) return;
        let n = [], r = this.eventMap[EventEmitter.ANY_EVENT] || [];
        return this.eventMap[e] && (r = r.concat(this.eventMap[e])), r.forEach((e)=>{
            if (e.suspended) return;
            let r = [
                ...t
            ];
            Array.isArray(e.arguments) && (r = r.concat(e.arguments)), e.remaining > 0 && (n.push(e.callback.apply(e.context, r)), e.count++), --e.remaining < 1 && e.remove();
        }), n;
    }
    removeListener(e, t, n = {}) {
        if (void 0 === e) return void (this.eventMap = {});
        if (!this.eventMap[e]) return;
        let r = this.eventMap[e].filter((e)=>t && e.callback !== t || n.remaining && n.remaining !== e.remaining || n.context && n.context !== e.context);
        r.length ? this.eventMap[e] = r : delete this.eventMap[e];
    }
    async waitFor(e, t = {}) {
        return t.duration = parseInt(t.duration), (isNaN(t.duration) || t.duration <= 0) && (t.duration = 1 / 0), new Promise((n, r)=>{
            let i, s = this.addListener(e, ()=>{
                clearTimeout(i), n();
            }, {
                remaining: 1
            });
            t.duration !== 1 / 0 && (i = setTimeout(()=>{
                s.remove(), r("The duration expired before the event was emitted.");
            }, t.duration));
        });
    }
    get eventCount() {
        return Object.keys(this.eventMap).length;
    }
}
class Listener {
    constructor(e, t, n, r = {}){
        if ("string" != typeof e && !(e instanceof String) && e !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if (!t) throw new ReferenceError("The 'target' parameter is mandatory.");
        if ("function" != typeof n) throw new TypeError("The 'callback' must be a function.");
        void 0 === r.arguments || Array.isArray(r.arguments) || (r.arguments = [
            r.arguments
        ]), (r = Object.assign({
            context: t,
            remaining: 1 / 0,
            arguments: void 0,
            duration: 1 / 0
        }, r)).duration !== 1 / 0 && setTimeout(()=>this.remove(), r.duration), this.arguments = r.arguments, this.callback = n, this.context = r.context, this.count = 0, this.event = e, this.remaining = parseInt(r.remaining) >= 1 ? parseInt(r.remaining) : 1 / 0, this.suspended = !1, this.target = t;
    }
    remove() {
        this.target.removeListener(this.event, this.callback, {
            context: this.context,
            remaining: this.remaining
        });
    }
}
/**
 * The `Enumerations` class contains enumerations and arrays of elements used throughout the
 * library. All its properties are static and should be referenced using the class name. For
 * example: `Enumerations.CHANNEL_MESSAGES`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Enumerations {
    static get MIDI_CHANNEL_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MESSAGES enum instead."), Enumerations.CHANNEL_MESSAGES;
    }
    static get CHANNEL_MESSAGES() {
        return {
            noteoff: 8,
            noteon: 9,
            keyaftertouch: 10,
            controlchange: 11,
            programchange: 12,
            channelaftertouch: 13,
            pitchbend: 14
        };
    }
    static get CHANNEL_NUMBERS() {
        return [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get MIDI_CHANNEL_NUMBERS() {
        return this.validation && console.warn("The MIDI_CHANNEL_NUMBERS array has been deprecated. Use the Enumerations.CHANNEL_NUMBERS array instead."), [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get CHANNEL_MODE_MESSAGES() {
        return {
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MODE_MESSAGES enum instead."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    static get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been deprecated. Use the Enumerations.CONTROL_CHANGE_MESSAGES array instead."), {
            bankselectcoarse: 0,
            modulationwheelcoarse: 1,
            breathcontrollercoarse: 2,
            controller3: 3,
            footcontrollercoarse: 4,
            portamentotimecoarse: 5,
            dataentrycoarse: 6,
            volumecoarse: 7,
            balancecoarse: 8,
            controller9: 9,
            pancoarse: 10,
            expressioncoarse: 11,
            effectcontrol1coarse: 12,
            effectcontrol2coarse: 13,
            controller14: 14,
            controller15: 15,
            generalpurposeslider1: 16,
            generalpurposeslider2: 17,
            generalpurposeslider3: 18,
            generalpurposeslider4: 19,
            controller20: 20,
            controller21: 21,
            controller22: 22,
            controller23: 23,
            controller24: 24,
            controller25: 25,
            controller26: 26,
            controller27: 27,
            controller28: 28,
            controller29: 29,
            controller30: 30,
            controller31: 31,
            bankselectfine: 32,
            modulationwheelfine: 33,
            breathcontrollerfine: 34,
            controller35: 35,
            footcontrollerfine: 36,
            portamentotimefine: 37,
            dataentryfine: 38,
            volumefine: 39,
            balancefine: 40,
            controller41: 41,
            panfine: 42,
            expressionfine: 43,
            effectcontrol1fine: 44,
            effectcontrol2fine: 45,
            controller46: 46,
            controller47: 47,
            controller48: 48,
            controller49: 49,
            controller50: 50,
            controller51: 51,
            controller52: 52,
            controller53: 53,
            controller54: 54,
            controller55: 55,
            controller56: 56,
            controller57: 57,
            controller58: 58,
            controller59: 59,
            controller60: 60,
            controller61: 61,
            controller62: 62,
            controller63: 63,
            holdpedal: 64,
            portamento: 65,
            sustenutopedal: 66,
            softpedal: 67,
            legatopedal: 68,
            hold2pedal: 69,
            soundvariation: 70,
            resonance: 71,
            soundreleasetime: 72,
            soundattacktime: 73,
            brightness: 74,
            soundcontrol6: 75,
            soundcontrol7: 76,
            soundcontrol8: 77,
            soundcontrol9: 78,
            soundcontrol10: 79,
            generalpurposebutton1: 80,
            generalpurposebutton2: 81,
            generalpurposebutton3: 82,
            generalpurposebutton4: 83,
            controller84: 84,
            controller85: 85,
            controller86: 86,
            controller87: 87,
            controller88: 88,
            controller89: 89,
            controller90: 90,
            reverblevel: 91,
            tremololevel: 92,
            choruslevel: 93,
            celestelevel: 94,
            phaserlevel: 95,
            databuttonincrement: 96,
            databuttondecrement: 97,
            nonregisteredparametercoarse: 98,
            nonregisteredparameterfine: 99,
            registeredparametercoarse: 100,
            registeredparameterfine: 101,
            controller102: 102,
            controller103: 103,
            controller104: 104,
            controller105: 105,
            controller106: 106,
            controller107: 107,
            controller108: 108,
            controller109: 109,
            controller110: 110,
            controller111: 111,
            controller112: 112,
            controller113: 113,
            controller114: 114,
            controller115: 115,
            controller116: 116,
            controller117: 117,
            controller118: 118,
            controller119: 119,
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get CONTROL_CHANGE_MESSAGES() {
        return [
            {
                number: 0,
                name: "bankselectcoarse",
                description: "Bank Select (Coarse)",
                position: "msb"
            },
            {
                number: 1,
                name: "modulationwheelcoarse",
                description: "Modulation Wheel (Coarse)",
                position: "msb"
            },
            {
                number: 2,
                name: "breathcontrollercoarse",
                description: "Breath Controller (Coarse)",
                position: "msb"
            },
            {
                number: 3,
                name: "controller3",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 4,
                name: "footcontrollercoarse",
                description: "Foot Controller (Coarse)",
                position: "msb"
            },
            {
                number: 5,
                name: "portamentotimecoarse",
                description: "Portamento Time (Coarse)",
                position: "msb"
            },
            {
                number: 6,
                name: "dataentrycoarse",
                description: "Data Entry (Coarse)",
                position: "msb"
            },
            {
                number: 7,
                name: "volumecoarse",
                description: "Channel Volume (Coarse)",
                position: "msb"
            },
            {
                number: 8,
                name: "balancecoarse",
                description: "Balance (Coarse)",
                position: "msb"
            },
            {
                number: 9,
                name: "controller9",
                description: "Controller 9 (Coarse)",
                position: "msb"
            },
            {
                number: 10,
                name: "pancoarse",
                description: "Pan (Coarse)",
                position: "msb"
            },
            {
                number: 11,
                name: "expressioncoarse",
                description: "Expression Controller (Coarse)",
                position: "msb"
            },
            {
                number: 12,
                name: "effectcontrol1coarse",
                description: "Effect Control 1 (Coarse)",
                position: "msb"
            },
            {
                number: 13,
                name: "effectcontrol2coarse",
                description: "Effect Control 2 (Coarse)",
                position: "msb"
            },
            {
                number: 14,
                name: "controller14",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 15,
                name: "controller15",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 16,
                name: "generalpurposecontroller1",
                description: "General Purpose Controller 1 (Coarse)",
                position: "msb"
            },
            {
                number: 17,
                name: "generalpurposecontroller2",
                description: "General Purpose Controller 2 (Coarse)",
                position: "msb"
            },
            {
                number: 18,
                name: "generalpurposecontroller3",
                description: "General Purpose Controller 3 (Coarse)",
                position: "msb"
            },
            {
                number: 19,
                name: "generalpurposecontroller4",
                description: "General Purpose Controller 4 (Coarse)",
                position: "msb"
            },
            {
                number: 20,
                name: "controller20",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 21,
                name: "controller21",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 22,
                name: "controller22",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 23,
                name: "controller23",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 24,
                name: "controller24",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 25,
                name: "controller25",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 26,
                name: "controller26",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 27,
                name: "controller27",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 28,
                name: "controller28",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 29,
                name: "controller29",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 30,
                name: "controller30",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 31,
                name: "controller31",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 32,
                name: "bankselectfine",
                description: "Bank Select (Fine)",
                position: "lsb"
            },
            {
                number: 33,
                name: "modulationwheelfine",
                description: "Modulation Wheel (Fine)",
                position: "lsb"
            },
            {
                number: 34,
                name: "breathcontrollerfine",
                description: "Breath Controller (Fine)",
                position: "lsb"
            },
            {
                number: 35,
                name: "controller35",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 36,
                name: "footcontrollerfine",
                description: "Foot Controller (Fine)",
                position: "lsb"
            },
            {
                number: 37,
                name: "portamentotimefine",
                description: "Portamento Time (Fine)",
                position: "lsb"
            },
            {
                number: 38,
                name: "dataentryfine",
                description: "Data Entry (Fine)",
                position: "lsb"
            },
            {
                number: 39,
                name: "channelvolumefine",
                description: "Channel Volume (Fine)",
                position: "lsb"
            },
            {
                number: 40,
                name: "balancefine",
                description: "Balance (Fine)",
                position: "lsb"
            },
            {
                number: 41,
                name: "controller41",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 42,
                name: "panfine",
                description: "Pan (Fine)",
                position: "lsb"
            },
            {
                number: 43,
                name: "expressionfine",
                description: "Expression Controller (Fine)",
                position: "lsb"
            },
            {
                number: 44,
                name: "effectcontrol1fine",
                description: "Effect control 1 (Fine)",
                position: "lsb"
            },
            {
                number: 45,
                name: "effectcontrol2fine",
                description: "Effect control 2 (Fine)",
                position: "lsb"
            },
            {
                number: 46,
                name: "controller46",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 47,
                name: "controller47",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 48,
                name: "controller48",
                description: "General Purpose Controller 1 (Fine)",
                position: "lsb"
            },
            {
                number: 49,
                name: "controller49",
                description: "General Purpose Controller 2 (Fine)",
                position: "lsb"
            },
            {
                number: 50,
                name: "controller50",
                description: "General Purpose Controller 3 (Fine)",
                position: "lsb"
            },
            {
                number: 51,
                name: "controller51",
                description: "General Purpose Controller 4 (Fine)",
                position: "lsb"
            },
            {
                number: 52,
                name: "controller52",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 53,
                name: "controller53",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 54,
                name: "controller54",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 55,
                name: "controller55",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 56,
                name: "controller56",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 57,
                name: "controller57",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 58,
                name: "controller58",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 59,
                name: "controller59",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 60,
                name: "controller60",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 61,
                name: "controller61",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 62,
                name: "controller62",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 63,
                name: "controller63",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 64,
                name: "damperpedal",
                description: "Damper Pedal On/Off"
            },
            {
                number: 65,
                name: "portamento",
                description: "Portamento On/Off"
            },
            {
                number: 66,
                name: "sostenuto",
                description: "Sostenuto On/Off"
            },
            {
                number: 67,
                name: "softpedal",
                description: "Soft Pedal On/Off"
            },
            {
                number: 68,
                name: "legatopedal",
                description: "Legato Pedal On/Off"
            },
            {
                number: 69,
                name: "hold2",
                description: "Hold 2 On/Off"
            },
            {
                number: 70,
                name: "soundvariation",
                description: "Sound Variation",
                position: "lsb"
            },
            {
                number: 71,
                name: "resonance",
                description: "Resonance",
                position: "lsb"
            },
            {
                number: 72,
                name: "releasetime",
                description: "Release Time",
                position: "lsb"
            },
            {
                number: 73,
                name: "attacktime",
                description: "Attack Time",
                position: "lsb"
            },
            {
                number: 74,
                name: "brightness",
                description: "Brightness",
                position: "lsb"
            },
            {
                number: 75,
                name: "decaytime",
                description: "Decay Time",
                position: "lsb"
            },
            {
                number: 76,
                name: "vibratorate",
                description: "Vibrato Rate",
                position: "lsb"
            },
            {
                number: 77,
                name: "vibratodepth",
                description: "Vibrato Depth",
                position: "lsb"
            },
            {
                number: 78,
                name: "vibratodelay",
                description: "Vibrato Delay",
                position: "lsb"
            },
            {
                number: 79,
                name: "controller79",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 80,
                name: "generalpurposecontroller5",
                description: "General Purpose Controller 5",
                position: "lsb"
            },
            {
                number: 81,
                name: "generalpurposecontroller6",
                description: "General Purpose Controller 6",
                position: "lsb"
            },
            {
                number: 82,
                name: "generalpurposecontroller7",
                description: "General Purpose Controller 7",
                position: "lsb"
            },
            {
                number: 83,
                name: "generalpurposecontroller8",
                description: "General Purpose Controller 8",
                position: "lsb"
            },
            {
                number: 84,
                name: "portamentocontrol",
                description: "Portamento Control",
                position: "lsb"
            },
            {
                number: 85,
                name: "controller85",
                description: "Undefined"
            },
            {
                number: 86,
                name: "controller86",
                description: "Undefined"
            },
            {
                number: 87,
                name: "controller87",
                description: "Undefined"
            },
            {
                number: 88,
                name: "highresolutionvelocityprefix",
                description: "High Resolution Velocity Prefix",
                position: "lsb"
            },
            {
                number: 89,
                name: "controller89",
                description: "Undefined"
            },
            {
                number: 90,
                name: "controller90",
                description: "Undefined"
            },
            {
                number: 91,
                name: "effect1depth",
                description: "Effects 1 Depth (Reverb Send Level)"
            },
            {
                number: 92,
                name: "effect2depth",
                description: "Effects 2 Depth"
            },
            {
                number: 93,
                name: "effect3depth",
                description: "Effects 3 Depth (Chorus Send Level)"
            },
            {
                number: 94,
                name: "effect4depth",
                description: "Effects 4 Depth"
            },
            {
                number: 95,
                name: "effect5depth",
                description: "Effects 5 Depth"
            },
            {
                number: 96,
                name: "dataincrement",
                description: "Data Increment"
            },
            {
                number: 97,
                name: "datadecrement",
                description: "Data Decrement"
            },
            {
                number: 98,
                name: "nonregisteredparameterfine",
                description: "Non-Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 99,
                name: "nonregisteredparametercoarse",
                description: "Non-Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 100,
                name: "registeredparameterfine",
                description: "Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 101,
                name: "registeredparametercoarse",
                description: "Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 102,
                name: "controller102",
                description: "Undefined"
            },
            {
                number: 103,
                name: "controller103",
                description: "Undefined"
            },
            {
                number: 104,
                name: "controller104",
                description: "Undefined"
            },
            {
                number: 105,
                name: "controller105",
                description: "Undefined"
            },
            {
                number: 106,
                name: "controller106",
                description: "Undefined"
            },
            {
                number: 107,
                name: "controller107",
                description: "Undefined"
            },
            {
                number: 108,
                name: "controller108",
                description: "Undefined"
            },
            {
                number: 109,
                name: "controller109",
                description: "Undefined"
            },
            {
                number: 110,
                name: "controller110",
                description: "Undefined"
            },
            {
                number: 111,
                name: "controller111",
                description: "Undefined"
            },
            {
                number: 112,
                name: "controller112",
                description: "Undefined"
            },
            {
                number: 113,
                name: "controller113",
                description: "Undefined"
            },
            {
                number: 114,
                name: "controller114",
                description: "Undefined"
            },
            {
                number: 115,
                name: "controller115",
                description: "Undefined"
            },
            {
                number: 116,
                name: "controller116",
                description: "Undefined"
            },
            {
                number: 117,
                name: "controller117",
                description: "Undefined"
            },
            {
                number: 118,
                name: "controller118",
                description: "Undefined"
            },
            {
                number: 119,
                name: "controller119",
                description: "Undefined"
            },
            {
                number: 120,
                name: "allsoundoff",
                description: "All Sound Off"
            },
            {
                number: 121,
                name: "resetallcontrollers",
                description: "Reset All Controllers"
            },
            {
                number: 122,
                name: "localcontrol",
                description: "Local Control On/Off"
            },
            {
                number: 123,
                name: "allnotesoff",
                description: "All Notes Off"
            },
            {
                number: 124,
                name: "omnimodeoff",
                description: "Omni Mode Off"
            },
            {
                number: 125,
                name: "omnimodeon",
                description: "Omni Mode On"
            },
            {
                number: 126,
                name: "monomodeon",
                description: "Mono Mode On"
            },
            {
                number: 127,
                name: "polymodeon",
                description: "Poly Mode On"
            }
        ];
    }
    static get REGISTERED_PARAMETERS() {
        return {
            pitchbendrange: [
                0,
                0
            ],
            channelfinetuning: [
                0,
                1
            ],
            channelcoarsetuning: [
                0,
                2
            ],
            tuningprogram: [
                0,
                3
            ],
            tuningbank: [
                0,
                4
            ],
            modulationrange: [
                0,
                5
            ],
            azimuthangle: [
                61,
                0
            ],
            elevationangle: [
                61,
                1
            ],
            gain: [
                61,
                2
            ],
            distanceratio: [
                61,
                3
            ],
            maximumdistance: [
                61,
                4
            ],
            maximumdistancegain: [
                61,
                5
            ],
            referencedistanceratio: [
                61,
                6
            ],
            panspreadangle: [
                61,
                7
            ],
            rollangle: [
                61,
                8
            ]
        };
    }
    static get MIDI_REGISTERED_PARAMETERS() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETERS enum has been deprecated. Use the Enumerations.REGISTERED_PARAMETERS enum instead."), Enumerations.MIDI_REGISTERED_PARAMETERS;
    }
    static get SYSTEM_MESSAGES() {
        return {
            sysex: 240,
            timecode: 241,
            songposition: 242,
            songselect: 243,
            tunerequest: 246,
            tuningrequest: 246,
            sysexend: 247,
            clock: 248,
            start: 250,
            continue: 251,
            stop: 252,
            activesensing: 254,
            reset: 255,
            midimessage: 0,
            unknownsystemmessage: -1
        };
    }
    static get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been deprecated. Use the Enumerations.SYSTEM_MESSAGES enum instead."), Enumerations.SYSTEM_MESSAGES;
    }
    static get CHANNEL_EVENTS() {
        return [
            "noteoff",
            "controlchange",
            "noteon",
            "keyaftertouch",
            "programchange",
            "channelaftertouch",
            "pitchbend",
            "allnotesoff",
            "allsoundoff",
            "localcontrol",
            "monomode",
            "omnimode",
            "resetallcontrollers",
            "nrpn",
            "nrpn-dataentrycoarse",
            "nrpn-dataentryfine",
            "nrpn-dataincrement",
            "nrpn-datadecrement",
            "rpn",
            "rpn-dataentrycoarse",
            "rpn-dataentryfine",
            "rpn-dataincrement",
            "rpn-datadecrement",
            "nrpn-databuttonincrement",
            "nrpn-databuttondecrement",
            "rpn-databuttonincrement",
            "rpn-databuttondecrement"
        ];
    }
}
/**
 * The `Note` class represents a single musical note such as `"D3"`, `"G#4"`, `"F-1"`, `"Gb7"`, etc.
 *
 * `Note` objects can be played back on a single channel by calling
 * [`OutputChannel.playNote()`]{@link OutputChannel#playNote} or, on multiple channels of the same
 * output, by calling [`Output.playNote()`]{@link Output#playNote}.
 *
 * The note has [`attack`](#attack) and [`release`](#release) velocities set at `0.5` by default.
 * These can be changed by passing in the appropriate option. It is also possible to set a
 * system-wide default for attack and release velocities by using the
 * [`WebMidi.defaults`](WebMidi#defaults) property.
 *
 * If you prefer to work with raw MIDI values (`0` to `127`), you can use [`rawAttack`](#rawAttack) and
 * [`rawRelease`](#rawRelease) to both get and set the values.
 *
 * The note may have a [`duration`](#duration). If it does, playback will be automatically stopped
 * when the duration has elapsed by sending a `"noteoff"` event. By default, the duration is set to
 * `Infinity`. In this case, it will never stop playing unless explicitly stopped by calling a
 * method such as [`OutputChannel.stopNote()`]{@link OutputChannel#stopNote},
 * [`Output.stopNote()`]{@link Output#stopNote} or similar.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Note {
    constructor(e, t = {}){
        this.duration = wm.defaults.note.duration, this.attack = wm.defaults.note.attack, this.release = wm.defaults.note.release, null != t.duration && (this.duration = t.duration), null != t.attack && (this.attack = t.attack), null != t.rawAttack && (this.attack = Utilities.from7bitToFloat(t.rawAttack)), null != t.release && (this.release = t.release), null != t.rawRelease && (this.release = Utilities.from7bitToFloat(t.rawRelease)), Number.isInteger(e) ? this.identifier = Utilities.toNoteIdentifier(e) : this.identifier = e;
    }
    get identifier() {
        return this._name + (this._accidental || "") + this._octave;
    }
    set identifier(e) {
        const t = Utilities.getNoteDetails(e);
        if (wm.validation && !e) throw new Error("Invalid note identifier");
        this._name = t.name, this._accidental = t.accidental, this._octave = t.octave;
    }
    get name() {
        return this._name;
    }
    set name(e) {
        if (wm.validation && (e = e.toUpperCase(), ![
            "C",
            "D",
            "E",
            "F",
            "G",
            "A",
            "B"
        ].includes(e))) throw new Error("Invalid name value");
        this._name = e;
    }
    get accidental() {
        return this._accidental;
    }
    set accidental(e) {
        if (wm.validation && (e = e.toLowerCase(), ![
            "#",
            "##",
            "b",
            "bb"
        ].includes(e))) throw new Error("Invalid accidental value");
        this._accidental = e;
    }
    get octave() {
        return this._octave;
    }
    set octave(e) {
        if (wm.validation && (e = parseInt(e), isNaN(e))) throw new Error("Invalid octave value");
        this._octave = e;
    }
    get duration() {
        return this._duration;
    }
    set duration(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || null === e || e < 0)) throw new RangeError("Invalid duration value.");
        this._duration = e;
    }
    get attack() {
        return this._attack;
    }
    set attack(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || !(e >= 0 && e <= 1))) throw new RangeError("Invalid attack value.");
        this._attack = e;
    }
    get release() {
        return this._release;
    }
    set release(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || !(e >= 0 && e <= 1))) throw new RangeError("Invalid release value.");
        this._release = e;
    }
    get rawAttack() {
        return Utilities.fromFloatTo7Bit(this._attack);
    }
    set rawAttack(e) {
        this._attack = Utilities.from7bitToFloat(e);
    }
    get rawRelease() {
        return Utilities.fromFloatTo7Bit(this._release);
    }
    set rawRelease(e) {
        this._release = Utilities.from7bitToFloat(e);
    }
    get number() {
        return Utilities.toNoteNumber(this.identifier);
    }
    getOffsetNumber(e = 0, t = 0) {
        return wm.validation && (e = parseInt(e) || 0, t = parseInt(t) || 0), Math.min(Math.max(this.number + 12 * e + t, 0), 127);
    }
}
/**
 * The `Utilities` class contains general-purpose utility methods. All methods are static and
 * should be called using the class name. For example: `Utilities.getNoteDetails("C4")`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Utilities {
    /**
   * Returns a MIDI note number matching the identifier passed in the form of a string. The
   * identifier must include the octave number. The identifier also optionally include a sharp (#),
   * a double sharp (##), a flat (b) or a double flat (bb) symbol. For example, these are all valid
   * identifiers: C5, G4, D#-1, F0, Gb7, Eb-1, Abb4, B##6, etc.
   *
   * When converting note identifiers to numbers, C4 is considered to be middle C (MIDI note number
   * 60) as per the scientific pitch notation standard.
   *
   * The resulting note number can be offset by using the `octaveOffset` parameter.
   *
   * @param identifier {string} The identifier in the form of a letter, followed by an optional "#",
   * "##", "b" or "bb" followed by the octave number. For exemple: C5, G4, D#-1, F0, Gb7, Eb-1,
   * Abb4, B##6, etc.
   *
   * @param {number} [octaveOffset=0] A integer to offset the octave by.
   *
   * @returns {number} The MIDI note number (an integer between 0 and 127).
   *
   * @throws RangeError Invalid 'octaveOffset' value
   *
   * @throws TypeError Invalid note identifier
   *
   * @license Apache-2.0
   * @since 3.0.0
   * @static
   */ static toNoteNumber(e, t = 0) {
        if (t = null == t ? 0 : parseInt(t), isNaN(t)) throw new RangeError("Invalid 'octaveOffset' value");
        "string" != typeof e && (e = "");
        const n = this.getNoteDetails(e);
        if (!n) throw new TypeError("Invalid note identifier");
        let r = 12 * (n.octave + 1 + t);
        if (r += ({
            C: 0,
            D: 2,
            E: 4,
            F: 5,
            G: 7,
            A: 9,
            B: 11
        })[n.name], n.accidental && (n.accidental.startsWith("b") ? r -= n.accidental.length : r += n.accidental.length), r < 0 || r > 127) throw new RangeError("Invalid octaveOffset value");
        return r;
    }
    static getNoteDetails(e) {
        Number.isInteger(e) && (e = this.toNoteIdentifier(e));
        const t = e.match(/^([CDEFGAB])(#{0,2}|b{0,2})(-?\d+)$/i);
        if (!t) throw new TypeError("Invalid note identifier");
        const n = t[1].toUpperCase(), r = parseInt(t[3]);
        let i = t[2].toLowerCase();
        i = "" === i ? void 0 : i;
        return {
            accidental: i,
            identifier: n + (i || "") + r,
            name: n,
            octave: r
        };
    }
    static sanitizeChannels(e) {
        let t;
        if (wm.validation) {
            if ("all" === e) t = [
                "all"
            ];
            else if ("none" === e) return [];
        }
        return t = Array.isArray(e) ? e : [
            e
        ], t.indexOf("all") > -1 && (t = Enumerations.MIDI_CHANNEL_NUMBERS), t.map(function(e) {
            return parseInt(e);
        }).filter(function(e) {
            return e >= 1 && e <= 16;
        });
    }
    static toTimestamp(e) {
        let t = !1;
        const n = parseFloat(e);
        return !isNaN(n) && ("string" == typeof e && "+" === e.substring(0, 1) ? n >= 0 && (t = wm.time + n) : n >= 0 && (t = n), t);
    }
    static guessNoteNumber(e, t) {
        t = parseInt(t) || 0;
        let n = !1;
        if (Number.isInteger(e) && e >= 0 && e <= 127) n = parseInt(e);
        else if (parseInt(e) >= 0 && parseInt(e) <= 127) n = parseInt(e);
        else if ("string" == typeof e || e instanceof String) try {
            n = this.toNoteNumber(e.trim(), t);
        } catch (e) {
            return !1;
        }
        return n;
    }
    static toNoteIdentifier(e, t) {
        if (e = parseInt(e), isNaN(e) || e < 0 || e > 127) throw new RangeError("Invalid note number");
        if (t = null == t ? 0 : parseInt(t), isNaN(t)) throw new RangeError("Invalid octaveOffset value");
        const n = Math.floor(e / 12 - 1) + t;
        return [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ][e % 12] + n.toString();
    }
    static buildNote(e, t = {}) {
        if (t.octaveOffset = parseInt(t.octaveOffset) || 0, e instanceof Note) return e;
        let n = this.guessNoteNumber(e, t.octaveOffset);
        if (!1 === n) throw new TypeError(`The input could not be parsed as a note (${e})`);
        return t.octaveOffset = void 0, new Note(n, t);
    }
    static buildNoteArray(e, t = {}) {
        let n = [];
        return Array.isArray(e) || (e = [
            e
        ]), e.forEach((e)=>{
            n.push(this.buildNote(e, t));
        }), n;
    }
    static from7bitToFloat(e) {
        return e === 1 / 0 && (e = 127), e = parseInt(e) || 0, Math.min(Math.max(e / 127, 0), 1);
    }
    static fromFloatTo7Bit(e) {
        return e === 1 / 0 && (e = 1), e = parseFloat(e) || 0, Math.min(Math.max(Math.round(127 * e), 0), 127);
    }
    static fromMsbLsbToFloat(e, t = 0) {
        wm.validation && (e = Math.min(Math.max(parseInt(e) || 0, 0), 127), t = Math.min(Math.max(parseInt(t) || 0, 0), 127));
        const n = ((e << 7) + t) / 16383;
        return Math.min(Math.max(n, 0), 1);
    }
    static fromFloatToMsbLsb(e) {
        wm.validation && (e = Math.min(Math.max(parseFloat(e) || 0, 0), 1));
        const t = Math.round(16383 * e);
        return {
            msb: t >> 7,
            lsb: 127 & t
        };
    }
    static offsetNumber(e, t = 0, n = 0) {
        if (wm.validation) {
            if (e = parseInt(e), isNaN(e)) throw new Error("Invalid note number");
            t = parseInt(t) || 0, n = parseInt(n) || 0;
        }
        return Math.min(Math.max(e + 12 * t + n, 0), 127);
    }
    static getPropertyByValue(e, t) {
        return Object.keys(e).find((n)=>e[n] === t);
    }
    static getCcNameByNumber(e) {
        if (!wm.validation || (e = parseInt(e)) >= 0 && e <= 127) return Enumerations.CONTROL_CHANGE_MESSAGES[e].name;
    }
    static getCcNumberByName(e) {
        let t = Enumerations.CONTROL_CHANGE_MESSAGES.find((t)=>t.name === e);
        return t ? t.number : Enumerations.MIDI_CONTROL_CHANGE_MESSAGES[e];
    }
    static getChannelModeByNumber(e) {
        if (!(e >= 120 && e <= 127)) return !1;
        for(let t in Enumerations.CHANNEL_MODE_MESSAGES)if (Enumerations.CHANNEL_MODE_MESSAGES.hasOwnProperty(t) && e === Enumerations.CHANNEL_MODE_MESSAGES[t]) return t;
        return !1;
    }
    static get isNode() {
        return false;
    }
    static get isBrowser() {
        return "undefined" != typeof window && void 0 !== window.document;
    }
}
/**
 * The `OutputChannel` class represents a single output MIDI channel. `OutputChannel` objects are
 * provided by an [`Output`](Output) port which, itself, is made available by a device. The
 * `OutputChannel` object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `OutputChannel` objects can be found inside the parent output's
 * [`channels`]{@link Output#channels} property.
 *
 * @param {Output} output The [`Output`](Output) this channel belongs to.
 * @param {number} number The MIDI channel number (`1` - `16`).
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class OutputChannel extends EventEmitter {
    constructor(e, t){
        super(), this._output = e, this._number = t, this._octaveOffset = 0;
    }
    destroy() {
        this._output = null, this._number = null, this._octaveOffset = 0, this.removeListener();
    }
    send(e, t = {
        time: 0
    }) {
        return this.output.send(e, t), this;
    }
    sendKeyAftertouch(e, t, n = {}) {
        if (wm.validation) {
            if (n.useRawValue && (n.rawValue = n.useRawValue), isNaN(parseFloat(t))) throw new RangeError("Invalid key aftertouch value.");
            if (n.rawValue) {
                if (!(t >= 0 && t <= 127 && Number.isInteger(t))) throw new RangeError("Key aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(t >= 0 && t <= 1)) throw new RangeError("Key aftertouch value must be a float between 0 and 1.");
        }
        n.rawValue || (t = Utilities.fromFloatTo7Bit(t));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Array.isArray(e) || (e = [
            e
        ]), Utilities.buildNoteArray(e).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.keyaftertouch << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                t
            ], {
                time: Utilities.toTimestamp(n.time)
            });
        }), this;
    }
    /**
   * Sends a MIDI **control change** message to the channel at the scheduled time. The control
   * change message to send can be specified numerically (`0` to `127`) or by using one of the
   * following common names:
   *
   * | Number | Name                          |
   * |--------|-------------------------------|
   * | 0      |`bankselectcoarse`             |
   * | 1      |`modulationwheelcoarse`        |
   * | 2      |`breathcontrollercoarse`       |
   * | 4      |`footcontrollercoarse`         |
   * | 5      |`portamentotimecoarse`         |
   * | 6      |`dataentrycoarse`              |
   * | 7      |`volumecoarse`                 |
   * | 8      |`balancecoarse`                |
   * | 10     |`pancoarse`                    |
   * | 11     |`expressioncoarse`             |
   * | 12     |`effectcontrol1coarse`         |
   * | 13     |`effectcontrol2coarse`         |
   * | 18     |`generalpurposeslider3`        |
   * | 19     |`generalpurposeslider4`        |
   * | 32     |`bankselectfine`               |
   * | 33     |`modulationwheelfine`          |
   * | 34     |`breathcontrollerfine`         |
   * | 36     |`footcontrollerfine`           |
   * | 37     |`portamentotimefine`           |
   * | 38     |`dataentryfine`                |
   * | 39     |`volumefine`                   |
   * | 40     |`balancefine`                  |
   * | 42     |`panfine`                      |
   * | 43     |`expressionfine`               |
   * | 44     |`effectcontrol1fine`           |
   * | 45     |`effectcontrol2fine`           |
   * | 64     |`holdpedal`                    |
   * | 65     |`portamento`                   |
   * | 66     |`sustenutopedal`               |
   * | 67     |`softpedal`                    |
   * | 68     |`legatopedal`                  |
   * | 69     |`hold2pedal`                   |
   * | 70     |`soundvariation`               |
   * | 71     |`resonance`                    |
   * | 72     |`soundreleasetime`             |
   * | 73     |`soundattacktime`              |
   * | 74     |`brightness`                   |
   * | 75     |`soundcontrol6`                |
   * | 76     |`soundcontrol7`                |
   * | 77     |`soundcontrol8`                |
   * | 78     |`soundcontrol9`                |
   * | 79     |`soundcontrol10`               |
   * | 80     |`generalpurposebutton1`        |
   * | 81     |`generalpurposebutton2`        |
   * | 82     |`generalpurposebutton3`        |
   * | 83     |`generalpurposebutton4`        |
   * | 91     |`reverblevel`                  |
   * | 92     |`tremololevel`                 |
   * | 93     |`choruslevel`                  |
   * | 94     |`celestelevel`                 |
   * | 95     |`phaserlevel`                  |
   * | 96     |`dataincrement`                |
   * | 97     |`datadecrement`                |
   * | 98     |`nonregisteredparametercoarse` |
   * | 99     |`nonregisteredparameterfine`   |
   * | 100    |`registeredparametercoarse`    |
   * | 101    |`registeredparameterfine`      |
   * | 120    |`allsoundoff`                  |
   * | 121    |`resetallcontrollers`          |
   * | 122    |`localcontrol`                 |
   * | 123    |`allnotesoff`                  |
   * | 124    |`omnimodeoff`                  |
   * | 125    |`omnimodeon`                   |
   * | 126    |`monomodeon`                   |
   * | 127    |`polymodeon`                   |
   *
   * As you can see above, not all control change message have a matching name. This does not mean
   * you cannot use the others. It simply means you will need to use their number
   * (`0` to `127`) instead of their name. While you can still use them, numbers `120` to `127` are
   * usually reserved for *channel mode* messages. See
   * [`sendChannelMode()`]{@link OutputChannel#sendChannelMode} method for more info.
   *
   * To view a detailed list of all available **control change** messages, please consult "Table 3 -
   * Control Change Messages" from the [MIDI Messages](
   * https://www.midi.org/specifications/item/table-3-control-change-messages-data-bytes-2)
   * specification.
   *
   * **Note**: messages #0-31 (MSB) are paired with messages #32-63 (LSB). For example, message #1
   * (`modulationwheelcoarse`) can be accompanied by a second control change message for
   * `modulationwheelfine` to achieve a greater level of precision. if you want to specify both MSB
   * and LSB for messages between `0` and `31`, you can do so by passing a 2-value array as the
   * second parameter.
   *
   * @param {number|string} controller The MIDI controller name or number (`0` - `127`).
   *
   * @param {number|number[]} value The value to send (0-127). You can also use a two-position array
   * for controllers 0 to 31. In this scenario, the first value will be sent as usual and the second
   * value will be sent to the matching LSB controller (which is obtained by adding 32 to the first
   * controller)
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} Controller numbers must be between 0 and 127.
   * @throws {RangeError} Invalid controller name.
   * @throws {TypeError} The value array must have a length of 2.
   *
   * @returns {OutputChannel} Returns the `OutputChannel` object so methods can be chained.
   *
   * @license Apache-2.0
   * @since 3.0.0
   */ sendControlChange(e, t, n = {}) {
        if ("string" == typeof e && (e = Utilities.getCcNumberByName(e)), Array.isArray(t) || (t = [
            t
        ]), wm.validation) {
            if (void 0 === e) throw new TypeError("Control change must be identified with a valid name or an integer between 0 and 127.");
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new TypeError("Control change number must be an integer between 0 and 127.");
            if (2 === (t = t.map((e)=>{
                const t = Math.min(Math.max(parseInt(e), 0), 127);
                if (isNaN(t)) throw new TypeError("Values must be integers between 0 and 127");
                return t;
            })).length && e >= 32) throw new TypeError("To use a value array, the controller must be between 0 and 31");
        }
        return t.forEach((r, i)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
                e + 32 * i,
                t[i]
            ], {
                time: Utilities.toTimestamp(n.time)
            });
        }), this;
    }
    _selectNonRegisteredParameter(e, t = {}) {
        return this.sendControlChange(99, e[0], t), this.sendControlChange(98, e[1], t), this;
    }
    _deselectRegisteredParameter(e = {}) {
        return this.sendControlChange(101, 127, e), this.sendControlChange(100, 127, e), this;
    }
    _deselectNonRegisteredParameter(e = {}) {
        return this.sendControlChange(101, 127, e), this.sendControlChange(100, 127, e), this;
    }
    _selectRegisteredParameter(e, t = {}) {
        return this.sendControlChange(101, e[0], t), this.sendControlChange(100, e[1], t), this;
    }
    _setCurrentParameter(e, t = {}) {
        return e = [].concat(e), this.sendControlChange(6, e[0], t), e.length < 2 || this.sendControlChange(38, e[1], t), this;
    }
    sendRpnDecrement(e, t = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("The specified registered parameter is invalid.");
            let t = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n)=>{
                Enumerations.REGISTERED_PARAMETERS[n][0] === e[0] && Enumerations.REGISTERED_PARAMETERS[n][1] === e[1] && (t = !0);
            }), !t) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e, t), this.sendControlChange(97, 0, t), this._deselectRegisteredParameter(t), this;
    }
    sendRpnIncrement(e, t = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("The specified registered parameter is invalid.");
            let t = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n)=>{
                Enumerations.REGISTERED_PARAMETERS[n][0] === e[0] && Enumerations.REGISTERED_PARAMETERS[n][1] === e[1] && (t = !0);
            }), !t) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e, t), this.sendControlChange(96, 0, t), this._deselectRegisteredParameter(t), this;
    }
    playNote(e, t = {}) {
        this.sendNoteOn(e, t);
        const n = Array.isArray(e) ? e : [
            e
        ];
        for (let e of n)if (parseInt(e.duration) > 0) {
            const n = {
                time: (Utilities.toTimestamp(t.time) || wm.time) + parseInt(e.duration),
                release: e.release,
                rawRelease: e.rawRelease
            };
            this.sendNoteOff(e, n);
        } else if (parseInt(t.duration) > 0) {
            const n = {
                time: (Utilities.toTimestamp(t.time) || wm.time) + parseInt(t.duration),
                release: t.release,
                rawRelease: t.rawRelease
            };
            this.sendNoteOff(e, n);
        }
        return this;
    }
    sendNoteOff(e, t = {}) {
        if (wm.validation) {
            if (null != t.rawRelease && !(t.rawRelease >= 0 && t.rawRelease <= 127)) throw new RangeError("The 'rawRelease' option must be an integer between 0 and 127");
            if (null != t.release && !(t.release >= 0 && t.release <= 1)) throw new RangeError("The 'release' option must be an number between 0 and 1");
            t.rawVelocity && (t.rawRelease = t.velocity, console.warn("The 'rawVelocity' option is deprecated. Use 'rawRelease' instead.")), t.velocity && (t.release = t.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n = 64;
        null != t.rawRelease ? n = t.rawRelease : isNaN(t.release) || (n = Math.round(127 * t.release));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e, {
            rawRelease: parseInt(n)
        }).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteoff << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                e.rawRelease
            ], {
                time: Utilities.toTimestamp(t.time)
            });
        }), this;
    }
    stopNote(e, t = {}) {
        return this.sendNoteOff(e, t);
    }
    sendNoteOn(e, t = {}) {
        if (wm.validation) {
            if (null != t.rawAttack && !(t.rawAttack >= 0 && t.rawAttack <= 127)) throw new RangeError("The 'rawAttack' option must be an integer between 0 and 127");
            if (null != t.attack && !(t.attack >= 0 && t.attack <= 1)) throw new RangeError("The 'attack' option must be an number between 0 and 1");
            t.rawVelocity && (t.rawAttack = t.velocity, t.rawRelease = t.release, console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' or 'rawRelease'.")), t.velocity && (t.attack = t.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n = 64;
        null != t.rawAttack ? n = t.rawAttack : isNaN(t.attack) || (n = Math.round(127 * t.attack));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e, {
            rawAttack: n
        }).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteon << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                e.rawAttack
            ], {
                time: Utilities.toTimestamp(t.time)
            });
        }), this;
    }
    sendChannelMode(e, t = 0, n = {}) {
        if ("string" == typeof e && (e = Enumerations.CHANNEL_MODE_MESSAGES[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("Invalid channel mode message name or number.");
            if (isNaN(e) || !(e >= 120 && e <= 127)) throw new TypeError("Invalid channel mode message number.");
            if (isNaN(parseInt(t)) || t < 0 || t > 127) throw new RangeError("Value must be an integer between 0 and 127.");
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
            e,
            t
        ], {
            time: Utilities.toTimestamp(n.time)
        }), this;
    }
    sendOmniMode(e, t = {}) {
        return void 0 === e || e ? this.sendChannelMode("omnimodeon", 0, t) : this.sendChannelMode("omnimodeoff", 0, t), this;
    }
    sendChannelAftertouch(e, t = {}) {
        if (wm.validation) {
            if (isNaN(parseFloat(e))) throw new RangeError("Invalid channel aftertouch value.");
            if (t.rawValue) {
                if (!(e >= 0 && e <= 127 && Number.isInteger(e))) throw new RangeError("Channel aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(e >= 0 && e <= 1)) throw new RangeError("Channel aftertouch value must be a float between 0 and 1.");
        }
        return t.rawValue || (e = Utilities.fromFloatTo7Bit(e)), this.send([
            (Enumerations.CHANNEL_MESSAGES.channelaftertouch << 4) + (this.number - 1),
            Math.round(e)
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendMasterTuning(e, t = {}) {
        if (e = parseFloat(e) || 0, wm.validation && !(e > -65 && e < 64)) throw new RangeError("The value must be a decimal number larger than -65 and smaller than 64.");
        let n = Math.floor(e) + 64, r = e - Math.floor(e);
        r = Math.round((r + 1) / 2 * 16383);
        let i = r >> 7 & 127, s = 127 & r;
        return this.sendRpnValue("channelcoarsetuning", n, t), this.sendRpnValue("channelfinetuning", [
            i,
            s
        ], t), this;
    }
    sendModulationRange(e, t, n = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!(null == t || Number.isInteger(t) && t >= 0 && t <= 127)) throw new RangeError("If specified, the cents value must be an integer between 0 and 127.");
        }
        return t >= 0 && t <= 127 || (t = 0), this.sendRpnValue("modulationrange", [
            e,
            t
        ], n), this;
    }
    sendNrpnValue(e, t, n = {}) {
        if (t = [].concat(t), wm.validation) {
            if (!Array.isArray(e) || !Number.isInteger(e[0]) || !Number.isInteger(e[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The first byte of the NRPN must be between 0 and 127.");
            if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The second byte of the NRPN must be between 0 and 127.");
            t.forEach((e)=>{
                if (!(e >= 0 && e <= 127)) throw new RangeError("The data bytes of the NRPN must be between 0 and 127.");
            });
        }
        return this._selectNonRegisteredParameter(e, n), this._setCurrentParameter(t, n), this._deselectNonRegisteredParameter(n), this;
    }
    sendPitchBend(e, t = {}) {
        if (wm.validation) {
            if (t.rawValue && Array.isArray(e)) {
                if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
                if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The pitch bend LSB must be an integer between 0 and 127.");
            } else if (t.rawValue && !Array.isArray(e)) {
                if (!(e >= 0 && e <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
            } else {
                if (isNaN(e) || null === e) throw new RangeError("Invalid pitch bend value.");
                if (!(e >= -1 && e <= 1)) throw new RangeError("The pitch bend value must be a float between -1 and 1.");
            }
        }
        let n = 0, r = 0;
        if (t.rawValue && Array.isArray(e)) n = e[0], r = e[1];
        else if (t.rawValue && !Array.isArray(e)) n = e;
        else {
            const t = Utilities.fromFloatToMsbLsb((e + 1) / 2);
            n = t.msb, r = t.lsb;
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.pitchbend << 4) + (this.number - 1),
            r,
            n
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendPitchBendRange(e, t, n = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!Number.isInteger(t) || !(t >= 0 && t <= 127)) throw new RangeError("The cents value must be an integer between 0 and 127.");
        }
        return this.sendRpnValue("pitchbendrange", [
            e,
            t
        ], n), this;
    }
    sendProgramChange(e, t = {}) {
        if (e = parseInt(e) || 0, wm.validation && !(e >= 0 && e <= 127)) throw new RangeError("The program number must be between 0 and 127.");
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.programchange << 4) + (this.number - 1),
            e
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendRpnValue(e, t, n = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (!Number.isInteger(e[0]) || !Number.isInteger(e[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The first byte of the RPN must be between 0 and 127.");
            if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The second byte of the RPN must be between 0 and 127.");
            [].concat(t).forEach((e)=>{
                if (!(e >= 0 && e <= 127)) throw new RangeError("The data bytes of the RPN must be between 0 and 127.");
            });
        }
        return this._selectRegisteredParameter(e, n), this._setCurrentParameter(t, n), this._deselectRegisteredParameter(n), this;
    }
    sendTuningBank(e, t = {}) {
        if (wm.validation && (!Number.isInteger(e) || !(e >= 0 && e <= 127))) throw new RangeError("The tuning bank number must be between 0 and 127.");
        return this.sendRpnValue("tuningbank", e, t), this;
    }
    sendTuningProgram(e, t = {}) {
        if (wm.validation && (!Number.isInteger(e) || !(e >= 0 && e <= 127))) throw new RangeError("The tuning program number must be between 0 and 127.");
        return this.sendRpnValue("tuningprogram", e, t), this;
    }
    sendLocalControl(e, t = {}) {
        return e ? this.sendChannelMode("localcontrol", 127, t) : this.sendChannelMode("localcontrol", 0, t);
    }
    sendAllNotesOff(e = {}) {
        return this.sendChannelMode("allnotesoff", 0, e);
    }
    sendAllSoundOff(e = {}) {
        return this.sendChannelMode("allsoundoff", 0, e);
    }
    sendResetAllControllers(e = {}) {
        return this.sendChannelMode("resetallcontrollers", 0, e);
    }
    sendPolyphonicMode(e, t = {}) {
        return "mono" === e ? this.sendChannelMode("monomodeon", 0, t) : this.sendChannelMode("polymodeon", 0, t);
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get output() {
        return this._output;
    }
    get number() {
        return this._number;
    }
}
/**
 * The `Output` class represents a single MIDI output port (not to be confused with a MIDI channel).
 * A port is made available by a MIDI device. A MIDI device can advertise several input and output
 * ports. Each port has 16 MIDI channels which can be accessed via the [`channels`](#channels)
 * property.
 *
 * The `Output` object is automatically instantiated by the library according to the host's MIDI
 * subsystem and should not be directly instantiated.
 *
 * You can access all available `Output` objects by referring to the
 * [`WebMidi.outputs`](WebMidi#outputs) array or by using methods such as
 * [`WebMidi.getOutputByName()`](WebMidi#getOutputByName) or
 * [`WebMidi.getOutputById()`](WebMidi#getOutputById).
 *
 * @fires Output#opened
 * @fires Output#disconnected
 * @fires Output#closed
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Output extends EventEmitter {
    constructor(e){
        super(), this._midiOutput = e, this._octaveOffset = 0, this.channels = [];
        for(let e = 1; e <= 16; e++)this.channels[e] = new OutputChannel(this, e);
        this._midiOutput.onstatechange = this._onStateChange.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e)=>e.destroy()), this.channels = [], this._midiOutput && (this._midiOutput.onstatechange = null), await this.close(), this._midiOutput = null;
    }
    _onStateChange(e) {
        let t = {
            timestamp: wm.time
        };
        "open" === e.port.connection ? (t.type = "opened", t.target = this, t.port = t.target, this.emit("opened", t)) : "closed" === e.port.connection && "connected" === e.port.state ? (t.type = "closed", t.target = this, t.port = t.target, this.emit("closed", t)) : "closed" === e.port.connection && "disconnected" === e.port.state ? (t.type = "disconnected", t.port = {
            connection: e.port.connection,
            id: e.port.id,
            manufacturer: e.port.manufacturer,
            name: e.port.name,
            state: e.port.state,
            type: e.port.type
        }, this.emit("disconnected", t)) : "pending" === e.port.connection && "disconnected" === e.port.state || console.warn("This statechange event was not caught:", e.port.connection, e.port.state);
    }
    async open() {
        try {
            return await this._midiOutput.open(), Promise.resolve(this);
        } catch (e) {
            return Promise.reject(e);
        }
    }
    async close() {
        this._midiOutput ? await this._midiOutput.close() : await Promise.resolve();
    }
    /**
   * Sends a MIDI message on the MIDI output port. If no time is specified, the message will be
   * sent immediately. The message should be an array of 8 bit unsigned integers (0-225), a
   * [`Uint8Array`]{@link https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array}
   * object or a [`Message`](Message) object.
   *
   * It is usually not necessary to use this method directly as you can use one of the simpler
   * helper methods such as [`playNote()`](#playNote), [`stopNote()`](#stopNote),
   * [`sendControlChange()`](#sendControlChange), etc.
   *
   * Details on the format of MIDI messages are available in the summary of
   * [MIDI messages]{@link https://www.midi.org/specifications-old/item/table-1-summary-of-midi-message}
   * from the MIDI Manufacturers Association.
   *
   * @param message {number[]|Uint8Array|Message} An array of 8bit unsigned integers, a `Uint8Array`
   * object (not available in Node.js) containing the message bytes or a `Message` object.
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} The first byte (status) must be an integer between 128 and 255.
   *
   * @returns {Output} Returns the `Output` object so methods can be chained.
   *
   * @license Apache-2.0
   */ send(e, t = {
        time: 0
    }, n = 0) {
        if (e instanceof Message && (e = Utilities.isNode ? e.data : e.rawData), e instanceof Uint8Array && Utilities.isNode && (e = Array.from(e)), wm.validation) {
            if (Array.isArray(e) || e instanceof Uint8Array || (e = [
                e
            ], Array.isArray(t) && (e = e.concat(t)), t = isNaN(n) ? {
                time: 0
            } : {
                time: n
            }), !(parseInt(e[0]) >= 128 && parseInt(e[0]) <= 255)) throw new RangeError("The first byte (status) must be an integer between 128 and 255.");
            e.slice(1).forEach((e)=>{
                if (!((e = parseInt(e)) >= 0 && e <= 255)) throw new RangeError("Data bytes must be integers between 0 and 255.");
            }), t || (t = {
                time: 0
            });
        }
        return this._midiOutput.send(e, Utilities.toTimestamp(t.time)), this;
    }
    sendSysex(e, t = [], n = {}) {
        if (e = [].concat(e), t instanceof Uint8Array) {
            const r = new Uint8Array(1 + e.length + t.length + 1);
            r[0] = Enumerations.SYSTEM_MESSAGES.sysex, r.set(Uint8Array.from(e), 1), r.set(t, 1 + e.length), r[r.length - 1] = Enumerations.SYSTEM_MESSAGES.sysexend, this.send(r, {
                time: n.time
            });
        } else {
            const r = e.concat(t, Enumerations.SYSTEM_MESSAGES.sysexend);
            this.send([
                Enumerations.SYSTEM_MESSAGES.sysex
            ].concat(r), {
                time: n.time
            });
        }
        return this;
    }
    clear() {
        return this._midiOutput.clear ? this._midiOutput.clear() : wm.validation && console.warn("The 'clear()' method has not yet been implemented in your environment."), this;
    }
    sendTimecodeQuarterFrame(e, t = {}) {
        if (wm.validation && (e = parseInt(e), isNaN(e) || !(e >= 0 && e <= 127))) throw new RangeError("The value must be an integer between 0 and 127.");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.timecode,
            e
        ], {
            time: t.time
        }), this;
    }
    sendSongPosition(e = 0, t = {}) {
        var n = (e = Math.floor(e) || 0) >> 7 & 127, r = 127 & e;
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songposition,
            n,
            r
        ], {
            time: t.time
        }), this;
    }
    sendSongSelect(e = 0, t = {}) {
        if (wm.validation && (e = parseInt(e), isNaN(e) || !(e >= 0 && e <= 127))) throw new RangeError("The program value must be between 0 and 127");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songselect,
            e
        ], {
            time: t.time
        }), this;
    }
    sendTuneRequest(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.tunerequest
        ], {
            time: e.time
        }), this;
    }
    sendClock(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.clock
        ], {
            time: e.time
        }), this;
    }
    sendStart(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.start
        ], {
            time: e.time
        }), this;
    }
    sendContinue(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.continue
        ], {
            time: e.time
        }), this;
    }
    sendStop(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.stop
        ], {
            time: e.time
        }), this;
    }
    sendActiveSensing(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.activesensing
        ], {
            time: e.time
        }), this;
    }
    sendReset(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.reset
        ], {
            time: e.time
        }), this;
    }
    sendTuningRequest(e = {}) {
        return wm.validation && console.warn("The sendTuningRequest() method has been deprecated. Use sendTuningRequest() instead."), this.sendTuneRequest(e);
    }
    sendKeyAftertouch(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendKeyAftertouch(e, t, n);
        }), this;
    }
    sendControlChange(e, t, n = {}, r = {}) {
        if (wm.validation && (Array.isArray(n) || Number.isInteger(n) || "all" === n)) {
            const e = n;
            (n = r).channels = e, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendControlChange(e, t, n);
        }), this;
    }
    sendPitchBendRange(e = 0, t = 0, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendPitchBendRange(e, t, n);
        }), this;
    }
    setPitchBendRange(e = 0, t = 0, n = "all", r = {}) {
        return wm.validation && (console.warn("The setPitchBendRange() method is deprecated. Use sendPitchBendRange() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendPitchBendRange(e, t, r);
    }
    sendRpnValue(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendRpnValue(e, t, n);
        }), this;
    }
    setRegisteredParameter(e, t = [], n = "all", r = {}) {
        return wm.validation && (console.warn("The setRegisteredParameter() method is deprecated. Use sendRpnValue() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnValue(e, t, r);
    }
    sendChannelAftertouch(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendChannelAftertouch(e, t);
        }), this;
    }
    sendPitchBend(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendPitchBend(e, t);
        }), this;
    }
    sendProgramChange(e = 0, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendProgramChange(e, t);
        }), this;
    }
    sendModulationRange(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendModulationRange(e, t, n);
        }), this;
    }
    setModulationRange(e = 0, t = 0, n = "all", r = {}) {
        return wm.validation && (console.warn("The setModulationRange() method is deprecated. Use sendModulationRange() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendModulationRange(e, t, r);
    }
    sendMasterTuning(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendMasterTuning(e, t);
        }), this;
    }
    setMasterTuning(e, t = {}, n = {}) {
        return wm.validation && (console.warn("The setMasterTuning() method is deprecated. Use sendMasterTuning() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendMasterTuning(e, n);
    }
    sendTuningProgram(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendTuningProgram(e, t);
        }), this;
    }
    setTuningProgram(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The setTuningProgram() method is deprecated. Use sendTuningProgram() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningProgram(e, n);
    }
    sendTuningBank(e = 0, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendTuningBank(e, t);
        }), this;
    }
    setTuningBank(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The setTuningBank() method is deprecated. Use sendTuningBank() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningBank(e, n);
    }
    sendChannelMode(e, t = 0, n = {}, r = {}) {
        if (wm.validation && (Array.isArray(n) || Number.isInteger(n) || "all" === n)) {
            const e = n;
            (n = r).channels = e, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendChannelMode(e, t, n);
        }), this;
    }
    sendAllSoundOff(e = {}) {
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendAllSoundOff(e);
        }), this;
    }
    sendAllNotesOff(e = {}) {
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendAllNotesOff(e);
        }), this;
    }
    sendResetAllControllers(e = {}, t = {}) {
        if (wm.validation && (Array.isArray(e) || Number.isInteger(e) || "all" === e)) {
            const n = e;
            (e = t).channels = n, "all" === e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendResetAllControllers(e);
        }), this;
    }
    sendPolyphonicMode(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendPolyphonicMode(e, t);
        }), this;
    }
    sendLocalControl(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendLocalControl(e, t);
        }), this;
    }
    sendOmniMode(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendOmniMode(e, t);
        }), this;
    }
    sendNrpnValue(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendNrpnValue(e, t, n);
        }), this;
    }
    setNonRegisteredParameter(e, t = [], n = "all", r = {}) {
        return wm.validation && (console.warn("The setNonRegisteredParameter() method is deprecated. Use sendNrpnValue() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendNrpnValue(e, t, r);
    }
    sendRpnIncrement(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendRpnIncrement(e, t);
        }), this;
    }
    incrementRegisteredParameter(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The incrementRegisteredParameter() method is deprecated. Use sendRpnIncrement() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnIncrement(e, n);
    }
    sendRpnDecrement(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendRpnDecrement(e, t);
        }), this;
    }
    decrementRegisteredParameter(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The decrementRegisteredParameter() method is deprecated. Use sendRpnDecrement() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnDecrement(e, n);
    }
    sendNoteOff(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendNoteOff(e, t);
        }), this;
    }
    stopNote(e, t) {
        return this.sendNoteOff(e, t);
    }
    playNote(e, t = {}, n = {}) {
        if (wm.validation && (t.rawVelocity && console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' instead."), t.velocity && console.warn("The 'velocity' option is deprecated. Use 'velocity' instead."), Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].playNote(e, t);
        }), this;
    }
    sendNoteOn(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendNoteOn(e, t);
        }), this;
    }
    get name() {
        return this._midiOutput.name;
    }
    get id() {
        return this._midiOutput.id;
    }
    get connection() {
        return this._midiOutput.connection;
    }
    get manufacturer() {
        return this._midiOutput.manufacturer;
    }
    get state() {
        return this._midiOutput.state;
    }
    get type() {
        return this._midiOutput.type;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
}
/**
 * The `Forwarder` class allows the forwarding of MIDI messages to predetermined outputs. When you
 * call its [`forward()`](#forward) method, it will send the specified [`Message`](Message) object
 * to all the outputs listed in its [`destinations`](#destinations) property.
 *
 * If specific channels or message types have been defined in the [`channels`](#channels) or
 * [`types`](#types) properties, only messages matching the channels/types will be forwarded.
 *
 * While it can be manually instantiated, you are more likely to come across a `Forwarder` object as
 * the return value of the [`Input.addForwarder()`](Input#addForwarder) method.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Forwarder {
    constructor(e = [], t = {}){
        this.destinations = [], this.types = [
            ...Object.keys(Enumerations.SYSTEM_MESSAGES),
            ...Object.keys(Enumerations.CHANNEL_MESSAGES)
        ], this.channels = Enumerations.MIDI_CHANNEL_NUMBERS, this.suspended = !1, Array.isArray(e) || (e = [
            e
        ]), t.types && !Array.isArray(t.types) && (t.types = [
            t.types
        ]), t.channels && !Array.isArray(t.channels) && (t.channels = [
            t.channels
        ]), wm.validation && (e.forEach((e)=>{
            if (!(e instanceof Output)) throw new TypeError("Destinations must be of type 'Output'.");
        }), void 0 !== t.types && t.types.forEach((e)=>{
            if (!Enumerations.SYSTEM_MESSAGES.hasOwnProperty(e) && !Enumerations.CHANNEL_MESSAGES.hasOwnProperty(e)) throw new TypeError("Type must be a valid message type.");
        }), void 0 !== t.channels && t.channels.forEach((e)=>{
            if (!Enumerations.MIDI_CHANNEL_NUMBERS.includes(e)) throw new TypeError("MIDI channel must be between 1 and 16.");
        })), this.destinations = e, t.types && (this.types = t.types), t.channels && (this.channels = t.channels);
    }
    forward(e) {
        this.suspended || this.types.includes(e.type) && (e.channel && !this.channels.includes(e.channel) || this.destinations.forEach((t)=>{
            (!wm.validation || t instanceof Output) && t.send(e);
        }));
    }
}
/**
 * The `InputChannel` class represents a single MIDI input channel (1-16) from a single input
 * device. This object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `InputChannel` objects can be found inside the input's [`channels`](Input#channels)
 * property.
 *
 * @fires InputChannel#midimessage
 * @fires InputChannel#unknownmessage
 *
 * @fires InputChannel#noteoff
 * @fires InputChannel#noteon
 * @fires InputChannel#keyaftertouch
 * @fires InputChannel#programchange
 * @fires InputChannel#channelaftertouch
 * @fires InputChannel#pitchbend
 *
 * @fires InputChannel#allnotesoff
 * @fires InputChannel#allsoundoff
 * @fires InputChannel#localcontrol
 * @fires InputChannel#monomode
 * @fires InputChannel#omnimode
 * @fires InputChannel#resetallcontrollers
 *
 * @fires InputChannel#event:nrpn
 * @fires InputChannel#event:nrpn-dataentrycoarse
 * @fires InputChannel#event:nrpn-dataentryfine
 * @fires InputChannel#event:nrpn-dataincrement
 * @fires InputChannel#event:nrpn-datadecrement
 * @fires InputChannel#event:rpn
 * @fires InputChannel#event:rpn-dataentrycoarse
 * @fires InputChannel#event:rpn-dataentryfine
 * @fires InputChannel#event:rpn-dataincrement
 * @fires InputChannel#event:rpn-datadecrement
 *
 * @fires InputChannel#controlchange
 * @fires InputChannel#event:controlchange-controllerxxx
 * @fires InputChannel#event:controlchange-bankselectcoarse
 * @fires InputChannel#event:controlchange-modulationwheelcoarse
 * @fires InputChannel#event:controlchange-breathcontrollercoarse
 * @fires InputChannel#event:controlchange-footcontrollercoarse
 * @fires InputChannel#event:controlchange-portamentotimecoarse
 * @fires InputChannel#event:controlchange-dataentrycoarse
 * @fires InputChannel#event:controlchange-volumecoarse
 * @fires InputChannel#event:controlchange-balancecoarse
 * @fires InputChannel#event:controlchange-pancoarse
 * @fires InputChannel#event:controlchange-expressioncoarse
 * @fires InputChannel#event:controlchange-effectcontrol1coarse
 * @fires InputChannel#event:controlchange-effectcontrol2coarse
 * @fires InputChannel#event:controlchange-generalpurposecontroller1
 * @fires InputChannel#event:controlchange-generalpurposecontroller2
 * @fires InputChannel#event:controlchange-generalpurposecontroller3
 * @fires InputChannel#event:controlchange-generalpurposecontroller4
 * @fires InputChannel#event:controlchange-bankselectfine
 * @fires InputChannel#event:controlchange-modulationwheelfine
 * @fires InputChannel#event:controlchange-breathcontrollerfine
 * @fires InputChannel#event:controlchange-footcontrollerfine
 * @fires InputChannel#event:controlchange-portamentotimefine
 * @fires InputChannel#event:controlchange-dataentryfine
 * @fires InputChannel#event:controlchange-channelvolumefine
 * @fires InputChannel#event:controlchange-balancefine
 * @fires InputChannel#event:controlchange-panfine
 * @fires InputChannel#event:controlchange-expressionfine
 * @fires InputChannel#event:controlchange-effectcontrol1fine
 * @fires InputChannel#event:controlchange-effectcontrol2fine
 * @fires InputChannel#event:controlchange-damperpedal
 * @fires InputChannel#event:controlchange-portamento
 * @fires InputChannel#event:controlchange-sostenuto
 * @fires InputChannel#event:controlchange-softpedal
 * @fires InputChannel#event:controlchange-legatopedal
 * @fires InputChannel#event:controlchange-hold2
 * @fires InputChannel#event:controlchange-soundvariation
 * @fires InputChannel#event:controlchange-resonance
 * @fires InputChannel#event:controlchange-releasetime
 * @fires InputChannel#event:controlchange-attacktime
 * @fires InputChannel#event:controlchange-brightness
 * @fires InputChannel#event:controlchange-decaytime
 * @fires InputChannel#event:controlchange-vibratorate
 * @fires InputChannel#event:controlchange-vibratodepth
 * @fires InputChannel#event:controlchange-vibratodelay
 * @fires InputChannel#event:controlchange-generalpurposecontroller5
 * @fires InputChannel#event:controlchange-generalpurposecontroller6
 * @fires InputChannel#event:controlchange-generalpurposecontroller7
 * @fires InputChannel#event:controlchange-generalpurposecontroller8
 * @fires InputChannel#event:controlchange-portamentocontrol
 * @fires InputChannel#event:controlchange-highresolutionvelocityprefix
 * @fires InputChannel#event:controlchange-effect1depth
 * @fires InputChannel#event:controlchange-effect2depth
 * @fires InputChannel#event:controlchange-effect3depth
 * @fires InputChannel#event:controlchange-effect4depth
 * @fires InputChannel#event:controlchange-effect5depth
 * @fires InputChannel#event:controlchange-dataincrement
 * @fires InputChannel#event:controlchange-datadecrement
 * @fires InputChannel#event:controlchange-nonregisteredparameterfine
 * @fires InputChannel#event:controlchange-nonregisteredparametercoarse
 * @fires InputChannel#event:controlchange-registeredparameterfine
 * @fires InputChannel#event:controlchange-registeredparametercoarse
 * @fires InputChannel#event:controlchange-allsoundoff
 * @fires InputChannel#event:controlchange-resetallcontrollers
 * @fires InputChannel#event:controlchange-localcontrol
 * @fires InputChannel#event:controlchange-allnotesoff
 * @fires InputChannel#event:controlchange-omnimodeoff
 * @fires InputChannel#event:controlchange-omnimodeon
 * @fires InputChannel#event:controlchange-monomodeon
 * @fires InputChannel#event:controlchange-polymodeon
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class InputChannel extends EventEmitter {
    constructor(e, t){
        super(), this._input = e, this._number = t, this._octaveOffset = 0, this._nrpnBuffer = [], this._rpnBuffer = [], this.parameterNumberEventsEnabled = !0, this.notesState = new Array(128).fill(!1);
    }
    destroy() {
        this._input = null, this._number = null, this._octaveOffset = 0, this._nrpnBuffer = [], this.notesState = new Array(128).fill(!1), this.parameterNumberEventsEnabled = !1, this.removeListener();
    }
    _processMidiMessageEvent(e) {
        const t = Object.assign({}, e);
        t.port = this.input, t.target = this, t.type = "midimessage", this.emit(t.type, t), this._parseEventForStandardMessages(t);
    }
    _parseEventForStandardMessages(e) {
        const t = Object.assign({}, e);
        t.type = t.message.type || "unknownmessage";
        const n = e.message.dataBytes[0], r = e.message.dataBytes[1];
        if ("noteoff" === t.type || "noteon" === t.type && 0 === r) this.notesState[n] = !1, t.type = "noteoff", t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: 0,
            rawRelease: r
        }), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.velocity = t.note.release, t.rawVelocity = t.note.rawRelease;
        else if ("noteon" === t.type) this.notesState[n] = !0, t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: r
        }), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.velocity = t.note.attack, t.rawVelocity = t.note.rawAttack;
        else if ("keyaftertouch" === t.type) t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset)), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.identifier = t.note.identifier, t.key = t.note.number, t.rawKey = n;
        else if ("controlchange" === t.type) {
            t.controller = {
                number: n,
                name: Enumerations.CONTROL_CHANGE_MESSAGES[n].name,
                description: Enumerations.CONTROL_CHANGE_MESSAGES[n].description,
                position: Enumerations.CONTROL_CHANGE_MESSAGES[n].position
            }, t.subtype = t.controller.name || "controller" + n, t.value = Utilities.from7bitToFloat(r), t.rawValue = r;
            const e = Object.assign({}, t);
            e.type = `${t.type}-controller${n}`, delete e.subtype, this.emit(e.type, e);
            const i = Object.assign({}, t);
            i.type = `${t.type}-` + Enumerations.CONTROL_CHANGE_MESSAGES[n].name, delete i.subtype, 0 !== i.type.indexOf("controller") && this.emit(i.type, i), t.message.dataBytes[0] >= 120 && this._parseChannelModeMessage(t), this.parameterNumberEventsEnabled && this._isRpnOrNrpnController(t.message.dataBytes[0]) && this._parseEventForParameterNumber(t);
        } else "programchange" === t.type ? (t.value = n, t.rawValue = t.value) : "channelaftertouch" === t.type ? (t.value = Utilities.from7bitToFloat(n), t.rawValue = n) : "pitchbend" === t.type ? (t.value = ((r << 7) + n - 8192) / 8192, t.rawValue = (r << 7) + n) : t.type = "unknownmessage";
        this.emit(t.type, t);
    }
    _parseChannelModeMessage(e) {
        const t = Object.assign({}, e);
        t.type = t.controller.name, "localcontrol" === t.type && (t.value = 127 === t.message.data[2], t.rawValue = t.message.data[2]), "omnimodeon" === t.type ? (t.type = "omnimode", t.value = !0, t.rawValue = t.message.data[2]) : "omnimodeoff" === t.type && (t.type = "omnimode", t.value = !1, t.rawValue = t.message.data[2]), "monomodeon" === t.type ? (t.type = "monomode", t.value = !0, t.rawValue = t.message.data[2]) : "polymodeon" === t.type && (t.type = "monomode", t.value = !1, t.rawValue = t.message.data[2]), this.emit(t.type, t);
    }
    _parseEventForParameterNumber(e) {
        const t = e.message.dataBytes[0], n = e.message.dataBytes[1];
        99 === t || 101 === t ? (this._nrpnBuffer = [], this._rpnBuffer = [], 99 === t ? this._nrpnBuffer = [
            e.message
        ] : 127 !== n && (this._rpnBuffer = [
            e.message
        ])) : 98 === t || 100 === t ? 98 === t ? (this._rpnBuffer = [], 1 === this._nrpnBuffer.length ? this._nrpnBuffer.push(e.message) : this._nrpnBuffer = []) : (this._nrpnBuffer = [], 1 === this._rpnBuffer.length && 127 !== n ? this._rpnBuffer.push(e.message) : this._rpnBuffer = []) : 6 !== t && 38 !== t && 96 !== t && 97 !== t || (2 === this._rpnBuffer.length ? this._dispatchParameterNumberEvent("rpn", this._rpnBuffer[0].dataBytes[1], this._rpnBuffer[1].dataBytes[1], e) : 2 === this._nrpnBuffer.length ? this._dispatchParameterNumberEvent("nrpn", this._nrpnBuffer[0].dataBytes[1], this._nrpnBuffer[1].dataBytes[1], e) : (this._nrpnBuffer = [], this._rpnBuffer = []));
    }
    _isRpnOrNrpnController(e) {
        return 6 === e || 38 === e || 96 === e || 97 === e || 98 === e || 99 === e || 100 === e || 101 === e;
    }
    _dispatchParameterNumberEvent(e, t, n, r) {
        e = "nrpn" === e ? "nrpn" : "rpn";
        const i = {
            target: r.target,
            timestamp: r.timestamp,
            message: r.message,
            parameterMsb: t,
            parameterLsb: n,
            value: Utilities.from7bitToFloat(r.message.dataBytes[1]),
            rawValue: r.message.dataBytes[1]
        };
        i.parameter = "rpn" === e ? Object.keys(Enumerations.REGISTERED_PARAMETERS).find((e)=>Enumerations.REGISTERED_PARAMETERS[e][0] === t && Enumerations.REGISTERED_PARAMETERS[e][1] === n) : (t << 7) + n;
        const s = Enumerations.CONTROL_CHANGE_MESSAGES[r.message.dataBytes[0]].name;
        i.type = `${e}-${s}`, this.emit(i.type, i);
        const a = Object.assign({}, i);
        "nrpn-dataincrement" === a.type ? a.type = "nrpn-databuttonincrement" : "nrpn-datadecrement" === a.type ? a.type = "nrpn-databuttondecrement" : "rpn-dataincrement" === a.type ? a.type = "rpn-databuttonincrement" : "rpn-datadecrement" === a.type && (a.type = "rpn-databuttondecrement"), this.emit(a.type, a), i.type = e, i.subtype = s, this.emit(i.type, i);
    }
    getChannelModeByNumber(e) {
        return wm.validation && (console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class."), e = Math.floor(e)), Utilities.getChannelModeByNumber(e);
    }
    getCcNameByNumber(e) {
        if (wm.validation && (console.warn("The 'getCcNameByNumber()' method has been moved to the 'Utilities' class."), !((e = parseInt(e)) >= 0 && e <= 127))) throw new RangeError("Invalid control change number.");
        return Utilities.getCcNameByNumber(e);
    }
    getNoteState(e) {
        e instanceof Note && (e = e.identifier);
        const t = Utilities.guessNoteNumber(e, wm.octaveOffset + this.input.octaveOffset + this.octaveOffset);
        return this.notesState[t];
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get input() {
        return this._input;
    }
    get number() {
        return this._number;
    }
    get nrpnEventsEnabled() {
        return this.parameterNumberEventsEnabled;
    }
    set nrpnEventsEnabled(e) {
        this.validation && (e = !!e), this.parameterNumberEventsEnabled = e;
    }
}
/**
 * The `Message` class represents a single MIDI message. It has several properties that make it
 * easy to make sense of the binary data it contains.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Message {
    constructor(e){
        this.rawData = e, this.data = Array.from(this.rawData), this.statusByte = this.rawData[0], this.rawDataBytes = this.rawData.slice(1), this.dataBytes = this.data.slice(1), this.isChannelMessage = !1, this.isSystemMessage = !1, this.command = void 0, this.channel = void 0, this.manufacturerId = void 0, this.type = void 0, this.statusByte < 240 ? (this.isChannelMessage = !0, this.command = this.statusByte >> 4, this.channel = 1 + (15 & this.statusByte)) : (this.isSystemMessage = !0, this.command = this.statusByte), this.isChannelMessage ? this.type = Utilities.getPropertyByValue(Enumerations.CHANNEL_MESSAGES, this.command) : this.isSystemMessage && (this.type = Utilities.getPropertyByValue(Enumerations.SYSTEM_MESSAGES, this.command)), this.statusByte === Enumerations.SYSTEM_MESSAGES.sysex && (0 === this.dataBytes[0] ? (this.manufacturerId = this.dataBytes.slice(0, 3), this.dataBytes = this.dataBytes.slice(3, this.rawDataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(3, this.rawDataBytes.length - 1)) : (this.manufacturerId = [
            this.dataBytes[0]
        ], this.dataBytes = this.dataBytes.slice(1, this.dataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(1, this.rawDataBytes.length - 1)));
    }
}
/**
 * The `Input` class represents a single MIDI input port. This object is automatically instantiated
 * by the library according to the host's MIDI subsystem and does not need to be directly
 * instantiated. Instead, you can access all `Input` objects by referring to the
 * [`WebMidi.inputs`](WebMidi#inputs) array. You can also retrieve inputs by using methods such as
 * [`WebMidi.getInputByName()`](WebMidi#getInputByName) and
 * [`WebMidi.getInputById()`](WebMidi#getInputById).
 *
 * Note that a single MIDI device may expose several inputs and/or outputs.
 *
 * **Important**: the `Input` class does not directly fire channel-specific MIDI messages
 * (such as [`noteon`](InputChannel#event-noteon) or
 * [`controlchange`](InputChannel#event-controlchange), etc.). The [`InputChannel`](InputChannel)
 * object does that. However, you can still use the
 * [`Input.addListener()`](#addListener) method to listen to channel-specific events on multiple
 * [`InputChannel`](InputChannel) objects at once.
 *
 * @fires Input#opened
 * @fires Input#disconnected
 * @fires Input#closed
 * @fires Input#midimessage
 *
 * @fires Input#sysex
 * @fires Input#timecode
 * @fires Input#songposition
 * @fires Input#songselect
 * @fires Input#tunerequest
 * @fires Input#clock
 * @fires Input#start
 * @fires Input#continue
 * @fires Input#stop
 * @fires Input#activesensing
 * @fires Input#reset
 *
 * @fires Input#unknownmessage
 * @fires Input#unknownmidimessage
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Input extends EventEmitter {
    constructor(e){
        super(), this._midiInput = e, this._octaveOffset = 0, this.channels = [];
        for(let e = 1; e <= 16; e++)this.channels[e] = new InputChannel(this, e);
        this._forwarders = [], this._midiInput.onstatechange = this._onStateChange.bind(this), this._midiInput.onmidimessage = this._onMidiMessage.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e)=>e.destroy()), this.channels = [], this._forwarders = [], this._midiInput && (this._midiInput.onstatechange = null, this._midiInput.onmidimessage = null), await this.close(), this._midiInput = null;
    }
    _onStateChange(e) {
        let t = {
            timestamp: wm.time,
            target: this,
            port: this
        };
        "open" === e.port.connection ? (t.type = "opened", this.emit("opened", t)) : "closed" === e.port.connection && "connected" === e.port.state ? (t.type = "closed", this.emit("closed", t)) : "closed" === e.port.connection && "disconnected" === e.port.state ? (t.type = "disconnected", t.port = {
            connection: e.port.connection,
            id: e.port.id,
            manufacturer: e.port.manufacturer,
            name: e.port.name,
            state: e.port.state,
            type: e.port.type
        }, this.emit("disconnected", t)) : "pending" === e.port.connection && "disconnected" === e.port.state || console.warn("This statechange event was not caught: ", e.port.connection, e.port.state);
    }
    _onMidiMessage(e) {
        const t = new Message(e.data), n = {
            port: this,
            target: this,
            message: t,
            timestamp: e.timeStamp,
            type: "midimessage",
            data: t.data,
            rawData: t.data,
            statusByte: t.data[0],
            dataBytes: t.dataBytes
        };
        this.emit("midimessage", n), t.isSystemMessage ? this._parseEvent(n) : t.isChannelMessage && this.channels[t.channel]._processMidiMessageEvent(n), this._forwarders.forEach((e)=>e.forward(t));
    }
    _parseEvent(e) {
        const t = Object.assign({}, e);
        t.type = t.message.type || "unknownmessage", "songselect" === t.type && (t.song = e.data[1] + 1, t.value = e.data[1], t.rawValue = t.value), this.emit(t.type, t), "unknownmessage" === t.type && this.emit("unknownmidimessage", Object.assign({}, t, {
            type: "unknownmidimessage"
        }));
    }
    async open() {
        try {
            await this._midiInput.open();
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(this);
    }
    async close() {
        if (!this._midiInput) return Promise.resolve(this);
        try {
            await this._midiInput.close();
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(this);
    }
    getChannelModeByNumber() {
        wm.validation && console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class.");
    }
    addListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = null != t ? [].concat(t) : void 0;
            t = n, n = {
                channels: e
            };
        }
        if (Enumerations.CHANNEL_EVENTS.includes(e)) {
            void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
            let r = [];
            return Utilities.sanitizeChannels(n.channels).forEach((i)=>{
                r.push(this.channels[i].addListener(e, t, n));
            }), r;
        }
        return super.addListener(e, t, n);
    }
    addOneTimeListener(e, t, n = {}) {
        return n.remaining = 1, this.addListener(e, t, n);
    }
    on(e, t, n, r) {
        return this.addListener(e, t, n, r);
    }
    hasListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = [].concat(t);
            t = n, n = {
                channels: e
            };
        }
        return Enumerations.CHANNEL_EVENTS.includes(e) ? (void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).every((n)=>this.channels[n].hasListener(e, t))) : super.hasListener(e, t);
    }
    removeListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = [].concat(t);
            t = n, n = {
                channels: e
            };
        }
        if (void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), null == e) return Utilities.sanitizeChannels(n.channels).forEach((e)=>{
            this.channels[e] && this.channels[e].removeListener();
        }), super.removeListener();
        Enumerations.CHANNEL_EVENTS.includes(e) ? Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].removeListener(e, t, n);
        }) : super.removeListener(e, t, n);
    }
    addForwarder(e, t = {}) {
        let n;
        return n = e instanceof Forwarder ? e : new Forwarder(e, t), this._forwarders.push(n), n;
    }
    removeForwarder(e) {
        this._forwarders = this._forwarders.filter((t)=>t !== e);
    }
    hasForwarder(e) {
        return this._forwarders.includes(e);
    }
    get name() {
        return this._midiInput.name;
    }
    get id() {
        return this._midiInput.id;
    }
    get connection() {
        return this._midiInput.connection;
    }
    get manufacturer() {
        return this._midiInput.manufacturer;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get state() {
        return this._midiInput.state;
    }
    get type() {
        return this._midiInput.type;
    }
    get nrpnEventsEnabled() {
        return wm.validation && console.warn("The 'nrpnEventsEnabled' property has been moved to the 'InputChannel' class."), !1;
    }
}
if (Utilities.isNode) {
    try {
        window.navigator;
    } catch (err) {
        let jzz;
        eval('jzz = require("jzz")'), $parcel$global.navigator || ($parcel$global.navigator = {}), Object.assign($parcel$global.navigator, jzz);
    }
    try {
        performance;
    } catch (err) {
        let performance1;
        eval('performance = require("perf_hooks").performance'), $parcel$global.performance = performance1;
    }
}
/**
 * The `WebMidi` object makes it easier to work with the low-level Web MIDI API. Basically, it
 * simplifies sending outgoing MIDI messages and reacting to incoming MIDI messages.
 *
 * When using the WebMidi.js library, you should know that the `WebMidi` class has already been
 * instantiated. You cannot instantiate it yourself. If you use the **IIFE** version, you should
 * simply use the global object called `WebMidi`. If you use the **CJS** (CommonJS) or **ESM** (ES6
 * module) version, you get an already-instantiated object when you import the module.
 *
 * @fires WebMidi#connected
 * @fires WebMidi#disabled
 * @fires WebMidi#disconnected
 * @fires WebMidi#enabled
 * @fires WebMidi#error
 * @fires WebMidi#midiaccessgranted
 * @fires WebMidi#portschanged
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class WebMidi extends EventEmitter {
    constructor(){
        super(), this.defaults = {
            note: {
                attack: Utilities.from7bitToFloat(64),
                release: Utilities.from7bitToFloat(64),
                duration: 1 / 0
            }
        }, this.interface = null, this.validation = !0, this._inputs = [], this._disconnectedInputs = [], this._outputs = [], this._disconnectedOutputs = [], this._stateChangeQueue = [], this._octaveOffset = 0;
    }
    async enable(e = {}, t = !1) {
        if (this.validation = !1 !== e.validation, this.validation && ("function" == typeof e && (e = {
            callback: e,
            sysex: t
        }), t && (e.sysex = !0)), this.enabled) return "function" == typeof e.callback && e.callback(), Promise.resolve();
        const n = {
            timestamp: this.time,
            target: this,
            type: "error",
            error: void 0
        }, r = {
            timestamp: this.time,
            target: this,
            type: "midiaccessgranted"
        }, i = {
            timestamp: this.time,
            target: this,
            type: "enabled"
        };
        try {
            "function" == typeof e.requestMIDIAccessFunction ? this.interface = await e.requestMIDIAccessFunction({
                sysex: e.sysex,
                software: e.software
            }) : this.interface = await navigator.requestMIDIAccess({
                sysex: e.sysex,
                software: e.software
            });
        } catch (t) {
            return n.error = t, this.emit("error", n), "function" == typeof e.callback && e.callback(t), Promise.reject(t);
        }
        this.emit("midiaccessgranted", r), this.interface.onstatechange = this._onInterfaceStateChange.bind(this);
        try {
            await this._updateInputsAndOutputs();
        } catch (t) {
            return n.error = t, this.emit("error", n), "function" == typeof e.callback && e.callback(t), Promise.reject(t);
        }
        return this.emit("enabled", i), "function" == typeof e.callback && e.callback(), Promise.resolve(this);
    }
    async disable() {
        return this.interface && (this.interface.onstatechange = void 0), this._destroyInputsAndOutputs().then(()=>{
            navigator && "function" == typeof navigator.close && navigator.close(), this.interface = null;
            let e = {
                timestamp: this.time,
                target: this,
                type: "disabled"
            };
            this.emit("disabled", e), this.removeListener();
        });
    }
    getInputById(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedInputs.length; t++)if (this._disconnectedInputs[t]._midiInput && this._disconnectedInputs[t].id === e.toString()) return this._disconnectedInputs[t];
        } else for(let t = 0; t < this.inputs.length; t++)if (this.inputs[t]._midiInput && this.inputs[t].id === e.toString()) return this.inputs[t];
    }
    getInputByName(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
            e = e.toString();
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedInputs.length; t++)if (~this._disconnectedInputs[t].name.indexOf(e)) return this._disconnectedInputs[t];
        } else for(let t = 0; t < this.inputs.length; t++)if (~this.inputs[t].name.indexOf(e)) return this.inputs[t];
    }
    getOutputByName(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
            e = e.toString();
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedOutputs.length; t++)if (~this._disconnectedOutputs[t].name.indexOf(e)) return this._disconnectedOutputs[t];
        } else for(let t = 0; t < this.outputs.length; t++)if (~this.outputs[t].name.indexOf(e)) return this.outputs[t];
    }
    getOutputById(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedOutputs.length; t++)if (this._disconnectedOutputs[t]._midiOutput && this._disconnectedOutputs[t].id === e.toString()) return this._disconnectedOutputs[t];
        } else for(let t = 0; t < this.outputs.length; t++)if (this.outputs[t]._midiOutput && this.outputs[t].id === e.toString()) return this.outputs[t];
    }
    noteNameToNumber(e) {
        return this.validation && console.warn("The noteNameToNumber() method is deprecated. Use Utilities.toNoteNumber() instead."), Utilities.toNoteNumber(e, this.octaveOffset);
    }
    getOctave(e) {
        return this.validation && (console.warn("The getOctave()is deprecated. Use Utilities.getNoteDetails() instead"), e = parseInt(e)), !isNaN(e) && e >= 0 && e <= 127 && Utilities.getNoteDetails(Utilities.offsetNumber(e, this.octaveOffset)).octave;
    }
    sanitizeChannels(e) {
        return this.validation && console.warn("The sanitizeChannels() method has been moved to the utilities class."), Utilities.sanitizeChannels(e);
    }
    toMIDIChannels(e) {
        return this.validation && console.warn("The toMIDIChannels() method has been deprecated. Use Utilities.sanitizeChannels() instead."), Utilities.sanitizeChannels(e);
    }
    guessNoteNumber(e) {
        return this.validation && console.warn("The guessNoteNumber() method has been deprecated. Use Utilities.guessNoteNumber() instead."), Utilities.guessNoteNumber(e, this.octaveOffset);
    }
    getValidNoteArray(e, t = {}) {
        return this.validation && console.warn("The getValidNoteArray() method has been moved to the Utilities.buildNoteArray()"), Utilities.buildNoteArray(e, t);
    }
    convertToTimestamp(e) {
        return this.validation && console.warn("The convertToTimestamp() method has been moved to Utilities.toTimestamp()."), Utilities.toTimestamp(e);
    }
    async _destroyInputsAndOutputs() {
        let e = [];
        return this.inputs.forEach((t)=>e.push(t.destroy())), this.outputs.forEach((t)=>e.push(t.destroy())), Promise.all(e).then(()=>{
            this._inputs = [], this._outputs = [];
        });
    }
    _onInterfaceStateChange(e) {
        if (!this.enabled) return;
        this._updateInputsAndOutputs();
        let t = {
            timestamp: e.timeStamp,
            type: e.port.state,
            target: this
        };
        if ("connected" === e.port.state && "open" === e.port.connection) {
            "output" === e.port.type ? t.port = this.getOutputById(e.port.id) : "input" === e.port.type && (t.port = this.getInputById(e.port.id)), this.emit(e.port.state, t);
            const n = Object.assign({}, t);
            n.type = "portschanged", this.emit(n.type, n);
        } else if ("disconnected" === e.port.state && "pending" === e.port.connection) {
            "input" === e.port.type ? t.port = this.getInputById(e.port.id, {
                disconnected: !0
            }) : "output" === e.port.type && (t.port = this.getOutputById(e.port.id, {
                disconnected: !0
            })), this.emit(e.port.state, t);
            const n = Object.assign({}, t);
            n.type = "portschanged", this.emit(n.type, n);
        }
    }
    async _updateInputsAndOutputs() {
        return Promise.all([
            this._updateInputs(),
            this._updateOutputs()
        ]);
    }
    async _updateInputs() {
        if (!this.interface) return;
        for(let e = this._inputs.length - 1; e >= 0; e--){
            const t = this._inputs[e];
            Array.from(this.interface.inputs.values()).find((e)=>e === t._midiInput) || (this._disconnectedInputs.push(t), this._inputs.splice(e, 1));
        }
        let e = [];
        return this.interface.inputs.forEach((t)=>{
            if (!this._inputs.find((e)=>e._midiInput === t)) {
                let n = this._disconnectedInputs.find((e)=>e._midiInput === t);
                n || (n = new Input(t)), this._inputs.push(n), e.push(n.open());
            }
        }), Promise.all(e);
    }
    async _updateOutputs() {
        if (!this.interface) return;
        for(let e = this._outputs.length - 1; e >= 0; e--){
            const t = this._outputs[e];
            Array.from(this.interface.outputs.values()).find((e)=>e === t._midiOutput) || (this._disconnectedOutputs.push(t), this._outputs.splice(e, 1));
        }
        let e = [];
        return this.interface.outputs.forEach((t)=>{
            if (!this._outputs.find((e)=>e._midiOutput === t)) {
                let n = this._disconnectedOutputs.find((e)=>e._midiOutput === t);
                n || (n = new Output(t)), this._outputs.push(n), e.push(n.open());
            }
        }), Promise.all(e);
    }
    get enabled() {
        return null !== this.interface;
    }
    get inputs() {
        return this._inputs;
    }
    get isNode() {
        return this.validation && console.warn("WebMidi.isNode has been deprecated. Use Utilities.isNode instead."), Utilities.isNode;
    }
    get isBrowser() {
        return this.validation && console.warn("WebMidi.isBrowser has been deprecated. Use Utilities.isBrowser instead."), Utilities.isBrowser;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get outputs() {
        return this._outputs;
    }
    get supported() {
        return "undefined" != typeof navigator && !!navigator.requestMIDIAccess;
    }
    get sysexEnabled() {
        return !(!this.interface || !this.interface.sysexEnabled);
    }
    get time() {
        return performance.now();
    }
    get version() {
        return "3.3.1";
    }
    get flavour() {
        return "cjs";
    }
    get CHANNEL_EVENTS() {
        return this.validation && console.warn("The CHANNEL_EVENTS enum has been moved to Enumerations.CHANNEL_EVENTS."), Enumerations.CHANNEL_EVENTS;
    }
    get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been moved to Enumerations.SYSTEM_MESSAGES."), Enumerations.SYSTEM_MESSAGES;
    }
    get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been moved to Enumerations.CHANNEL_MODE_MESSAGES."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been replaced by the Enumerations.CONTROL_CHANGE_MESSAGES array."), Enumerations.MIDI_CONTROL_CHANGE_MESSAGES;
    }
    get MIDI_REGISTERED_PARAMETER() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETER enum has been moved to Enumerations.REGISTERED_PARAMETERS."), Enumerations.REGISTERED_PARAMETERS;
    }
    get NOTES() {
        return this.validation && console.warn("The NOTES enum has been deprecated."), [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ];
    }
}
const wm = new WebMidi;
wm.constructor = null, exports.Enumerations = Enumerations, exports.Forwarder = Forwarder, exports.Input = Input, exports.InputChannel = InputChannel, exports.Message = Message, exports.Note = Note, exports.Output = Output, exports.OutputChannel = OutputChannel, exports.Utilities = Utilities, exports.WebMidi = wm;

});

/*
MIT License

Copyright (c) 2017 Pavel Dobryakov

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/ // Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */ var $dfd8c9cbca816579$export$789ba40ee1a75f0;
(function(HttpTransportType) {
    /** Specifies no transport preference. */ HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */ HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */ HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */ HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})($dfd8c9cbca816579$export$789ba40ee1a75f0 || ($dfd8c9cbca816579$export$789ba40ee1a75f0 = {}));
var $dfd8c9cbca816579$export$f29afaa8e8d2989a;
(function(TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */ TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */ TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})($dfd8c9cbca816579$export$f29afaa8e8d2989a || ($dfd8c9cbca816579$export$f29afaa8e8d2989a = {}));

// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// 0, 2, 10, 30 second delays before reconnect attempts.
const $a70d4a2704acd148$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [
    0,
    2000,
    10000,
    30000,
    null
];
class $a70d4a2704acd148$export$97bc471d6a059e6e {
    constructor(retryDelays){
        this._retryDelays = retryDelays !== undefined ? [
            ...retryDelays,
            null
        ] : $a70d4a2704acd148$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    nextRetryDelayInMilliseconds(retryContext) {
        return this._retryDelays[retryContext.previousRetryCount];
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
class $2b7cf72ed2755a15$export$28d77f87efed1d88 {
}
$2b7cf72ed2755a15$export$28d77f87efed1d88.Authorization = "Authorization";
$2b7cf72ed2755a15$export$28d77f87efed1d88.Cookie = "Cookie";


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Represents an HTTP response. */ class $25eb580f65a5de55$export$1d94dfe0d9d1f1e7 {
    constructor(statusCode, statusText, content){
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
}
class $25eb580f65a5de55$export$8c6ee871e681f0f4 {
    get(url, options) {
        return this.send({
            ...options,
            method: "GET",
            url: url
        });
    }
    post(url, options) {
        return this.send({
            ...options,
            method: "POST",
            url: url
        });
    }
    delete(url, options) {
        return this.send({
            ...options,
            method: "DELETE",
            url: url
        });
    }
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */ // @ts-ignore
    getCookieString(url) {
        return "";
    }
}


class $3017bfe8a565980c$export$981ab95414418dd3 extends (0, $25eb580f65a5de55$export$8c6ee871e681f0f4) {
    constructor(innerClient, accessTokenFactory){
        super();
        this._innerClient = innerClient;
        this._accessTokenFactory = accessTokenFactory;
    }
    async send(request) {
        let allowRetry = true;
        if (this._accessTokenFactory && (!this._accessToken || request.url && request.url.indexOf("/negotiate?") > 0)) {
            // don't retry if the request is a negotiate or if we just got a potentially new token from the access token factory
            allowRetry = false;
            this._accessToken = await this._accessTokenFactory();
        }
        this._setAuthorizationHeader(request);
        const response = await this._innerClient.send(request);
        if (allowRetry && response.statusCode === 401 && this._accessTokenFactory) {
            this._accessToken = await this._accessTokenFactory();
            this._setAuthorizationHeader(request);
            return await this._innerClient.send(request);
        }
        return response;
    }
    _setAuthorizationHeader(request) {
        if (!request.headers) request.headers = {};
        if (this._accessToken) request.headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Authorization] = `Bearer ${this._accessToken}`;
        else if (this._accessTokenFactory) {
            if (request.headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Authorization]) delete request.headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Authorization];
        }
    }
    getCookieString(url) {
        return this._innerClient.getCookieString(url);
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Error thrown when an HTTP request fails. */ class $9862e2597169e2d4$export$65bd6083489bd8bb extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */ constructor(errorMessage, statusCode){
        const trueProto = new.target.prototype;
        super(`${errorMessage}: Status code '${statusCode}'`);
        this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$66d311bf29d5c89c extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "A timeout occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$18b052ffd8c84d7 extends Error {
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "An abort occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$c7cbd7482d8bece8 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'UnsupportedTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$764b8cd64449c5b0 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'DisabledTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$264839a6ea29f91a extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'FailedToStartTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$b4f59905103de78d extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
     *
     * @param {string} message A descriptive error message.
     */ constructor(message){
        const trueProto = new.target.prototype;
        super(message);
        this.errorType = 'FailedToNegotiateWithServerError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$9341e26d19ed3783 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
     *
     * @param {string} message A descriptive error message.
     * @param {Error[]} innerErrors The collection of errors this error is aggregating.
     */ constructor(message, innerErrors){
        const trueProto = new.target.prototype;
        super(message);
        this.innerErrors = innerErrors;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */ var $5f3832d7be2e7d2f$export$243e62d78d3b544d;
(function(LogLevel) {
    /** Log level for very low severity diagnostic messages. */ LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */ LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */ LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */ LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */ LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */ LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */ LogLevel[LogLevel["None"] = 6] = "None";
})($5f3832d7be2e7d2f$export$243e62d78d3b544d || ($5f3832d7be2e7d2f$export$243e62d78d3b544d = {}));


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** A logger that does nothing when log messages are sent to it. */ class $b632327c1843227b$export$17ac58a1138ded46 {
    constructor(){}
    /** @inheritDoc */ // eslint-disable-next-line
    log(_logLevel, _message) {}
}
/** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */ $b632327c1843227b$export$17ac58a1138ded46.instance = new $b632327c1843227b$export$17ac58a1138ded46();


const $3c61bc8cbb9065de$export$a4ad2735b021c132 = '10.0.11';


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


class $32bb29965a07731e$export$83f0753fc4347e43 {
    static isRequired(val, name) {
        if (val === null || val === undefined) throw new Error(`The '${name}' argument is required.`);
    }
    static isNotEmpty(val, name) {
        if (!val || val.match(/^\s*$/)) throw new Error(`The '${name}' argument should not be empty.`);
    }
    static isIn(val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) throw new Error(`Unknown ${name} value: ${val}.`);
    }
}
class $32bb29965a07731e$export$2dffd0b5373a4389 {
    // react-native has a window but no document so we should check both
    static get isBrowser() {
        return !$32bb29965a07731e$export$2dffd0b5373a4389.isNode && typeof window === "object" && typeof window.document === "object";
    }
    // WebWorkers don't have a window object so the isBrowser check would fail
    static get isWebWorker() {
        return !$32bb29965a07731e$export$2dffd0b5373a4389.isNode && typeof self === "object" && "importScripts" in self;
    }
    // react-native has a window but no document
    static get isReactNative() {
        return !$32bb29965a07731e$export$2dffd0b5373a4389.isNode && typeof window === "object" && typeof window.document === "undefined";
    }
    // Node apps shouldn't have a window object, but WebWorkers don't either
    // so we need to check for both WebWorker and window
    static get isNode() {
        return false;
    }
}
function $32bb29965a07731e$export$a688b91586df8fd9(data, includeContent) {
    let detail = "";
    if ($32bb29965a07731e$export$9dd3754ae86f0017(data)) {
        detail = `Binary data of length ${data.byteLength}`;
        if (includeContent) detail += `. Content: '${$32bb29965a07731e$export$3ddcef0d22959f49(data)}'`;
    } else if (typeof data === "string") {
        detail = `String data of length ${data.length}`;
        if (includeContent) detail += `. Content: '${data}'`;
    }
    return detail;
}
function $32bb29965a07731e$export$3ddcef0d22959f49(data) {
    const view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    let str = "";
    view.forEach((num)=>{
        const pad = num < 16 ? "0" : "";
        str += `0x${pad}${num.toString(16)} `;
    });
    // Trim of trailing space.
    return str.substring(0, str.length - 1);
}
function $32bb29965a07731e$export$9dd3754ae86f0017(val) {
    return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
    val.constructor && val.constructor.name === "ArrayBuffer");
}
async function $32bb29965a07731e$export$465cb47180de50f0(logger, transportName, httpClient, url, content, options) {
    const headers = {};
    const [name, value] = $32bb29965a07731e$export$56c7340f89ca57c5();
    headers[name] = value;
    logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(${transportName} transport) sending data. ${$32bb29965a07731e$export$a688b91586df8fd9(content, options.logMessageContent)}.`);
    const responseType = $32bb29965a07731e$export$9dd3754ae86f0017(content) ? "arraybuffer" : "text";
    const response = await httpClient.post(url, {
        content: content,
        headers: {
            ...headers,
            ...options.headers
        },
        responseType: responseType,
        timeout: options.timeout,
        withCredentials: options.withCredentials
    });
    logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(${transportName} transport) request complete. Response status: ${response.statusCode}.`);
}
function $32bb29965a07731e$export$fe2e61603b61130d(logger) {
    if (logger === undefined) return new $32bb29965a07731e$export$ba6a9c7ac8291f7f((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information);
    if (logger === null) return (0, $b632327c1843227b$export$17ac58a1138ded46).instance;
    if (logger.log !== undefined) return logger;
    return new $32bb29965a07731e$export$ba6a9c7ac8291f7f(logger);
}
class $32bb29965a07731e$export$b7a41f2bfb5c60c3 {
    constructor(subject, observer){
        this._subject = subject;
        this._observer = observer;
    }
    dispose() {
        const index = this._subject.observers.indexOf(this._observer);
        if (index > -1) this._subject.observers.splice(index, 1);
        if (this._subject.observers.length === 0 && this._subject.cancelCallback) this._subject.cancelCallback().catch((_)=>{});
    }
}
class $32bb29965a07731e$export$ba6a9c7ac8291f7f {
    constructor(minimumLogLevel){
        this._minLevel = minimumLogLevel;
        this.out = console;
    }
    log(logLevel, message) {
        if (logLevel >= this._minLevel) {
            const msg = `[${new Date().toISOString()}] ${(0, $5f3832d7be2e7d2f$export$243e62d78d3b544d)[logLevel]}: ${message}`;
            switch(logLevel){
                case (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Critical:
                case (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error:
                    this.out.error(msg);
                    break;
                case (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning:
                    this.out.warn(msg);
                    break;
                case (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information:
                    this.out.info(msg);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.out.log(msg);
                    break;
            }
        }
    }
}
function $32bb29965a07731e$export$56c7340f89ca57c5() {
    let userAgentHeaderName = "X-SignalR-User-Agent";
    if ($32bb29965a07731e$export$2dffd0b5373a4389.isNode) userAgentHeaderName = "User-Agent";
    return [
        userAgentHeaderName,
        $32bb29965a07731e$export$1feb51270b0ce71b((0, $3c61bc8cbb9065de$export$a4ad2735b021c132), $32bb29965a07731e$var$getOsName(), $32bb29965a07731e$var$getRuntime(), $32bb29965a07731e$var$getRuntimeVersion())
    ];
}
function $32bb29965a07731e$export$1feb51270b0ce71b(version, os, runtime, runtimeVersion) {
    // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
    let userAgent = "Microsoft SignalR/";
    const majorAndMinor = version.split(".");
    userAgent += `${majorAndMinor[0]}.${majorAndMinor[1]}`;
    userAgent += ` (${version}; `;
    if (os && os !== "") userAgent += `${os}; `;
    else userAgent += "Unknown OS; ";
    userAgent += `${runtime}`;
    if (runtimeVersion) userAgent += `; ${runtimeVersion}`;
    else userAgent += "; Unknown Runtime Version";
    userAgent += ")";
    return userAgent;
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $32bb29965a07731e$var$getOsName() {
    if ($32bb29965a07731e$export$2dffd0b5373a4389.isNode) switch($cfae44f0dfdf62c0$exports.platform){
        case "win32":
            return "Windows NT";
        case "darwin":
            return "macOS";
        case "linux":
            return "Linux";
        default:
            return $cfae44f0dfdf62c0$exports.platform;
    }
    else return "";
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $32bb29965a07731e$var$getRuntimeVersion() {
    if ($32bb29965a07731e$export$2dffd0b5373a4389.isNode) return $cfae44f0dfdf62c0$exports.versions.node;
    return undefined;
}
function $32bb29965a07731e$var$getRuntime() {
    if ($32bb29965a07731e$export$2dffd0b5373a4389.isNode) return "NodeJS";
    else return "Browser";
}
function $32bb29965a07731e$export$375b49718dbd9ced(e) {
    if (e.stack) return e.stack;
    else if (e.message) return e.message;
    return `${e}`;
}
function $32bb29965a07731e$export$ff5f2eeb11fc7e14() {
    // globalThis is semi-new and not available in Node until v12
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("could not find global");
}


class $a898fbbbb5189898$export$1b51ed6f7c8f947b extends (0, $25eb580f65a5de55$export$8c6ee871e681f0f4) {
    constructor(logger){
        super();
        this._logger = logger;
        // Node added a fetch implementation to the global scope starting in v18.
        // We need to add a cookie jar in node to be able to share cookies with WebSocket
        if (typeof fetch === "undefined" || (0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
            this._jar = new (requireFunc("tough-cookie")).CookieJar();
            if (typeof fetch === "undefined") this._fetchType = requireFunc("node-fetch");
            else // Use fetch from Node if available
            this._fetchType = fetch;
            // node-fetch doesn't have a nice API for getting and setting cookies
            // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
            this._fetchType = requireFunc("fetch-cookie")(this._fetchType, this._jar);
        } else this._fetchType = fetch.bind((0, $32bb29965a07731e$export$ff5f2eeb11fc7e14)());
        if (typeof AbortController === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
            this._abortControllerType = requireFunc("abort-controller");
        } else this._abortControllerType = AbortController;
    }
    /** @inheritDoc */ async send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) throw new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)();
        if (!request.method) throw new Error("No method defined.");
        if (!request.url) throw new Error("No url defined.");
        const abortController = new this._abortControllerType();
        let error;
        // Hook our abortSignal into the abort controller
        if (request.abortSignal) request.abortSignal.onabort = ()=>{
            abortController.abort();
            error = new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)();
        };
        // If a timeout has been passed in, setup a timeout to call abort
        // Type needs to be any to fit window.setTimeout and NodeJS.setTimeout
        let timeoutId = null;
        if (request.timeout) {
            const msTimeout = request.timeout;
            timeoutId = setTimeout(()=>{
                abortController.abort();
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Timeout from HTTP request.`);
                error = new (0, $9862e2597169e2d4$export$66d311bf29d5c89c)();
            }, msTimeout);
        }
        if (request.content === "") request.content = undefined;
        if (request.content) {
            // Explicitly setting the Content-Type header for React Native on Android platform.
            request.headers = request.headers || {};
            if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(request.content)) request.headers["Content-Type"] = "application/octet-stream";
            else request.headers["Content-Type"] = "text/plain;charset=UTF-8";
        }
        let response;
        try {
            response = await this._fetchType(request.url, {
                body: request.content,
                cache: "no-cache",
                credentials: request.withCredentials === true ? "include" : "same-origin",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    ...request.headers
                },
                method: request.method,
                mode: "cors",
                redirect: "follow",
                signal: abortController.signal
            });
        } catch (e) {
            if (error) throw error;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Error from HTTP request. ${e}.`);
            throw e;
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
            if (request.abortSignal) request.abortSignal.onabort = null;
        }
        if (!response.ok) {
            const errorMessage = await $a898fbbbb5189898$var$deserializeContent(response, "text");
            throw new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(errorMessage || response.statusText, response.status);
        }
        const content = $a898fbbbb5189898$var$deserializeContent(response, request.responseType);
        const payload = await content;
        return new (0, $25eb580f65a5de55$export$1d94dfe0d9d1f1e7)(response.status, response.statusText, payload);
    }
    getCookieString(url) {
        let cookies = "";
        if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && this._jar) // @ts-ignore: unused variable
        this._jar.getCookies(url, (e, c)=>cookies = c.join("; "));
        return cookies;
    }
}
function $a898fbbbb5189898$var$deserializeContent(response, responseType) {
    let content;
    switch(responseType){
        case "arraybuffer":
            content = response.arrayBuffer();
            break;
        case "text":
            content = response.text();
            break;
        case "blob":
        case "document":
        case "json":
            throw new Error(`${responseType} is not supported.`);
        default:
            content = response.text();
            break;
    }
    return content;
}




// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.




class $e584b8a3345de0d8$export$33b9ed1bd07561aa extends (0, $25eb580f65a5de55$export$8c6ee871e681f0f4) {
    constructor(logger){
        super();
        this._logger = logger;
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return new Promise((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = request.withCredentials === undefined ? true : request.withCredentials;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            if (request.content === "") request.content = undefined;
            if (request.content) {
                // Explicitly setting the Content-Type header for React Native on Android platform.
                if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(request.content)) xhr.setRequestHeader("Content-Type", "application/octet-stream");
                else xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            }
            const headers = request.headers;
            if (headers) Object.keys(headers).forEach((header)=>{
                xhr.setRequestHeader(header, headers[header]);
            });
            if (request.responseType) xhr.responseType = request.responseType;
            if (request.abortSignal) request.abortSignal.onabort = ()=>{
                xhr.abort();
                reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)());
            };
            if (request.timeout) xhr.timeout = request.timeout;
            xhr.onload = ()=>{
                if (request.abortSignal) request.abortSignal.onabort = null;
                if (xhr.status >= 200 && xhr.status < 300) resolve(new (0, $25eb580f65a5de55$export$1d94dfe0d9d1f1e7)(xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                else reject(new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(xhr.response || xhr.responseText || xhr.statusText, xhr.status));
            };
            xhr.onerror = ()=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Error from HTTP request. ${xhr.status}: ${xhr.statusText}.`);
                reject(new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(xhr.statusText, xhr.status));
            };
            xhr.ontimeout = ()=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Timeout from HTTP request.`);
                reject(new (0, $9862e2597169e2d4$export$66d311bf29d5c89c)());
            };
            xhr.send(request.content);
        });
    }
}


class $c9ca2928589aa40c$export$4f11ab3560c519e5 extends (0, $25eb580f65a5de55$export$8c6ee871e681f0f4) {
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */ constructor(logger){
        super();
        if (typeof fetch !== "undefined" || (0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode) this._httpClient = new (0, $a898fbbbb5189898$export$1b51ed6f7c8f947b)(logger);
        else if (typeof XMLHttpRequest !== "undefined") this._httpClient = new (0, $e584b8a3345de0d8$export$33b9ed1bd07561aa)(logger);
        else throw new Error("No usable HttpClient found.");
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return this._httpClient.send(request);
    }
    getCookieString(url) {
        return this._httpClient.getCookieString(url);
    }
}





// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */ class $45591c3c8a133c1f$export$48f7e099c149af88 {
    constructor(){
        this._isAborted = false;
        this.onabort = null;
    }
    abort() {
        if (!this._isAborted) {
            this._isAborted = true;
            if (this.onabort) this.onabort();
        }
    }
    get signal() {
        return this;
    }
    get aborted() {
        return this._isAborted;
    }
}






class $68d775930ce5466a$export$fbd8c90d2cca1300 {
    // This is an internal type, not exported from 'index' so this is really just internal.
    get pollAborted() {
        return this._pollAbort.aborted;
    }
    constructor(httpClient, logger, options){
        this._httpClient = httpClient;
        this._logger = logger;
        this._pollAbort = new (0, $45591c3c8a133c1f$export$48f7e099c149af88)();
        this._options = options;
        this._running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isIn(transferFormat, (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a), "transferFormat");
        this._url = url;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Connecting.");
        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
        if (transferFormat === (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Binary && typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string") throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
        const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
        const headers = {
            [name]: value,
            ...this._options.headers
        };
        const pollOptions = {
            abortSignal: this._pollAbort.signal,
            headers: headers,
            timeout: 100000,
            withCredentials: this._options.withCredentials
        };
        if (transferFormat === (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Binary) pollOptions.responseType = "arraybuffer";
        // Make initial long polling request
        // Server uses first long polling request to finish initializing connection and it returns without data
        const pollUrl = `${url}&_=${Date.now()}`;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
        const response = await this._httpClient.get(pollUrl, pollOptions);
        if (response.statusCode !== 200) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
            // Mark running as false so that the poll immediately ends and runs the close logic
            this._closeError = new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(response.statusText || "", response.statusCode);
            this._running = false;
        } else this._running = true;
        this._receiving = this._poll(this._url, pollOptions);
    }
    async _poll(url, pollOptions) {
        try {
            while(this._running)try {
                const pollUrl = `${url}&_=${Date.now()}`;
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
                const response = await this._httpClient.get(pollUrl, pollOptions);
                if (response.statusCode === 204) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "(LongPolling transport) Poll terminated by server.");
                    this._running = false;
                } else if (response.statusCode !== 200) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
                    // Unexpected status code
                    this._closeError = new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(response.statusText || "", response.statusCode);
                    this._running = false;
                } else // Process the response
                if (response.content) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) data received. ${(0, $32bb29965a07731e$export$a688b91586df8fd9)(response.content, this._options.logMessageContent)}.`);
                    if (this.onreceive) this.onreceive(response.content);
                } else // This is another way timeout manifest.
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Poll timed out, reissuing.");
            } catch (e) {
                if (!this._running) // Log but disregard errors that occur after stopping
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) Poll errored after shutdown: ${e.message}`);
                else if (e instanceof (0, $9862e2597169e2d4$export$66d311bf29d5c89c)) // Ignore timeouts and reissue the poll.
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Poll timed out, reissuing.");
                else {
                    // Close the connection with the error as the result.
                    this._closeError = e;
                    this._running = false;
                }
            }
        } finally{
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Polling complete.");
            // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
            // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
            if (!this.pollAborted) this._raiseOnClose();
        }
    }
    async send(data) {
        if (!this._running) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $32bb29965a07731e$export$465cb47180de50f0)(this._logger, "LongPolling", this._httpClient, this._url, data, this._options);
    }
    async stop() {
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Stopping polling.");
        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
        this._running = false;
        this._pollAbort.abort();
        try {
            await this._receiving;
            // Send DELETE to clean up long polling on the server
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
            const headers = {};
            const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
            headers[name] = value;
            const deleteOptions = {
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            };
            let error;
            try {
                await this._httpClient.delete(this._url, deleteOptions);
            } catch (err) {
                error = err;
            }
            if (error) {
                if (error instanceof (0, $9862e2597169e2d4$export$65bd6083489bd8bb)) {
                    if (error.statusCode === 404) this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.");
                    else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) Error sending a DELETE request: ${error}`);
                }
            } else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) DELETE request accepted.");
        } finally{
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Stop finished.");
            // Raise close event here instead of in polling
            // It needs to happen after the DELETE request is sent
            this._raiseOnClose();
        }
    }
    _raiseOnClose() {
        if (this.onclose) {
            let logMessage = "(LongPolling transport) Firing onclose event.";
            if (this._closeError) logMessage += " Error: " + this._closeError;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, logMessage);
            this.onclose(this._closeError);
        }
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.



class $812b3bf15307ec8b$export$f0d4dc62ec317948 {
    constructor(httpClient, accessToken, logger, options){
        this._httpClient = httpClient;
        this._accessToken = accessToken;
        this._logger = logger;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isIn(transferFormat, (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(SSE transport) Connecting.");
        // set url before accessTokenFactory because this._url is only for send and we set the auth header instead of the query string for send
        this._url = url;
        if (this._accessToken) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`;
        return new Promise((resolve, reject)=>{
            let opened = false;
            if (transferFormat !== (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Text) {
                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                return;
            }
            let eventSource;
            if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isBrowser || (0, $32bb29965a07731e$export$2dffd0b5373a4389).isWebWorker) eventSource = new this._options.EventSource(url, {
                withCredentials: this._options.withCredentials
            });
            else {
                // Non-browser passes cookies via the dictionary
                const cookies = this._httpClient.getCookieString(url);
                const headers = {};
                headers.Cookie = cookies;
                const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
                headers[name] = value;
                eventSource = new this._options.EventSource(url, {
                    withCredentials: this._options.withCredentials,
                    headers: {
                        ...headers,
                        ...this._options.headers
                    }
                });
            }
            try {
                eventSource.onmessage = (e)=>{
                    if (this.onreceive) try {
                        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(SSE transport) data received. ${(0, $32bb29965a07731e$export$a688b91586df8fd9)(e.data, this._options.logMessageContent)}.`);
                        this.onreceive(e.data);
                    } catch (error) {
                        this._close(error);
                        return;
                    }
                };
                // @ts-ignore: not using event on purpose
                eventSource.onerror = (e)=>{
                    // EventSource doesn't give any useful information about server side closes.
                    if (opened) this._close();
                    else reject(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
                };
                eventSource.onopen = ()=>{
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `SSE connected to ${this._url}`);
                    this._eventSource = eventSource;
                    opened = true;
                    resolve();
                };
            } catch (e) {
                reject(e);
                return;
            }
        });
    }
    async send(data) {
        if (!this._eventSource) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $32bb29965a07731e$export$465cb47180de50f0)(this._logger, "SSE", this._httpClient, this._url, data, this._options);
    }
    stop() {
        this._close();
        return Promise.resolve();
    }
    _close(e) {
        if (this._eventSource) {
            this._eventSource.close();
            this._eventSource = undefined;
            if (this.onclose) this.onclose(e);
        }
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.




class $c80131de2ca718fe$export$de21836fc42c6f9c {
    constructor(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers){
        this._logger = logger;
        this._accessTokenFactory = accessTokenFactory;
        this._logMessageContent = logMessageContent;
        this._webSocketConstructor = webSocketConstructor;
        this._httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
        this._headers = headers;
    }
    async connect(url, transferFormat) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isIn(transferFormat, (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(WebSockets transport) Connecting.");
        let token;
        if (this._accessTokenFactory) token = await this._accessTokenFactory();
        return new Promise((resolve, reject)=>{
            url = url.replace(/^http/, "ws");
            let webSocket;
            const cookies = this._httpClient.getCookieString(url);
            let opened = false;
            if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode || (0, $32bb29965a07731e$export$2dffd0b5373a4389).isReactNative) {
                const headers = {};
                const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
                headers[name] = value;
                if (token) headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Authorization] = `Bearer ${token}`;
                if (cookies) headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Cookie] = cookies;
                // Only pass headers when in non-browser environments
                webSocket = new this._webSocketConstructor(url, undefined, {
                    headers: {
                        ...headers,
                        ...this._headers
                    }
                });
            } else if (token) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token)}`;
            if (!webSocket) // Chrome is not happy with passing 'undefined' as protocol
            webSocket = new this._webSocketConstructor(url);
            if (transferFormat === (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Binary) webSocket.binaryType = "arraybuffer";
            webSocket.onopen = (_event)=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `WebSocket connected to ${url}.`);
                this._webSocket = webSocket;
                opened = true;
                resolve();
            };
            webSocket.onerror = (event)=>{
                let error = null;
                // ErrorEvent is a browser only type we need to check if the type exists before using it
                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                else error = "There was an error with the transport";
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `(WebSockets transport) ${error}.`);
            };
            webSocket.onmessage = (message)=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(WebSockets transport) data received. ${(0, $32bb29965a07731e$export$a688b91586df8fd9)(message.data, this._logMessageContent)}.`);
                if (this.onreceive) try {
                    this.onreceive(message.data);
                } catch (error) {
                    this._close(error);
                    return;
                }
            };
            webSocket.onclose = (event)=>{
                // Don't call close handler if connection was never established
                // We'll reject the connect call instead
                if (opened) this._close(event);
                else {
                    let error = null;
                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                    else error = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.";
                    reject(new Error(error));
                }
            };
        });
    }
    send(data) {
        if (this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(WebSockets transport) sending data. ${(0, $32bb29965a07731e$export$a688b91586df8fd9)(data, this._logMessageContent)}.`);
            this._webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    }
    stop() {
        if (this._webSocket) // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
        // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
        this._close(undefined);
        return Promise.resolve();
    }
    _close(event) {
        // webSocket will be null if the transport did not start successfully
        if (this._webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this._webSocket.onclose = ()=>{};
            this._webSocket.onmessage = ()=>{};
            this._webSocket.onerror = ()=>{};
            this._webSocket.close();
            this._webSocket = undefined;
        }
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (this._isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) this.onclose(new Error(`WebSocket closed with status code: ${event.code} (${event.reason || "no reason given"}).`));
            else if (event instanceof Error) this.onclose(event);
            else this.onclose();
        }
    }
    _isCloseEvent(event) {
        return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    }
}


const $73b6b78c950d1272$var$MAX_REDIRECTS = 100;
class $73b6b78c950d1272$export$13c1f9cf8a283575 {
    constructor(url, options = {}){
        this._stopPromiseResolver = ()=>{};
        this.features = {};
        this._negotiateVersion = 1;
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        this._logger = (0, $32bb29965a07731e$export$fe2e61603b61130d)(options.logger);
        this.baseUrl = this._resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
        if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
        else throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        options.timeout = options.timeout === undefined ? 100000 : options.timeout;
        let webSocketModule = null;
        let eventSourceModule = null;
        if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && true) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            webSocketModule = requireFunc("ws");
            eventSourceModule = requireFunc("eventsource");
        }
        if (!(0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && typeof WebSocket !== "undefined" && !options.WebSocket) options.WebSocket = WebSocket;
        else if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && !options.WebSocket) {
            if (webSocketModule) options.WebSocket = webSocketModule;
        }
        if (!(0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && typeof EventSource !== "undefined" && !options.EventSource) options.EventSource = EventSource;
        else if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && !options.EventSource) {
            if (typeof eventSourceModule !== "undefined") options.EventSource = eventSourceModule;
        }
        this._httpClient = new (0, $3017bfe8a565980c$export$981ab95414418dd3)(options.httpClient || new (0, $c9ca2928589aa40c$export$4f11ab3560c519e5)(this._logger), options.accessTokenFactory);
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
        this._connectionStarted = false;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async start(transferFormat) {
        transferFormat = transferFormat || (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Binary;
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isIn(transferFormat, (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Starting connection with transfer format '${(0, $dfd8c9cbca816579$export$f29afaa8e8d2989a)[transferFormat]}'.`);
        if (this._connectionState !== "Disconnected" /* ConnectionState.Disconnected */ ) return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
        this._connectionState = "Connecting" /* ConnectionState.Connecting */ ;
        this._startInternalPromise = this._startInternal(transferFormat);
        await this._startInternalPromise;
        // The TypeScript compiler thinks that connectionState must be Connecting here. The TypeScript compiler is wrong.
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "Failed to start the HttpConnection before stop() was called.";
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, message);
            // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
            await this._stopPromise;
            return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)(message));
        } else if (this._connectionState !== "Connected" /* ConnectionState.Connected */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, message);
            return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)(message));
        }
        this._connectionStarted = true;
    }
    send(data) {
        if (this._connectionState !== "Connected" /* ConnectionState.Connected */ ) return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        if (!this._sendQueue) this._sendQueue = new $73b6b78c950d1272$export$ff09921d3884e946(this.transport);
        // Transport will not be null if state is connected
        return this._sendQueue.send(data);
    }
    async stop(error) {
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        this._connectionState = "Disconnecting" /* ConnectionState.Disconnecting */ ;
        this._stopPromise = new Promise((resolve)=>{
            // Don't complete stop() until stopConnection() completes.
            this._stopPromiseResolver = resolve;
        });
        // stopInternal should never throw so just observe it.
        await this._stopInternal(error);
        await this._stopPromise;
    }
    async _stopInternal(error) {
        // Set error as soon as possible otherwise there is a race between
        // the transport closing and providing an error and the error from a close message
        // We would prefer the close message error.
        this._stopError = error;
        try {
            await this._startInternalPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
        // The transport's onclose will trigger stopConnection which will run our onclose event.
        // The transport should always be set if currently connected. If it wasn't set, it's likely because
        // stop was called during start() and start() failed.
        if (this.transport) {
            try {
                await this.transport.stop();
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `HttpConnection.transport.stop() threw error '${e}'.`);
                this._stopConnection();
            }
            this.transport = undefined;
        } else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
    }
    async _startInternal(transferFormat) {
        // Store the original base url and the access token factory since they may change
        // as part of negotiating
        let url = this.baseUrl;
        this._accessTokenFactory = this._options.accessTokenFactory;
        this._httpClient._accessTokenFactory = this._accessTokenFactory;
        try {
            if (this._options.skipNegotiation) {
                if (this._options.transport === (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets) {
                    // No need to add a connection ID in this case
                    this.transport = this._constructTransport((0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets);
                    // We should just call connect directly in this case.
                    // No fallback or negotiate in this case.
                    await this._startTransport(url, transferFormat);
                } else throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
            } else {
                let negotiateResponse = null;
                let redirects = 0;
                do {
                    negotiateResponse = await this._getNegotiationResponse(url);
                    // the user tries to stop the connection when it is being started
                    if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */  || this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) throw new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)("The connection was stopped during negotiation.");
                    if (negotiateResponse.error) throw new Error(negotiateResponse.error);
                    if (negotiateResponse.ProtocolVersion) throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                    if (negotiateResponse.url) url = negotiateResponse.url;
                    if (negotiateResponse.accessToken) {
                        // Replace the current access token factory with one that uses
                        // the returned access token
                        const accessToken = negotiateResponse.accessToken;
                        this._accessTokenFactory = ()=>accessToken;
                        // set the factory to undefined so the AccessTokenHttpClient won't retry with the same token, since we know it won't change until a connection restart
                        this._httpClient._accessToken = accessToken;
                        this._httpClient._accessTokenFactory = undefined;
                    }
                    redirects++;
                }while (negotiateResponse.url && redirects < $73b6b78c950d1272$var$MAX_REDIRECTS);
                if (redirects === $73b6b78c950d1272$var$MAX_REDIRECTS && negotiateResponse.url) throw new Error("Negotiate redirection limit exceeded.");
                await this._createTransport(url, this._options.transport, negotiateResponse, transferFormat);
            }
            if (this.transport instanceof (0, $68d775930ce5466a$export$fbd8c90d2cca1300)) this.features.inherentKeepAlive = true;
            if (this._connectionState === "Connecting" /* ConnectionState.Connecting */ ) {
                // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "The HttpConnection connected successfully.");
                this._connectionState = "Connected" /* ConnectionState.Connected */ ;
            }
        // stop() is waiting on us via this.startInternalPromise so keep this.transport around so it can clean up.
        // This is the only case startInternal can exit in neither the connected nor disconnected state because stopConnection()
        // will transition to the disconnected state. start() will wait for the transition using the stopPromise.
        } catch (e) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, "Failed to start the connection: " + e);
            this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
            this.transport = undefined;
            // if start fails, any active calls to stop assume that start will complete the stop promise
            this._stopPromiseResolver();
            return Promise.reject(e);
        }
    }
    async _getNegotiationResponse(url) {
        const headers = {};
        const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
        headers[name] = value;
        const negotiateUrl = this._resolveNegotiateUrl(url);
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Sending negotiation request: ${negotiateUrl}.`);
        try {
            const response = await this._httpClient.post(negotiateUrl, {
                content: "",
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            });
            if (response.statusCode !== 200) return Promise.reject(new Error(`Unexpected status code returned from negotiate '${response.statusCode}'`));
            const negotiateResponse = JSON.parse(response.content);
            if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) // Negotiate version 0 doesn't use connectionToken
            // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
            negotiateResponse.connectionToken = negotiateResponse.connectionId;
            if (negotiateResponse.useStatefulReconnect && this._options._useStatefulReconnect !== true) return Promise.reject(new (0, $9862e2597169e2d4$export$b4f59905103de78d)("Client didn't negotiate Stateful Reconnect but the server did."));
            return negotiateResponse;
        } catch (e) {
            let errorMessage = "Failed to complete negotiation with the server: " + e;
            if (e instanceof (0, $9862e2597169e2d4$export$65bd6083489bd8bb)) {
                if (e.statusCode === 404) errorMessage = errorMessage + " Either this is not a SignalR endpoint or there is a proxy blocking the connection.";
            }
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, errorMessage);
            return Promise.reject(new (0, $9862e2597169e2d4$export$b4f59905103de78d)(errorMessage));
        }
    }
    _createConnectUrl(url, connectionToken) {
        if (!connectionToken) return url;
        return url + (url.indexOf("?") === -1 ? "?" : "&") + `id=${connectionToken}`;
    }
    async _createTransport(url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        let connectUrl = this._createConnectUrl(url, negotiateResponse.connectionToken);
        if (this._isITransport(requestedTransport)) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection was provided an instance of ITransport, using that directly.");
            this.transport = requestedTransport;
            await this._startTransport(connectUrl, requestedTransferFormat);
            this.connectionId = negotiateResponse.connectionId;
            return;
        }
        const transportExceptions = [];
        const transports = negotiateResponse.availableTransports || [];
        let negotiate = negotiateResponse;
        for (const endpoint of transports){
            const transportOrError = this._resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, (negotiate === null || negotiate === void 0 ? void 0 : negotiate.useStatefulReconnect) === true);
            if (transportOrError instanceof Error) {
                // Store the error and continue, we don't want to cause a re-negotiate in these cases
                transportExceptions.push(`${endpoint.transport} failed:`);
                transportExceptions.push(transportOrError);
            } else if (this._isITransport(transportOrError)) {
                this.transport = transportOrError;
                if (!negotiate) {
                    try {
                        negotiate = await this._getNegotiationResponse(url);
                    } catch (ex) {
                        return Promise.reject(ex);
                    }
                    connectUrl = this._createConnectUrl(url, negotiate.connectionToken);
                }
                try {
                    await this._startTransport(connectUrl, requestedTransferFormat);
                    this.connectionId = negotiate.connectionId;
                    return;
                } catch (ex) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Failed to start the transport '${endpoint.transport}': ${ex}`);
                    negotiate = undefined;
                    transportExceptions.push(new (0, $9862e2597169e2d4$export$264839a6ea29f91a)(`${endpoint.transport} failed: ${ex}`, (0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[endpoint.transport]));
                    if (this._connectionState !== "Connecting" /* ConnectionState.Connecting */ ) {
                        const message = "Failed to select transport before stop() was called.";
                        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, message);
                        return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)(message));
                    }
                }
            }
        }
        if (transportExceptions.length > 0) return Promise.reject(new (0, $9862e2597169e2d4$export$9341e26d19ed3783)(`Unable to connect to the server with any of the available transports. ${transportExceptions.join(" ")}`, transportExceptions));
        return Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
    }
    _constructTransport(transport) {
        switch(transport){
            case (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets:
                if (!this._options.WebSocket) throw new Error("'WebSocket' is not supported in your environment.");
                return new (0, $c80131de2ca718fe$export$de21836fc42c6f9c)(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
            case (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).ServerSentEvents:
                if (!this._options.EventSource) throw new Error("'EventSource' is not supported in your environment.");
                return new (0, $812b3bf15307ec8b$export$f0d4dc62ec317948)(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
            case (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).LongPolling:
                return new (0, $68d775930ce5466a$export$fbd8c90d2cca1300)(this._httpClient, this._logger, this._options);
            default:
                throw new Error(`Unknown transport: ${transport}.`);
        }
    }
    _startTransport(url, transferFormat) {
        this.transport.onreceive = this.onreceive;
        if (this.features.reconnect) this.transport.onclose = async (e)=>{
            let callStop = false;
            if (this.features.reconnect) try {
                this.features.disconnected();
                await this.transport.connect(url, transferFormat);
                await this.features.resend();
            } catch  {
                callStop = true;
            }
            else {
                this._stopConnection(e);
                return;
            }
            if (callStop) this._stopConnection(e);
        };
        else this.transport.onclose = (e)=>this._stopConnection(e);
        return this.transport.connect(url, transferFormat);
    }
    _resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, useStatefulReconnect) {
        const transport = (0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[endpoint.transport];
        if (transport === null || transport === undefined) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
            return new Error(`Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
        } else if ($73b6b78c950d1272$var$transportMatches(requestedTransport, transport)) {
            const transferFormats = endpoint.transferFormats.map((s)=>(0, $dfd8c9cbca816579$export$f29afaa8e8d2989a)[s]);
            if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                if (transport === (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets && !this._options.WebSocket || transport === (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).ServerSentEvents && !this._options.EventSource) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' because it is not supported in your environment.'`);
                    return new (0, $9862e2597169e2d4$export$c7cbd7482d8bece8)(`'${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' is not supported in your environment.`, transport);
                } else {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Selecting transport '${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}'.`);
                    try {
                        this.features.reconnect = transport === (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets ? useStatefulReconnect : undefined;
                        return this._constructTransport(transport);
                    } catch (ex) {
                        return ex;
                    }
                }
            } else {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' because it does not support the requested transfer format '${(0, $dfd8c9cbca816579$export$f29afaa8e8d2989a)[requestedTransferFormat]}'.`);
                return new Error(`'${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' does not support ${(0, $dfd8c9cbca816579$export$f29afaa8e8d2989a)[requestedTransferFormat]}.`);
            }
        } else {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' because it was disabled by the client.`);
            return new (0, $9862e2597169e2d4$export$764b8cd64449c5b0)(`'${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' is disabled by the client.`, transport);
        }
    }
    _isITransport(transport) {
        return transport && typeof transport === "object" && "connect" in transport;
    }
    _stopConnection(error) {
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `HttpConnection.stopConnection(${error}) called while in state ${this._connectionState}.`);
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this._stopError || error;
        this._stopError = undefined;
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is already in the disconnected state.`);
            return;
        }
        if (this._connectionState === "Connecting" /* ConnectionState.Connecting */ ) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is still in the connecting state.`);
            throw new Error(`HttpConnection.stopConnection(${error}) was called while the connection is still in the connecting state.`);
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) // A call to stop() induced this call to stopConnection and needs to be completed.
        // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
        this._stopPromiseResolver();
        if (error) this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Connection disconnected with error '${error}'.`);
        else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "Connection disconnected.");
        if (this._sendQueue) {
            this._sendQueue.stop().catch((e)=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `TransportSendQueue.stop() threw error '${e}'.`);
            });
            this._sendQueue = undefined;
        }
        this.connectionId = undefined;
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
        if (this._connectionStarted) {
            this._connectionStarted = false;
            try {
                if (this.onclose) this.onclose(error);
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `HttpConnection.onclose(${error}) threw error '${e}'.`);
            }
        }
    }
    _resolveUrl(url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) return url;
        if (!(0, $32bb29965a07731e$export$2dffd0b5373a4389).isBrowser) throw new Error(`Cannot resolve '${url}'.`);
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        const aTag = window.document.createElement("a");
        aTag.href = url;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Normalizing '${url}' to '${aTag.href}'.`);
        return aTag.href;
    }
    _resolveNegotiateUrl(url) {
        const negotiateUrl = new URL(url);
        if (negotiateUrl.pathname.endsWith('/')) negotiateUrl.pathname += "negotiate";
        else negotiateUrl.pathname += "/negotiate";
        const searchParams = new URLSearchParams(negotiateUrl.searchParams);
        if (!searchParams.has("negotiateVersion")) searchParams.append("negotiateVersion", this._negotiateVersion.toString());
        if (searchParams.has("useStatefulReconnect")) {
            if (searchParams.get("useStatefulReconnect") === "true") this._options._useStatefulReconnect = true;
        } else if (this._options._useStatefulReconnect === true) searchParams.append("useStatefulReconnect", "true");
        negotiateUrl.search = searchParams.toString();
        return negotiateUrl.toString();
    }
}
function $73b6b78c950d1272$var$transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || (actualTransport & requestedTransport) !== 0;
}
class $73b6b78c950d1272$export$ff09921d3884e946 {
    constructor(_transport){
        this._transport = _transport;
        this._buffer = [];
        this._executing = true;
        this._sendBufferedData = new $73b6b78c950d1272$var$PromiseSource();
        this._transportResult = new $73b6b78c950d1272$var$PromiseSource();
        this._sendLoopPromise = this._sendLoop();
    }
    send(data) {
        this._bufferData(data);
        if (!this._transportResult) this._transportResult = new $73b6b78c950d1272$var$PromiseSource();
        return this._transportResult.promise;
    }
    stop() {
        this._executing = false;
        this._sendBufferedData.resolve();
        return this._sendLoopPromise;
    }
    _bufferData(data) {
        if (this._buffer.length && typeof this._buffer[0] !== typeof data) throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof data}`);
        this._buffer.push(data);
        this._sendBufferedData.resolve();
    }
    async _sendLoop() {
        while(true){
            await this._sendBufferedData.promise;
            if (!this._executing) {
                if (this._transportResult) this._transportResult.reject("Connection stopped.");
                break;
            }
            this._sendBufferedData = new $73b6b78c950d1272$var$PromiseSource();
            const transportResult = this._transportResult;
            this._transportResult = undefined;
            const data = typeof this._buffer[0] === "string" ? this._buffer.join("") : $73b6b78c950d1272$export$ff09921d3884e946._concatBuffers(this._buffer);
            this._buffer.length = 0;
            try {
                await this._transport.send(data);
                transportResult.resolve();
            } catch (error) {
                transportResult.reject(error);
            }
        }
    }
    static _concatBuffers(arrayBuffers) {
        const totalLength = arrayBuffers.map((b)=>b.byteLength).reduce((a, b)=>a + b);
        const result = new Uint8Array(totalLength);
        let offset = 0;
        for (const item of arrayBuffers){
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result.buffer;
    }
}
class $73b6b78c950d1272$var$PromiseSource {
    constructor(){
        this.promise = new Promise((resolve, reject)=>([this._resolver, this._rejecter] = [
                resolve,
                reject
            ]));
    }
    resolve() {
        this._resolver();
    }
    reject(reason) {
        this._rejecter(reason);
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Not exported from index
/** @private */ class $5e59b4f8b1f9494d$export$fc2e5d47850f626b {
    static write(output) {
        return `${output}${$5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparator}`;
    }
    static parse(input) {
        if (input[input.length - 1] !== $5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparator) throw new Error("Message is incomplete.");
        const messages = input.split($5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparator);
        messages.pop();
        return messages;
    }
}
$5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparatorCode = 0x1e;
$5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparator = String.fromCharCode($5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparatorCode);



class $60dd2bca4d6878db$export$b23df48528d3f5f4 {
    // Handshake request is always JSON
    writeHandshakeRequest(handshakeRequest) {
        return (0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).write(JSON.stringify(handshakeRequest));
    }
    parseHandshakeResponse(data) {
        let messageData;
        let remainingData;
        if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(data)) {
            // Format is binary but still need to read JSON text from handshake response
            const binaryData = new Uint8Array(data);
            const separatorIndex = binaryData.indexOf((0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).RecordSeparatorCode);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, Array.prototype.slice.call(binaryData.slice(0, responseLength)));
            remainingData = binaryData.byteLength > responseLength ? binaryData.slice(responseLength).buffer : null;
        } else {
            const textData = data;
            const separatorIndex = textData.indexOf((0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).RecordSeparator);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = textData.length > responseLength ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        const messages = (0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).parse(messageData);
        const response = JSON.parse(messages[0]);
        if (response.type) throw new Error("Expected a handshake response from the server.");
        const responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [
            remainingData,
            responseMessage
        ];
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Defines the type of a Hub Message. */ var $2e5e85a8c3cc12fd$export$80edbf15fa61a4db;
(function(MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */ MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */ MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */ MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */ MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */ MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */ MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */ MessageType[MessageType["Close"] = 7] = "Close";
    MessageType[MessageType["Ack"] = 8] = "Ack";
    MessageType[MessageType["Sequence"] = 9] = "Sequence";
})($2e5e85a8c3cc12fd$export$80edbf15fa61a4db || ($2e5e85a8c3cc12fd$export$80edbf15fa61a4db = {}));



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

class $82e59eaf686a40c1$export$b6bbab5a9b109038 {
    constructor(){
        this.observers = [];
    }
    next(item) {
        for (const observer of this.observers)observer.next(item);
    }
    error(err) {
        for (const observer of this.observers)if (observer.error) observer.error(err);
    }
    complete() {
        for (const observer of this.observers)if (observer.complete) observer.complete();
    }
    subscribe(observer) {
        this.observers.push(observer);
        return new (0, $32bb29965a07731e$export$b7a41f2bfb5c60c3)(this, observer);
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.


class $b8f262c250af9dbb$export$9d24a0f7b61acd07 {
    constructor(protocol, connection, bufferSize){
        this._bufferSize = 100000;
        this._messages = [];
        this._totalMessageCount = 0;
        this._waitForSequenceMessage = false;
        // Message IDs start at 1 and always increment by 1
        this._nextReceivingSequenceId = 1;
        this._latestReceivedSequenceId = 0;
        this._bufferedByteCount = 0;
        this._reconnectInProgress = false;
        this._protocol = protocol;
        this._connection = connection;
        this._bufferSize = bufferSize;
    }
    async _send(message) {
        const serializedMessage = this._protocol.writeMessage(message);
        let backpressurePromise = Promise.resolve();
        // Only count invocation messages. Acks, pings, etc. don't need to be resent on reconnect
        if (this._isInvocationMessage(message)) {
            this._totalMessageCount++;
            let backpressurePromiseResolver = ()=>{};
            let backpressurePromiseRejector = ()=>{};
            if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(serializedMessage)) this._bufferedByteCount += serializedMessage.byteLength;
            else this._bufferedByteCount += serializedMessage.length;
            if (this._bufferedByteCount >= this._bufferSize) backpressurePromise = new Promise((resolve, reject)=>{
                backpressurePromiseResolver = resolve;
                backpressurePromiseRejector = reject;
            });
            this._messages.push(new $b8f262c250af9dbb$var$BufferedItem(serializedMessage, this._totalMessageCount, backpressurePromiseResolver, backpressurePromiseRejector));
        }
        try {
            // If this is set it means we are reconnecting or resending
            // We don't want to send on a disconnected connection
            // And we don't want to send if resend is running since that would mean sending
            // this message twice
            if (!this._reconnectInProgress) await this._connection.send(serializedMessage);
        } catch  {
            this._disconnected();
        }
        await backpressurePromise;
    }
    _ack(ackMessage) {
        let newestAckedMessage = -1;
        // Find index of newest message being acked
        for(let index = 0; index < this._messages.length; index++){
            const element = this._messages[index];
            if (element._id <= ackMessage.sequenceId) {
                newestAckedMessage = index;
                if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(element._message)) this._bufferedByteCount -= element._message.byteLength;
                else this._bufferedByteCount -= element._message.length;
                // resolve items that have already been sent and acked
                element._resolver();
            } else if (this._bufferedByteCount < this._bufferSize) // resolve items that now fall under the buffer limit but haven't been acked
            element._resolver();
            else break;
        }
        if (newestAckedMessage !== -1) // We're removing everything including the message pointed to, so add 1
        this._messages = this._messages.slice(newestAckedMessage + 1);
    }
    _shouldProcessMessage(message) {
        if (this._waitForSequenceMessage) {
            if (message.type !== (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence) return false;
            else {
                this._waitForSequenceMessage = false;
                return true;
            }
        }
        // No special processing for acks, pings, etc.
        if (!this._isInvocationMessage(message)) return true;
        const currentId = this._nextReceivingSequenceId;
        this._nextReceivingSequenceId++;
        if (currentId <= this._latestReceivedSequenceId) {
            if (currentId === this._latestReceivedSequenceId) // Should only hit this if we just reconnected and the server is sending
            // Messages it has buffered, which would mean it hasn't seen an Ack for these messages
            this._ackTimer();
            // Ignore, this is a duplicate message
            return false;
        }
        this._latestReceivedSequenceId = currentId;
        // Only start the timer for sending an Ack message when we have a message to ack. This also conveniently solves
        // timer throttling by not having a recursive timer, and by starting the timer via a network call (recv)
        this._ackTimer();
        return true;
    }
    _resetSequence(message) {
        if (message.sequenceId > this._nextReceivingSequenceId) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
            return;
        }
        this._nextReceivingSequenceId = message.sequenceId;
    }
    _disconnected() {
        this._reconnectInProgress = true;
        this._waitForSequenceMessage = true;
    }
    async _resend() {
        const sequenceId = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
        await this._connection.send(this._protocol.writeMessage({
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence,
            sequenceId: sequenceId
        }));
        // Get a local variable to the _messages, just in case messages are acked while resending
        // Which would slice the _messages array (which creates a new copy)
        const messages = this._messages;
        for (const element of messages)await this._connection.send(element._message);
        this._reconnectInProgress = false;
    }
    _dispose(error) {
        error !== null && error !== void 0 ? error : error = new Error("Unable to reconnect to server.");
        // Unblock backpressure if any
        for (const element of this._messages)element._rejector(error);
    }
    _isInvocationMessage(message) {
        // There is no way to check if something implements an interface.
        // So we individually check the messages in a switch statement.
        // To make sure we don't miss any message types we rely on the compiler
        // seeing the function returns a value and it will do the
        // exhaustive check for us on the switch statement, since we don't use 'case default'
        switch(message.type){
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamItem:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamInvocation:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).CancelInvocation:
                return true;
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Close:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ping:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ack:
                return false;
        }
    }
    _ackTimer() {
        if (this._ackTimerHandle === undefined) this._ackTimerHandle = setTimeout(async ()=>{
            try {
                if (!this._reconnectInProgress) await this._connection.send(this._protocol.writeMessage({
                    type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ack,
                    sequenceId: this._latestReceivedSequenceId
                }));
            // Ignore errors, that means the connection is closed and we don't care about the Ack message anymore.
            } catch  {}
            clearTimeout(this._ackTimerHandle);
            this._ackTimerHandle = undefined;
        // 1 second delay so we don't spam Ack messages if there are many messages being received at once.
        }, 1000);
    }
}
class $b8f262c250af9dbb$var$BufferedItem {
    constructor(message, id, resolver, rejector){
        this._message = message;
        this._id = id;
        this._resolver = resolver;
        this._rejector = rejector;
    }
}


const $abdc410ed994728b$var$DEFAULT_TIMEOUT_IN_MS = 30000;
const $abdc410ed994728b$var$DEFAULT_PING_INTERVAL_IN_MS = 15000;
const $abdc410ed994728b$var$DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE = 100000;
var $abdc410ed994728b$export$b8b4168ab851a6c3;
(function(HubConnectionState) {
    /** The hub connection is disconnected. */ HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */ HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */ HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */ HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */ HubConnectionState["Reconnecting"] = "Reconnecting";
})($abdc410ed994728b$export$b8b4168ab851a6c3 || ($abdc410ed994728b$export$b8b4168ab851a6c3 = {}));
class $abdc410ed994728b$export$e5dbe756ed73e8c8 {
    /** @internal */ // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    static create(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize) {
        return new $abdc410ed994728b$export$e5dbe756ed73e8c8(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize);
    }
    constructor(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize){
        this._nextKeepAlive = 0;
        this._freezeEventListener = ()=>{
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
        };
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(connection, "connection");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(logger, "logger");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = serverTimeoutInMilliseconds !== null && serverTimeoutInMilliseconds !== void 0 ? serverTimeoutInMilliseconds : $abdc410ed994728b$var$DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = keepAliveIntervalInMilliseconds !== null && keepAliveIntervalInMilliseconds !== void 0 ? keepAliveIntervalInMilliseconds : $abdc410ed994728b$var$DEFAULT_PING_INTERVAL_IN_MS;
        this._statefulReconnectBufferSize = statefulReconnectBufferSize !== null && statefulReconnectBufferSize !== void 0 ? statefulReconnectBufferSize : $abdc410ed994728b$var$DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE;
        this._logger = logger;
        this._protocol = protocol;
        this.connection = connection;
        this._reconnectPolicy = reconnectPolicy;
        this._handshakeProtocol = new (0, $60dd2bca4d6878db$export$b23df48528d3f5f4)();
        this.connection.onreceive = (data)=>this._processIncomingData(data);
        this.connection.onclose = (error)=>this._connectionClosed(error);
        this._callbacks = {};
        this._methods = {};
        this._closedCallbacks = [];
        this._reconnectingCallbacks = [];
        this._reconnectedCallbacks = [];
        this._invocationId = 0;
        this._receivedHandshakeResponse = false;
        this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected;
        this._connectionStarted = false;
        this._cachedPingMessage = this._protocol.writeMessage({
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ping
        });
    }
    /** Indicates the state of the {@link HubConnection} to the server. */ get state() {
        return this._connectionState;
    }
    /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
     *  in the disconnected state or if the negotiation step was skipped.
     */ get connectionId() {
        return this.connection ? this.connection.connectionId || null : null;
    }
    /** Indicates the url of the {@link HubConnection} to the server. */ get baseUrl() {
        return this.connection.baseUrl || "";
    }
    /**
     * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
     * Reconnecting states.
     * @param {string} url The url to connect to.
     */ set baseUrl(url) {
        if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected && this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting) throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
        if (!url) throw new Error("The HubConnection url must be a valid url.");
        this.connection.baseUrl = url;
    }
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */ start() {
        this._startPromise = this._startWithStateTransitions();
        return this._startPromise;
    }
    async _startWithStateTransitions() {
        if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected) return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
        this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Connecting;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Starting HubConnection.");
        try {
            await this._startInternal();
            if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isBrowser) // Log when the browser freezes the tab so users know why their connection unexpectedly stopped working
            window.document.addEventListener("freeze", this._freezeEventListener);
            this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Connected;
            this._connectionStarted = true;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "HubConnection connected successfully.");
        } catch (e) {
            this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `HubConnection failed to start successfully because of error '${e}'.`);
            return Promise.reject(e);
        }
    }
    async _startInternal() {
        this._stopDuringStartError = undefined;
        this._receivedHandshakeResponse = false;
        // Set up the promise before any connection is (re)started otherwise it could race with received messages
        const handshakePromise = new Promise((resolve, reject)=>{
            this._handshakeResolver = resolve;
            this._handshakeRejecter = reject;
        });
        await this.connection.start(this._protocol.transferFormat);
        try {
            let version = this._protocol.version;
            if (!this.connection.features.reconnect) // Stateful Reconnect starts with HubProtocol version 2, newer clients connecting to older servers will fail to connect due to
            // the handshake only supporting version 1, so we will try to send version 1 during the handshake to keep old servers working.
            version = 1;
            const handshakeRequest = {
                protocol: this._protocol.name,
                version: version
            };
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Sending handshake request.");
            await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(handshakeRequest));
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Using HubProtocol '${this._protocol.name}'.`);
            // defensively cleanup timeout in case we receive a message from the server before we finish start
            this._cleanupTimeout();
            this._resetTimeoutPeriod();
            this._resetKeepAliveInterval();
            await handshakePromise;
            // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
            // being rejected on close, because this continuation can run after both the handshake completed successfully
            // and the connection was closed.
            if (this._stopDuringStartError) // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
            // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
            // will cause the calling continuation to get scheduled to run later.
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            throw this._stopDuringStartError;
            const useStatefulReconnect = this.connection.features.reconnect || false;
            if (useStatefulReconnect) {
                this._messageBuffer = new (0, $b8f262c250af9dbb$export$9d24a0f7b61acd07)(this._protocol, this.connection, this._statefulReconnectBufferSize);
                this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer);
                this.connection.features.resend = ()=>{
                    if (this._messageBuffer) return this._messageBuffer._resend();
                };
            }
            if (!this.connection.features.inherentKeepAlive) await this._sendMessage(this._cachedPingMessage);
        } catch (e) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`);
            this._cleanupTimeout();
            this._cleanupPingTimer();
            // HttpConnection.stop() should not complete until after the onclose callback is invoked.
            // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
            await this.connection.stop(e);
            throw e;
        }
    }
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */ async stop() {
        // Capture the start promise before the connection might be restarted in an onclose callback.
        const startPromise = this._startPromise;
        this.connection.features.reconnect = false;
        this._stopPromise = this._stopInternal();
        await this._stopPromise;
        try {
            // Awaiting undefined continues immediately
            await startPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
    }
    _stopInternal(error) {
        if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HubConnection.stop(${error}) ignored because it is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnecting) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        const state = this._connectionState;
        this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnecting;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Stopping HubConnection.");
        if (this._reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this._reconnectDelayHandle);
            this._reconnectDelayHandle = undefined;
            this._completeClose();
            return Promise.resolve();
        }
        if (state === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendCloseMessage();
        this._cleanupTimeout();
        this._cleanupPingTimer();
        this._stopDuringStartError = error || new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    }
    async _sendCloseMessage() {
        try {
            await this._sendWithProtocol(this._createCloseMessage());
        } catch  {
        // Ignore, this is a best effort attempt to let the server know the client closed gracefully.
        }
    }
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */ stream(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createStreamInvocation(methodName, args, streamIds);
        // eslint-disable-next-line prefer-const
        let promiseQueue;
        const subject = new (0, $82e59eaf686a40c1$export$b6bbab5a9b109038)();
        subject.cancelCallback = ()=>{
            const cancelInvocation = this._createCancelInvocation(invocationDescriptor.invocationId);
            delete this._callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(()=>{
                return this._sendWithProtocol(cancelInvocation);
            });
        };
        this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
            if (error) {
                subject.error(error);
                return;
            } else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion) {
                    if (invocationEvent.error) subject.error(new Error(invocationEvent.error));
                    else subject.complete();
                } else subject.next(invocationEvent.item);
            }
        };
        promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
            subject.error(e);
            delete this._callbacks[invocationDescriptor.invocationId];
        });
        this._launchStreams(streams, promiseQueue);
        return subject;
    }
    _sendMessage(message) {
        this._resetKeepAliveInterval();
        return this.connection.send(message);
    }
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */ _sendWithProtocol(message) {
        if (this._messageBuffer) return this._messageBuffer._send(message);
        else return this._sendMessage(this._protocol.writeMessage(message));
    }
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */ send(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const sendPromise = this._sendWithProtocol(this._createInvocation(methodName, args, true, streamIds));
        this._launchStreams(streams, sendPromise);
        return sendPromise;
    }
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */ invoke(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createInvocation(methodName, args, false, streamIds);
        const p = new Promise((resolve, reject)=>{
            // invocationId will always have a value for a non-blocking invocation
            this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
                if (error) {
                    reject(error);
                    return;
                } else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion) {
                        if (invocationEvent.error) reject(new Error(invocationEvent.error));
                        else resolve(invocationEvent.result);
                    } else reject(new Error(`Unexpected message type: ${invocationEvent.type}`));
                }
            };
            const promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete this._callbacks[invocationDescriptor.invocationId];
            });
            this._launchStreams(streams, promiseQueue);
        });
        return p;
    }
    on(methodName, newMethod) {
        if (!methodName || !newMethod) return;
        methodName = methodName.toLowerCase();
        if (!this._methods[methodName]) this._methods[methodName] = [];
        // Preventing adding the same handler multiple times.
        if (this._methods[methodName].indexOf(newMethod) !== -1) return;
        this._methods[methodName].push(newMethod);
    }
    off(methodName, method) {
        if (!methodName) return;
        methodName = methodName.toLowerCase();
        const handlers = this._methods[methodName];
        if (!handlers) return;
        if (method) {
            const removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) delete this._methods[methodName];
            }
        } else delete this._methods[methodName];
    }
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */ onclose(callback) {
        if (callback) this._closedCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */ onreconnecting(callback) {
        if (callback) this._reconnectingCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */ onreconnected(callback) {
        if (callback) this._reconnectedCallbacks.push(callback);
    }
    _processIncomingData(data) {
        this._cleanupTimeout();
        if (!this._receivedHandshakeResponse) {
            data = this._processHandshakeResponse(data);
            this._receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            const messages = this._protocol.parseMessages(data, this._logger);
            for (const message of messages){
                if (this._messageBuffer && !this._messageBuffer._shouldProcessMessage(message)) continue;
                switch(message.type){
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation:
                        this._invokeClientMethod(message).catch((e)=>{
                            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Invoke client method threw error: ${(0, $32bb29965a07731e$export$375b49718dbd9ced)(e)}`);
                        });
                        break;
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamItem:
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion:
                        {
                            const callback = this._callbacks[message.invocationId];
                            if (callback) {
                                if (message.type === (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion) delete this._callbacks[message.invocationId];
                                try {
                                    callback(message);
                                } catch (e) {
                                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Stream callback threw error: ${(0, $32bb29965a07731e$export$375b49718dbd9ced)(e)}`);
                                }
                            }
                            break;
                        }
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ping:
                        break;
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Close:
                        {
                            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "Close message received from server.");
                            const error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                            if (message.allowReconnect === true) // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                            // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            this.connection.stop(error);
                            else // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                            this._stopPromise = this._stopInternal(error);
                            break;
                        }
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ack:
                        if (this._messageBuffer) this._messageBuffer._ack(message);
                        break;
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence:
                        if (this._messageBuffer) this._messageBuffer._resetSequence(message);
                        break;
                    default:
                        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Invalid message type: ${message.type}.`);
                        break;
                }
            }
        }
        this._resetTimeoutPeriod();
    }
    _processHandshakeResponse(data) {
        let responseMessage;
        let remainingData;
        try {
            [remainingData, responseMessage] = this._handshakeProtocol.parseHandshakeResponse(data);
        } catch (e) {
            const message = "Error parsing handshake response: " + e;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            const message = "Server returned handshake error: " + responseMessage.error;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        } else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Server handshake complete.");
        this._handshakeResolver();
        return remainingData;
    }
    _resetKeepAliveInterval() {
        if (this.connection.features.inherentKeepAlive) return;
        // Set the time we want the next keep alive to be sent
        // Timer will be setup on next message receive
        this._nextKeepAlive = new Date().getTime() + this.keepAliveIntervalInMilliseconds;
        this._cleanupPingTimer();
    }
    _resetTimeoutPeriod() {
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this._timeoutHandle = setTimeout(()=>this.serverTimeout(), this.serverTimeoutInMilliseconds);
            // Immediately fire Keep-Alive ping if nextPing is overdue to avoid dependency on JS timers
            let nextPing = this._nextKeepAlive - new Date().getTime();
            if (nextPing < 0) {
                if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._trySendPingMessage();
                return;
            }
            // Set keepAlive timer if there isn't one
            if (this._pingServerHandle === undefined) {
                if (nextPing < 0) nextPing = 0;
                // The timer needs to be set from a networking callback to avoid Chrome timer throttling from causing timers to run once a minute
                this._pingServerHandle = setTimeout(async ()=>{
                    if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected) await this._trySendPingMessage();
                }, nextPing);
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    serverTimeout() {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    }
    async _invokeClientMethod(invocationMessage) {
        const methodName = invocationMessage.target.toLowerCase();
        const methods = this._methods[methodName];
        if (!methods) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `No client method with the name '${methodName}' found.`);
            // No handlers provided by client but the server is expecting a response still, so we send an error
            if (invocationMessage.invocationId) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                await this._sendWithProtocol(this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null));
            }
            return;
        }
        // Avoid issues with handlers removing themselves thus modifying the list while iterating through it
        const methodsCopy = methods.slice();
        // Server expects a response
        const expectsResponse = invocationMessage.invocationId ? true : false;
        // We preserve the last result or exception but still call all handlers
        let res;
        let exception;
        let completionMessage;
        for (const m of methodsCopy)try {
            const prevRes = res;
            res = await m.apply(this, invocationMessage.arguments);
            if (expectsResponse && res && prevRes) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Multiple results provided for '${methodName}'. Sending error to server.`);
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `Client provided multiple results.`, null);
            }
            // Ignore exception if we got a result after, the exception will be logged
            exception = undefined;
        } catch (e) {
            exception = e;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `A callback for the method '${methodName}' threw error '${e}'.`);
        }
        if (completionMessage) await this._sendWithProtocol(completionMessage);
        else if (expectsResponse) {
            // If there is an exception that means either no result was given or a handler after a result threw
            if (exception) completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `${exception}`, null);
            else if (res !== undefined) completionMessage = this._createCompletionMessage(invocationMessage.invocationId, null, res);
            else {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                // Client didn't provide a result or throw from a handler, server expects a response so we send an error
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null);
            }
            await this._sendWithProtocol(completionMessage);
        } else if (res) this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Result given for '${methodName}' method but server is not expecting a result.`);
    }
    _connectionClosed(error) {
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `HubConnection.connectionClosed(${error}) called while in state ${this._connectionState}.`);
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this._stopDuringStartError = this._stopDuringStartError || error || new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this._handshakeResolver) this._handshakeResolver();
        this._cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this._cleanupTimeout();
        this._cleanupPingTimer();
        if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnecting) this._completeClose(error);
        else if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected && this._reconnectPolicy) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._reconnect(error);
        else if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected) this._completeClose(error);
    // If none of the above if conditions were true were called the HubConnection must be in either:
    // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
    // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
    //    and potentially continue the reconnect() loop.
    // 3. The Disconnected state in which case we're already done.
    }
    _completeClose(error) {
        if (this._connectionStarted) {
            this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected;
            this._connectionStarted = false;
            if (this._messageBuffer) {
                this._messageBuffer._dispose(error !== null && error !== void 0 ? error : new Error("Connection closed."));
                this._messageBuffer = undefined;
            }
            if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isBrowser) window.document.removeEventListener("freeze", this._freezeEventListener);
            try {
                this._closedCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `An onclose callback called with error '${error}' threw error '${e}'.`);
            }
        }
    }
    async _reconnect(error) {
        const reconnectStartTime = Date.now();
        let previousReconnectAttempts = 0;
        let retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
        let nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts, 0, retryError);
        if (nextRetryDelay === null) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
            this._completeClose(error);
            return;
        }
        this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting;
        if (error) this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Connection reconnecting because of error '${error}'.`);
        else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "Connection reconnecting.");
        if (this._reconnectingCallbacks.length !== 0) {
            try {
                this._reconnectingCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `An onreconnecting callback called with error '${error}' threw error '${e}'.`);
            }
            // Exit early if an onreconnecting callback called connection.stop().
            if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                return;
            }
        }
        while(nextRetryDelay !== null){
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Reconnect attempt number ${previousReconnectAttempts + 1} will start in ${nextRetryDelay} ms.`);
            await new Promise((resolve)=>{
                this._reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
            });
            this._reconnectDelayHandle = undefined;
            if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                return;
            }
            try {
                await this._startInternal();
                this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Connected;
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "HubConnection reconnected successfully.");
                if (this._reconnectedCallbacks.length !== 0) try {
                    this._reconnectedCallbacks.forEach((c)=>c.apply(this, [
                            this.connection.connectionId
                        ]));
                } catch (e) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${e}'.`);
                }
                return;
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Reconnect attempt failed because of error '${e}'.`);
                if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`);
                    // The TypeScript compiler thinks that connectionState must be Connected here. The TypeScript compiler is wrong.
                    if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnecting) this._completeClose();
                    return;
                }
                previousReconnectAttempts++;
                retryError = e instanceof Error ? e : new Error(e.toString());
                nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts, Date.now() - reconnectStartTime, retryError);
            }
        }
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Reconnect retries have been exhausted after ${Date.now() - reconnectStartTime} ms and ${previousReconnectAttempts} failed attempts. Connection disconnecting.`);
        this._completeClose();
    }
    _getNextRetryDelay(previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this._reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds: elapsedMilliseconds,
                previousRetryCount: previousRetryCount,
                retryReason: retryReason
            });
        } catch (e) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${previousRetryCount}, ${elapsedMilliseconds}) threw error '${e}'.`);
            return null;
        }
    }
    _cancelCallbacksWithError(error) {
        const callbacks = this._callbacks;
        this._callbacks = {};
        Object.keys(callbacks).forEach((key)=>{
            const callback = callbacks[key];
            try {
                callback(null, error);
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Stream 'error' callback called with '${error}' threw error: ${(0, $32bb29965a07731e$export$375b49718dbd9ced)(e)}`);
            }
        });
    }
    _cleanupPingTimer() {
        if (this._pingServerHandle) {
            clearTimeout(this._pingServerHandle);
            this._pingServerHandle = undefined;
        }
    }
    _cleanupTimeout() {
        if (this._timeoutHandle) clearTimeout(this._timeoutHandle);
    }
    _createInvocation(methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            if (streamIds.length !== 0) return {
                target: methodName,
                arguments: args,
                streamIds: streamIds,
                type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation
            };
            else return {
                target: methodName,
                arguments: args,
                type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation
            };
        } else {
            const invocationId = this._invocationId;
            this._invocationId++;
            if (streamIds.length !== 0) return {
                target: methodName,
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds: streamIds,
                type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation
            };
            else return {
                target: methodName,
                arguments: args,
                invocationId: invocationId.toString(),
                type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation
            };
        }
    }
    _launchStreams(streams, promiseQueue) {
        if (streams.length === 0) return;
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) promiseQueue = Promise.resolve();
        // We want to iterate over the keys, since the keys are the stream ids
        // eslint-disable-next-line guard-for-in
        for(const streamId in streams)streams[streamId].subscribe({
            complete: ()=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId)));
            },
            error: (err)=>{
                let message;
                if (err instanceof Error) message = err.message;
                else if (err && err.toString) message = err.toString();
                else message = "Unknown error";
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId, message)));
            },
            next: (item)=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createStreamItemMessage(streamId, item)));
            }
        });
    }
    _replaceStreamingParams(args) {
        const streams = [];
        const streamIds = [];
        for(let i = 0; i < args.length; i++){
            const argument = args[i];
            if (this._isObservable(argument)) {
                const streamId = this._invocationId;
                this._invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [
            streams,
            streamIds
        ];
    }
    _isObservable(arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    }
    _createStreamInvocation(methodName, args, streamIds) {
        const invocationId = this._invocationId;
        this._invocationId++;
        if (streamIds.length !== 0) return {
            target: methodName,
            arguments: args,
            invocationId: invocationId.toString(),
            streamIds: streamIds,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamInvocation
        };
        else return {
            target: methodName,
            arguments: args,
            invocationId: invocationId.toString(),
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamInvocation
        };
    }
    _createCancelInvocation(id) {
        return {
            invocationId: id,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).CancelInvocation
        };
    }
    _createStreamItemMessage(id, item) {
        return {
            invocationId: id,
            item: item,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamItem
        };
    }
    _createCompletionMessage(id, error, result) {
        if (error) return {
            error: error,
            invocationId: id,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion
        };
        return {
            invocationId: id,
            result: result,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion
        };
    }
    _createCloseMessage() {
        return {
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Close
        };
    }
    async _trySendPingMessage() {
        try {
            await this._sendMessage(this._cachedPingMessage);
        } catch  {
            // We don't care about the error. It should be seen elsewhere in the client.
            // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
            this._cleanupPingTimer();
        }
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.





const $b090a650b4fba31d$var$JSON_HUB_PROTOCOL_NAME = "json";
class $b090a650b4fba31d$export$11f4f8ecec1ad0c8 {
    constructor(){
        /** @inheritDoc */ this.name = $b090a650b4fba31d$var$JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */ this.version = 2;
        /** @inheritDoc */ this.transferFormat = (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */ parseMessages(input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        if (!input) return [];
        if (logger === null) logger = (0, $b632327c1843227b$export$17ac58a1138ded46).instance;
        // Parse the messages
        const messages = (0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).parse(input);
        const hubMessages = [];
        for (const message of messages){
            const parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") throw new Error("Invalid payload.");
            switch(parsedMessage.type){
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation:
                    this._isInvocationMessage(parsedMessage);
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamItem:
                    this._isStreamItemMessage(parsedMessage);
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion:
                    this._isCompletionMessage(parsedMessage);
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ping:
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Close:
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ack:
                    this._isAckMessage(parsedMessage);
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence:
                    this._isSequenceMessage(parsedMessage);
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    }
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */ writeMessage(message) {
        return (0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).write(JSON.stringify(message));
    }
    _isInvocationMessage(message) {
        this._assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) this._assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
    }
    _isStreamItemMessage(message) {
        this._assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) throw new Error("Invalid payload for StreamItem message.");
    }
    _isCompletionMessage(message) {
        if (message.result && message.error) throw new Error("Invalid payload for Completion message.");
        if (!message.result && message.error) this._assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        this._assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    }
    _isAckMessage(message) {
        if (typeof message.sequenceId !== 'number') throw new Error("Invalid SequenceId for Ack message.");
    }
    _isSequenceMessage(message) {
        if (typeof message.sequenceId !== 'number') throw new Error("Invalid SequenceId for Sequence message.");
    }
    _assertNotEmptyString(value, errorMessage) {
        if (typeof value !== "string" || value === "") throw new Error(errorMessage);
    }
}




const $cccc8edc49e3facc$var$LogLevelNameMapping = {
    trace: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace,
    debug: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug,
    info: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information,
    information: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information,
    warn: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning,
    warning: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning,
    error: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error,
    critical: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Critical,
    none: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).None
};
function $cccc8edc49e3facc$var$parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    const mapping = $cccc8edc49e3facc$var$LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") return mapping;
    else throw new Error(`Unknown log level: ${name}`);
}
class $cccc8edc49e3facc$export$afccb10c24910b13 {
    configureLogging(logging) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(logging, "logging");
        if ($cccc8edc49e3facc$var$isLogger(logging)) this.logger = logging;
        else if (typeof logging === "string") {
            const logLevel = $cccc8edc49e3facc$var$parseLogLevel(logging);
            this.logger = new (0, $32bb29965a07731e$export$ba6a9c7ac8291f7f)(logLevel);
        } else this.logger = new (0, $32bb29965a07731e$export$ba6a9c7ac8291f7f)(logging);
        return this;
    }
    withUrl(url, transportTypeOrOptions) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isNotEmpty(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            ...transportTypeOrOptions
        };
        else this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            transport: transportTypeOrOptions
        };
        return this;
    }
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */ withHubProtocol(protocol) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    }
    withAutomaticReconnect(retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) throw new Error("A reconnectPolicy has already been set.");
        if (!retryDelaysOrReconnectPolicy) this.reconnectPolicy = new (0, $a70d4a2704acd148$export$97bc471d6a059e6e)();
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) this.reconnectPolicy = new (0, $a70d4a2704acd148$export$97bc471d6a059e6e)(retryDelaysOrReconnectPolicy);
        else this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withServerTimeout(milliseconds) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(milliseconds, "milliseconds");
        this._serverTimeoutInMilliseconds = milliseconds;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withKeepAliveInterval(milliseconds) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(milliseconds, "milliseconds");
        this._keepAliveIntervalInMilliseconds = milliseconds;
        return this;
    }
    /** Enables and configures options for the Stateful Reconnect feature.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withStatefulReconnect(options) {
        if (this.httpConnectionOptions === undefined) this.httpConnectionOptions = {};
        this.httpConnectionOptions._useStatefulReconnect = true;
        this._statefulReconnectBufferSize = options === null || options === void 0 ? void 0 : options.bufferSize;
        return this;
    }
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */ build() {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        const httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
        httpConnectionOptions.logger = this.logger;
        // Now create the connection
        if (!this.url) throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        const connection = new (0, $73b6b78c950d1272$export$13c1f9cf8a283575)(this.url, httpConnectionOptions);
        return (0, $abdc410ed994728b$export$e5dbe756ed73e8c8).create(connection, this.logger || (0, $b632327c1843227b$export$17ac58a1138ded46).instance, this.protocol || new (0, $b090a650b4fba31d$export$11f4f8ecec1ad0c8)(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
    }
}
function $cccc8edc49e3facc$var$isLogger(logger) {
    return logger.log !== undefined;
}



var $4oKKP = parcelRequire("4oKKP");
/* eslint-disable promise/prefer-await-to-then */ const $0fb704a73fce4e36$var$methodMap = [
    [
        'requestFullscreen',
        'exitFullscreen',
        'fullscreenElement',
        'fullscreenEnabled',
        'fullscreenchange',
        'fullscreenerror'
    ],
    // New WebKit
    [
        'webkitRequestFullscreen',
        'webkitExitFullscreen',
        'webkitFullscreenElement',
        'webkitFullscreenEnabled',
        'webkitfullscreenchange',
        'webkitfullscreenerror'
    ],
    // Old WebKit
    [
        'webkitRequestFullScreen',
        'webkitCancelFullScreen',
        'webkitCurrentFullScreenElement',
        'webkitCancelFullScreen',
        'webkitfullscreenchange',
        'webkitfullscreenerror'
    ],
    [
        'mozRequestFullScreen',
        'mozCancelFullScreen',
        'mozFullScreenElement',
        'mozFullScreenEnabled',
        'mozfullscreenchange',
        'mozfullscreenerror'
    ],
    [
        'msRequestFullscreen',
        'msExitFullscreen',
        'msFullscreenElement',
        'msFullscreenEnabled',
        'MSFullscreenChange',
        'MSFullscreenError'
    ]
];
const $0fb704a73fce4e36$var$nativeAPI = (()=>{
    if (typeof document === 'undefined') return false;
    const unprefixedMethods = $0fb704a73fce4e36$var$methodMap[0];
    const returnValue = {};
    for (const methodList of $0fb704a73fce4e36$var$methodMap){
        const exitFullscreenMethod = methodList?.[1];
        if (exitFullscreenMethod in document) {
            for (const [index, method] of methodList.entries())returnValue[unprefixedMethods[index]] = method;
            return returnValue;
        }
    }
    return false;
})();
const $0fb704a73fce4e36$var$eventNameMap = {
    change: $0fb704a73fce4e36$var$nativeAPI.fullscreenchange,
    error: $0fb704a73fce4e36$var$nativeAPI.fullscreenerror
};
// eslint-disable-next-line import/no-mutable-exports
let $0fb704a73fce4e36$var$screenfull = {
    // eslint-disable-next-line default-param-last
    request (element = document.documentElement, options) {
        return new Promise((resolve, reject)=>{
            const onFullScreenEntered = ()=>{
                $0fb704a73fce4e36$var$screenfull.off('change', onFullScreenEntered);
                resolve();
            };
            $0fb704a73fce4e36$var$screenfull.on('change', onFullScreenEntered);
            const returnPromise = element[$0fb704a73fce4e36$var$nativeAPI.requestFullscreen](options);
            if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
        });
    },
    exit () {
        return new Promise((resolve, reject)=>{
            if (!$0fb704a73fce4e36$var$screenfull.isFullscreen) {
                resolve();
                return;
            }
            const onFullScreenExit = ()=>{
                $0fb704a73fce4e36$var$screenfull.off('change', onFullScreenExit);
                resolve();
            };
            $0fb704a73fce4e36$var$screenfull.on('change', onFullScreenExit);
            const returnPromise = document[$0fb704a73fce4e36$var$nativeAPI.exitFullscreen]();
            if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
        });
    },
    toggle (element, options) {
        return $0fb704a73fce4e36$var$screenfull.isFullscreen ? $0fb704a73fce4e36$var$screenfull.exit() : $0fb704a73fce4e36$var$screenfull.request(element, options);
    },
    onchange (callback) {
        $0fb704a73fce4e36$var$screenfull.on('change', callback);
    },
    onerror (callback) {
        $0fb704a73fce4e36$var$screenfull.on('error', callback);
    },
    on (event, callback) {
        const eventName = $0fb704a73fce4e36$var$eventNameMap[event];
        if (eventName) document.addEventListener(eventName, callback, false);
    },
    off (event, callback) {
        const eventName = $0fb704a73fce4e36$var$eventNameMap[event];
        if (eventName) document.removeEventListener(eventName, callback, false);
    },
    raw: $0fb704a73fce4e36$var$nativeAPI
};
Object.defineProperties($0fb704a73fce4e36$var$screenfull, {
    isFullscreen: {
        get: ()=>Boolean(document[$0fb704a73fce4e36$var$nativeAPI.fullscreenElement])
    },
    element: {
        enumerable: true,
        get: ()=>document[$0fb704a73fce4e36$var$nativeAPI.fullscreenElement] ?? undefined
    },
    isEnabled: {
        enumerable: true,
        // Coerce to boolean in case of old WebKit.
        get: ()=>Boolean(document[$0fb704a73fce4e36$var$nativeAPI.fullscreenEnabled])
    }
});
if (!$0fb704a73fce4e36$var$nativeAPI) $0fb704a73fce4e36$var$screenfull = {
    isEnabled: false
};
var $0fb704a73fce4e36$export$2e2bcd8739ae039 = $0fb704a73fce4e36$var$screenfull;



var $b073ace211e07ca5$exports = {};
$b073ace211e07ca5$exports = "precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aPosition;\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform vec2 texelSize;\n\nvoid main () {\n    vUv = aPosition * 0.5 + 0.5;\n    vL = vUv - vec2(texelSize.x, 0.0);\n    vR = vUv + vec2(texelSize.x, 0.0);\n    vT = vUv + vec2(0.0, texelSize.y);\n    vB = vUv - vec2(0.0, texelSize.y);\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}\n";


var $af22a45ee2cf3058$exports = {};
$af22a45ee2cf3058$exports = "precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aPosition;\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nuniform vec2 texelSize;\n\nvoid main () {\n    vUv = aPosition * 0.5 + 0.5;\n    float offset = 1.33333333;\n    vL = vUv - texelSize * offset;\n    vR = vUv + texelSize * offset;\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}\n";


var $9fe15e68bee46b24$exports = {};
$9fe15e68bee46b24$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nuniform sampler2D uTexture;\n\nvoid main () {\n    vec4 sum = texture2D(uTexture, vUv) * 0.29411764;\n    sum += texture2D(uTexture, vL) * 0.35294117;\n    sum += texture2D(uTexture, vR) * 0.35294117;\n    gl_FragColor = sum;\n}\n";


var $b2937d4c01081df9$exports = {};
$b2937d4c01081df9$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nuniform sampler2D uTexture;\n\nvoid main () {\n    gl_FragColor = texture2D(uTexture, vUv);\n}\n";


var $719ba1830217732e$exports = {};
$719ba1830217732e$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nuniform sampler2D uTexture;\nuniform float value;\n\nvoid main () {\n    gl_FragColor = value * texture2D(uTexture, vUv);\n}\n";


var $73744113a8abb7e1$exports = {};
$73744113a8abb7e1$exports = "precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main () {\n    gl_FragColor = color;\n}\n";


var $abb988efd69fa6f6$exports = {};
$abb988efd69fa6f6$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTexture;\nuniform float aspectRatio;\n\n#define SCALE 25.0\n\nvoid main () {\n    vec2 uv = floor(vUv * SCALE * vec2(aspectRatio, 1.0));\n    float v = mod(uv.x + uv.y, 2.0);\n    v = v * 0.1 + 0.8;\n    gl_FragColor = vec4(vec3(v), 1.0);\n}\n";


var $91e81c3e9c7f71c0$exports = {};
$91e81c3e9c7f71c0$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform sampler2D uTexture;\nuniform sampler2D uBloom;\nuniform sampler2D uSunrays;\nuniform sampler2D uDithering;\nuniform vec2 ditherScale;\nuniform vec2 texelSize;\n\nvec3 linearToGamma (vec3 color) {\n    color = max(color, vec3(0));\n    return max(1.055 * pow(color, vec3(0.416666667)) - 0.055, vec3(0));\n}\n\nvoid main () {\n    vec3 c = texture2D(uTexture, vUv).rgb;\n\n    #ifdef SHADING\n    vec3 lc = texture2D(uTexture, vL).rgb;\n    vec3 rc = texture2D(uTexture, vR).rgb;\n    vec3 tc = texture2D(uTexture, vT).rgb;\n    vec3 bc = texture2D(uTexture, vB).rgb;\n\n    float dx = length(rc) - length(lc);\n    float dy = length(tc) - length(bc);\n\n    vec3 n = normalize(vec3(dx, dy, length(texelSize)));\n    vec3 l = vec3(0.0, 0.0, 1.0);\n\n    float diffuse = clamp(dot(n, l) + 0.7, 0.7, 1.0);\n    c *= diffuse;\n    #endif\n\n    #ifdef BLOOM\n    vec3 bloom = texture2D(uBloom, vUv).rgb;\n    #endif\n\n    #ifdef SUNRAYS\n    float sunrays = texture2D(uSunrays, vUv).r;\n    c *= sunrays;\n    #ifdef BLOOM\n    bloom *= sunrays;\n    #endif\n    #endif\n\n    #ifdef BLOOM\n    float noise = texture2D(uDithering, vUv * ditherScale).r;\n    noise = noise * 2.0 - 1.0;\n    bloom += noise / 255.0;\n    bloom = linearToGamma(bloom);\n    c += bloom;\n    #endif\n\n    float a = max(c.r, max(c.g, c.b));\n    gl_FragColor = vec4(c, a);\n}\n";


var $8f5fcad1063be82d$exports = {};
$8f5fcad1063be82d$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTexture;\nuniform vec3 curve;\nuniform float threshold;\n\nvoid main () {\n    vec3 c = texture2D(uTexture, vUv).rgb;\n    float br = max(c.r, max(c.g, c.b));\n    float rq = clamp(br - curve.x, 0.0, curve.y);\n    rq = curve.z * rq * rq;\n    c *= max(rq, br - threshold) / max(br, 0.0001);\n    gl_FragColor = vec4(c, 0.0);\n}\n";


var $a5ada04d393fb5d7$exports = {};
$a5ada04d393fb5d7$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform sampler2D uTexture;\n\nvoid main () {\n    vec4 sum = vec4(0.0);\n    sum += texture2D(uTexture, vL);\n    sum += texture2D(uTexture, vR);\n    sum += texture2D(uTexture, vT);\n    sum += texture2D(uTexture, vB);\n    sum *= 0.25;\n    gl_FragColor = sum;\n}\n";


var $1ef0e73bcc342f97$exports = {};
$1ef0e73bcc342f97$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform sampler2D uTexture;\nuniform float intensity;\n\nvoid main () {\n    vec4 sum = vec4(0.0);\n    sum += texture2D(uTexture, vL);\n    sum += texture2D(uTexture, vR);\n    sum += texture2D(uTexture, vT);\n    sum += texture2D(uTexture, vB);\n    sum *= 0.25;\n    gl_FragColor = sum * intensity;\n}\n";


var $7a5947680249ab33$exports = {};
$7a5947680249ab33$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTexture;\n\nvoid main () {\n    vec4 c = texture2D(uTexture, vUv);\n    float br = max(c.r, max(c.g, c.b));\n    c.a = 1.0 - min(max(br * 20.0, 0.0), 0.8);\n    gl_FragColor = c;\n}\n";


var $4f387349a228c2dd$exports = {};
$4f387349a228c2dd$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTexture;\nuniform float weight;\n\n#define ITERATIONS 16\n\nvoid main () {\n    float Density = 0.3;\n    float Decay = 0.95;\n    float Exposure = 0.7;\n\n    vec2 coord = vUv;\n    vec2 dir = vUv - 0.5;\n\n    dir *= 1.0 / float(ITERATIONS) * Density;\n    float illuminationDecay = 1.0;\n\n    float color = texture2D(uTexture, vUv).a;\n\n    for (int i = 0; i < ITERATIONS; i++)\n    {\n        coord -= dir;\n        float col = texture2D(uTexture, coord).a;\n        color += col * illuminationDecay * weight;\n        illuminationDecay *= Decay;\n    }\n\n    gl_FragColor = vec4(color * Exposure, 0.0, 0.0, 1.0);\n}\n";


var $3efa16d047bc35ee$exports = {};
$3efa16d047bc35ee$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTarget;\nuniform float aspectRatio;\nuniform vec3 color;\nuniform vec2 point;\nuniform float radius;\n\nvoid main () {\n    vec2 p = vUv - point.xy;\n    p.x *= aspectRatio;\n    vec3 splat = exp(-dot(p, p) / radius) * color;\n    vec3 base = texture2D(uTarget, vUv).xyz;\n    gl_FragColor = vec4(base + splat, 1.0);\n}\n";


var $993d5df17bfe8036$exports = {};
$993d5df17bfe8036$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uVelocity;\nuniform sampler2D uSource;\nuniform vec2 texelSize;\nuniform vec2 dyeTexelSize;\nuniform float dt;\nuniform float dissipation;\n\nvec4 bilerp (sampler2D sam, vec2 uv, vec2 tsize) {\n    vec2 st = uv / tsize - 0.5;\n\n    vec2 iuv = floor(st);\n    vec2 fuv = fract(st);\n\n    vec4 a = texture2D(sam, (iuv + vec2(0.5, 0.5)) * tsize);\n    vec4 b = texture2D(sam, (iuv + vec2(1.5, 0.5)) * tsize);\n    vec4 c = texture2D(sam, (iuv + vec2(0.5, 1.5)) * tsize);\n    vec4 d = texture2D(sam, (iuv + vec2(1.5, 1.5)) * tsize);\n\n    return mix(mix(a, b, fuv.x), mix(c, d, fuv.x), fuv.y);\n}\n\nvoid main () {\n    #ifdef MANUAL_FILTERING\n    vec2 coord = vUv - dt * bilerp(uVelocity, vUv, texelSize).xy * texelSize;\n    vec4 result = bilerp(uSource, coord, dyeTexelSize);\n    #else\n    vec2 coord = vUv - dt * texture2D(uVelocity, vUv).xy * texelSize;\n    vec4 result = texture2D(uSource, coord);\n    #endif\n    float decay = 1.0 + dissipation * dt;\n    gl_FragColor = result / decay;\n}\n";


var $d9cebc9ec9011904$exports = {};
$d9cebc9ec9011904$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nvarying highp vec2 vL;\nvarying highp vec2 vR;\nvarying highp vec2 vT;\nvarying highp vec2 vB;\nuniform sampler2D uVelocity;\n\nvoid main () {\n    float L = texture2D(uVelocity, vL).x;\n    float R = texture2D(uVelocity, vR).x;\n    float T = texture2D(uVelocity, vT).y;\n    float B = texture2D(uVelocity, vB).y;\n\n    vec2 C = texture2D(uVelocity, vUv).xy;\n    if (vL.x < 0.0) { L = -C.x; }\n    if (vR.x > 1.0) { R = -C.x; }\n    if (vT.y > 1.0) { T = -C.y; }\n    if (vB.y < 0.0) { B = -C.y; }\n\n    float div = 0.5 * (R - L + T - B);\n    gl_FragColor = vec4(div, 0.0, 0.0, 1.0);\n}\n";


var $7c890988bafebabf$exports = {};
$7c890988bafebabf$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nvarying highp vec2 vL;\nvarying highp vec2 vR;\nvarying highp vec2 vT;\nvarying highp vec2 vB;\nuniform sampler2D uVelocity;\n\nvoid main () {\n    float L = texture2D(uVelocity, vL).y;\n    float R = texture2D(uVelocity, vR).y;\n    float T = texture2D(uVelocity, vT).x;\n    float B = texture2D(uVelocity, vB).x;\n    float vorticity = R - L - T + B;\n    gl_FragColor = vec4(0.5 * vorticity, 0.0, 0.0, 1.0);\n}\n";


var $70acace40d332cd0$exports = {};
$70acace40d332cd0$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform sampler2D uVelocity;\nuniform sampler2D uCurl;\nuniform float curl;\nuniform float dt;\n\nvoid main () {\n    float L = texture2D(uCurl, vL).x;\n    float R = texture2D(uCurl, vR).x;\n    float T = texture2D(uCurl, vT).x;\n    float B = texture2D(uCurl, vB).x;\n    float C = texture2D(uCurl, vUv).x;\n\n    vec2 force = 0.5 * vec2(abs(T) - abs(B), abs(R) - abs(L));\n    force /= length(force) + 0.0001;\n    force *= curl * C;\n    force.y *= -1.0;\n\n    vec2 vel = texture2D(uVelocity, vUv).xy;\n    gl_FragColor = vec4(vel + force * dt, 0.0, 1.0);\n}\n";


var $6cca967b18c9fc9f$exports = {};
$6cca967b18c9fc9f$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nvarying highp vec2 vL;\nvarying highp vec2 vR;\nvarying highp vec2 vT;\nvarying highp vec2 vB;\nuniform sampler2D uPressure;\nuniform sampler2D uDivergence;\n\nvoid main () {\n    float L = texture2D(uPressure, vL).x;\n    float R = texture2D(uPressure, vR).x;\n    float T = texture2D(uPressure, vT).x;\n    float B = texture2D(uPressure, vB).x;\n    float C = texture2D(uPressure, vUv).x;\n    float divergence = texture2D(uDivergence, vUv).x;\n    float pressure = (L + R + B + T - divergence) * 0.25;\n    gl_FragColor = vec4(pressure, 0.0, 0.0, 1.0);\n}\n";


var $08cd69f8f5a4a380$exports = {};
$08cd69f8f5a4a380$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nvarying highp vec2 vL;\nvarying highp vec2 vR;\nvarying highp vec2 vT;\nvarying highp vec2 vB;\nuniform sampler2D uPressure;\nuniform sampler2D uVelocity;\n\nvoid main () {\n    float L = texture2D(uPressure, vL).x;\n    float R = texture2D(uPressure, vR).x;\n    float T = texture2D(uPressure, vT).x;\n    float B = texture2D(uPressure, vB).x;\n    vec2 velocity = texture2D(uVelocity, vUv).xy;\n    velocity.xy -= vec2(R - L, T - B);\n    gl_FragColor = vec4(velocity, 0.0, 1.0);\n}\n";


var $bd5624bc48e5cdda$exports = {};

$parcel$export($bd5624bc48e5cdda$exports, "name", () => $bd5624bc48e5cdda$export$a8ff84c12d48cfa6);
$parcel$export($bd5624bc48e5cdda$exports, "isSupportedDevice", () => $bd5624bc48e5cdda$export$4067a3e42f64a634);
$parcel$export($bd5624bc48e5cdda$exports, "midiInControlChange", () => $bd5624bc48e5cdda$export$b192a6bb3da44c96);
$parcel$export($bd5624bc48e5cdda$exports, "midiSplatHandler", () => $bd5624bc48e5cdda$export$23ccdb72f86533c);
const $bd5624bc48e5cdda$export$a8ff84c12d48cfa6 = "nanoKontrol2";
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_SOLO = 32;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_SOLO = 33;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_SOLO = 34;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_SOLO = 35;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_SOLO = 36;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_SOLO = 37;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_SOLO = 38;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_SOLO = 39;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_MUTE = 48;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_MUTE = 49;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_MUTE = 50;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_MUTE = 51;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_MUTE = 52;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_MUTE = 53;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_MUTE = 54;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_MUTE = 55;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_RECORD = 64;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_RECORD = 65;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_RECORD = 66;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_RECORD = 67;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_RECORD = 68;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_RECORD = 69;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_RECORD = 70;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_RECORD = 71;
const $bd5624bc48e5cdda$var$nanoKontrol2_slidersGroupButtons = [
    [
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_SOLO
    ],
    [
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_MUTE
    ],
    [
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_RECORD
    ]
];
function $bd5624bc48e5cdda$export$4067a3e42f64a634(manufacturer, name) {
    if (!name) return false;
    return name.toLowerCase().includes("nanokontrol");
}
function $bd5624bc48e5cdda$export$b192a6bb3da44c96(event, config, logger) {
    let understood = false;
    if (event.controller.number === 0) {
        config.SPLAT_FORCE = Math.floor(event.rawValue / 127 * 10000);
        if (config.SPLAT_FORCE === 0) config.SPLAT_FORCE = 0.01;
        logger("SPLAT_FORCE", config.SPLAT_FORCE);
        understood = true;
    }
    if (event.controller.number === 1) {
        config.SPLAT_RADIUS = event.rawValue / 127;
        if (config.SPLAT_RADIUS === 0) config.SPLAT_RADIUS = 0.01;
        logger("SPLAT_RADIUS", config.SPLAT_RADIUS);
        understood = true;
    }
    if (event.controller.number === 2) {
        config.DYE_RESOLUTION = 32 + event.rawValue / 127 * 1024;
        logger("DYE_RESOLUTION", config.DYE_RESOLUTION);
        config.doReinitFramebuffers = true;
        understood = true;
    }
    if (event.controller.number === 3) {
        config.SIM_RESOLUTION = 32 + event.rawValue / 127 * 1024;
        logger("SIM_RESOLUTION", config.SIM_RESOLUTION);
        config.doReinitFramebuffers = true;
        understood = true;
    }
    if (event.controller.number === 4) {
        config.CURL = event.rawValue / 127 * 50;
        logger("CURL", config.CURL);
        understood = true;
    }
    if (event.controller.number === 7) {
        config.PRESSURE = event.rawValue / 127;
        logger("PRESSURE", config.PRESSURE);
        understood = true;
    }
    if (event.controller.number === 16) {
        config.DENSITY_DISSIPATION = (event.rawValue / 127 - 0.5) * 4;
        logger("DENSITY_DISSIPATION", config.DENSITY_DISSIPATION);
        understood = true;
    }
    if (event.controller.number === 17) {
        config.VELOCITY_DISSIPATION = (event.rawValue / 127 - 0.5) * 4;
        logger("VELOCITY_DISSIPATION", config.VELOCITY_DISSIPATION);
        understood = true;
    }
    if (!understood) logger(`Unknown MIDI CC: ${event.controller.number}/${event.rawValue} on '${event.port.name}'`);
    return understood;
}
function $bd5624bc48e5cdda$export$23ccdb72f86533c(port) {
    // reset all the leds to off initially
    $bd5624bc48e5cdda$var$nanoKontrol2_slidersGroupButtons.forEach((rows)=>{
        rows.forEach((button)=>{
            port.sendControlChange(button, 0);
        });
    });
    // return the handler that's invoked on splats
    let splatHook = (x, y, dx, dy, realColor)=>{
        // x goes from 0.00 to 1.00 (left to right)
        let buttonX = Math.ceil((x + 0.00) * 8);
        buttonX = buttonX < 1 ? 1 : buttonX;
        // y goes from 1.00 to 0.00 (top to bottom)
        let buttonY = Math.ceil((1.00 - y) * 3);
        buttonY = buttonY < 1 ? 1 : buttonY;
        // now find the button for that x, y
        let theButton = $bd5624bc48e5cdda$var$nanoKontrol2_slidersGroupButtons[buttonY - 1][buttonX - 1];
        port.sendControlChange(theButton, 127);
        port.sendControlChange(theButton, 0, {
            time: "+500"
        });
    };
    return splatHook;
}


var $6b44a3520a6435e8$exports = {};

$parcel$export($6b44a3520a6435e8$exports, "name", () => $6b44a3520a6435e8$export$a8ff84c12d48cfa6);
$parcel$export($6b44a3520a6435e8$exports, "isSupportedDevice", () => $6b44a3520a6435e8$export$4067a3e42f64a634);
$parcel$export($6b44a3520a6435e8$exports, "midiInNoteOn", () => $6b44a3520a6435e8$export$e00075188492435b);
$parcel$export($6b44a3520a6435e8$exports, "midiInControlChange", () => $6b44a3520a6435e8$export$b192a6bb3da44c96);
const $6b44a3520a6435e8$export$a8ff84c12d48cfa6 = "Traktor";
function $6b44a3520a6435e8$export$4067a3e42f64a634(manufacturer, name) {
    if (!name) return false;
    return name.toLowerCase().includes("traktor");
}
function $6b44a3520a6435e8$export$e00075188492435b(event, config, logger, randomSplatsNow) {
    logger(`Traktor MIDI Note: ${event.note.name} (${event.note.number}) channel ${event.message.channel} on '${event.port.name}'`);
    let numRandomSplats = event.note.number % 10;
    randomSplatsNow(numRandomSplats > 0 ? numRandomSplats : 1);
    return false; // do not broadcast config change.
}
function $6b44a3520a6435e8$export$b192a6bb3da44c96(event, config, logger) {
    let understood = false;
    if (event.controller.number === 42 && event.message.channel === 2) {
        config.SPLAT_FORCE = Math.floor(event.rawValue / 127 * 10000);
        if (config.SPLAT_FORCE === 0) config.SPLAT_FORCE = 0.01;
        logger("SPLAT_FORCE", config.SPLAT_FORCE);
        understood = true;
    }
    if (event.controller.number === 1 && event.message.channel === 6) {
        config.SPLAT_RADIUS = event.rawValue / 127;
        if (config.SPLAT_RADIUS === 0) config.SPLAT_RADIUS = 0.01;
        logger("SPLAT_RADIUS", config.SPLAT_RADIUS);
        understood = true;
    }
    if (event.controller.number === 1 && event.message.channel === 7) {
        config.DYE_RESOLUTION = 32 + event.rawValue / 127 * 1024;
        logger("DYE_RESOLUTION", config.DYE_RESOLUTION);
        config.doReinitFramebuffers = true;
        understood = true;
    }
    if (event.controller.number === 1 && event.message.channel === 8) {
        config.SIM_RESOLUTION = 32 + event.rawValue / 127 * 1024;
        logger("SIM_RESOLUTION", config.SIM_RESOLUTION);
        config.doReinitFramebuffers = true;
        understood = true;
    }
    if (event.controller.number === 3 && event.message.channel === 6) {
        config.CURL = event.rawValue / 127 * 50;
        logger("CURL", config.CURL);
        understood = true;
    }
    if (event.controller.number === 3 && event.message.channel === 7) {
        config.PRESSURE = event.rawValue / 127;
        logger("PRESSURE", config.PRESSURE);
        understood = true;
    }
    if (event.controller.number === 2 && event.message.channel === 6) {
        config.DENSITY_DISSIPATION = (event.rawValue / 127 - 0.5) * 4;
        logger("DENSITY_DISSIPATION", config.DENSITY_DISSIPATION);
        understood = true;
    }
    if (event.controller.number === 2 && event.message.channel === 7) {
        config.VELOCITY_DISSIPATION = (event.rawValue / 127 - 0.5) * 4;
        logger("VELOCITY_DISSIPATION", config.VELOCITY_DISSIPATION);
        understood = true;
    }
    if (!understood) logger(`MIDI CC: ${event.controller.number}/${event.rawValue} channel ${event.message.channel} on '${event.port.name}'`);
    return understood;
} /**
 * @param port{Output}
 * @returns {splatHook}
 */  /*
export function midiSplatHandler (port) {
    // @TODO: who knows what messages light up the leds on the traktor?
    for (let i = 1; i < 120; i++) {
        port.sendControlChange(i, 127);
    }
}
*/ 


var $7a5d8027f40c18e1$exports = {};

$parcel$export($7a5d8027f40c18e1$exports, "name", () => $7a5d8027f40c18e1$export$a8ff84c12d48cfa6);
$parcel$export($7a5d8027f40c18e1$exports, "isSupportedDevice", () => $7a5d8027f40c18e1$export$4067a3e42f64a634);
$parcel$export($7a5d8027f40c18e1$exports, "midiInNoteOn", () => $7a5d8027f40c18e1$export$e00075188492435b);
$parcel$export($7a5d8027f40c18e1$exports, "midiInControlChange", () => $7a5d8027f40c18e1$export$b192a6bb3da44c96);
const $7a5d8027f40c18e1$export$a8ff84c12d48cfa6 = "Generic";
function $7a5d8027f40c18e1$export$4067a3e42f64a634(manufacturer, name) {
    if (!name) return false;
    return true; // (generic!)
}
function $7a5d8027f40c18e1$export$e00075188492435b(event, config, logger, randomSplatsNow) {
    logger(`Generic MIDI Note: ${event.note.name} (${event.note.number}) channel ${event.message.channel} on '${event.port.name}'`);
    let numRandomSplats = event.note.number % 10;
    randomSplatsNow(numRandomSplats > 0 ? numRandomSplats : 1);
    return false; // do not broadcast config change.
}
function $7a5d8027f40c18e1$export$b192a6bb3da44c96(event, config, logger) {
    config.SPLAT_RADIUS = event.rawValue / 127;
    if (config.SPLAT_RADIUS === 0) config.SPLAT_RADIUS = 0.01;
    logger(`SPLAT_RADIUS: ${config.SPLAT_RADIUS} - Generic MIDI CC: ${event.controller.number}/${event.rawValue} channel ${event.message.channel} on '${event.port.name}'`);
    return true;
}


// ordered midi modules
const $9f3b2ca04e3d8775$var$midiModules = [
    $bd5624bc48e5cdda$exports,
    $6b44a3520a6435e8$exports,
    $7a5d8027f40c18e1$exports
];
// <START SIGNALR CONNECTION>
const $9f3b2ca04e3d8775$var$connection = new $cccc8edc49e3facc$export$afccb10c24910b13().configureLogging($5f3832d7be2e7d2f$export$243e62d78d3b544d.Information).withUrl("/fluidhub", {
    transport: $dfd8c9cbca816579$export$789ba40ee1a75f0.WebSockets,
    skipNegotiation: true
}).withAutomaticReconnect().build();
$9f3b2ca04e3d8775$var$connection.on('broadcastMessage', (message)=>{
    console.log("broadcastMessage", message);
    $9f3b2ca04e3d8775$var$canvasLog(message);
});
$9f3b2ca04e3d8775$var$connection.start();
// </START SIGNALR CONNECTION>
let $9f3b2ca04e3d8775$var$splatHook = null;
let $9f3b2ca04e3d8775$var$config = {
    MOBILE_DYE_RESOLUTION: 128,
    MOBILE_SIM_RESOLUTION: 64,
    SIM_RESOLUTION: 241.63779527559055,
    DYE_RESOLUTION: 1024,
    DENSITY_DISSIPATION: 0.8661417322834644,
    VELOCITY_DISSIPATION: 1.0866141732283463,
    PRESSURE: 0.7244094488188977,
    PRESSURE_ITERATIONS: 3,
    CURL: 32.677165354330704,
    SPLAT_RADIUS: 0.07086614173228346,
    SPLAT_FORCE: 6000,
    SHADING: true,
    COLORFUL: false,
    COLOR_UPDATE_SPEED: 1,
    PAUSED: false,
    BACK_COLOR: {
        r: 0,
        g: 0,
        b: 0
    },
    TRANSPARENT: false,
    BLOOM: true,
    BLOOM_ITERATIONS: 8,
    BLOOM_RESOLUTION: 256,
    BLOOM_INTENSITY: 0.8,
    BLOOM_THRESHOLD: 0.6,
    BLOOM_SOFT_KNEE: 0.7,
    SUNRAYS: true,
    SUNRAYS_RESOLUTION: 784,
    SUNRAYS_WEIGHT: 1,
    doReinitFramebuffers: false
};
if ($9f3b2ca04e3d8775$var$queryStringContains("transparent")) $9f3b2ca04e3d8775$var$config.TRANSPARENT = true;
// <MIDI INIT>
function $9f3b2ca04e3d8775$var$startupMidiSupport() {
    // Reacting when a new device becomes available; also fired for already-present ports during enable().
    (0, $4oKKP.WebMidi).addListener("connected", function(e) {
        for (const module of $9f3b2ca04e3d8775$var$midiModules)if (module.isSupportedDevice(e.port.manufacturer, e.port.name)) {
            console.log(`Module '${module.name}' supports '${e.port.name}'!`);
            $9f3b2ca04e3d8775$var$canvasLog(`Module '${module.name}' supports '${e.port.name}'!`);
            if (e.port.type === "input") {
                if (module.midiInControlChange) e.port.addListener("controlchange", (e)=>{
                    if (module.midiInControlChange(e, $9f3b2ca04e3d8775$var$config, $9f3b2ca04e3d8775$var$canvasLog, $9f3b2ca04e3d8775$var$randomSplatsNow)) $9f3b2ca04e3d8775$var$connection.invoke('config', JSON.stringify($9f3b2ca04e3d8775$var$config));
                });
                if (module.midiInNoteOn) e.port.addListener("noteon", (e)=>{
                    if (module.midiInNoteOn(e, $9f3b2ca04e3d8775$var$config, $9f3b2ca04e3d8775$var$canvasLog, $9f3b2ca04e3d8775$var$randomSplatsNow)) $9f3b2ca04e3d8775$var$connection.invoke('config', JSON.stringify($9f3b2ca04e3d8775$var$config));
                });
            } else if (e.port.type === "output") // @TODO: if more than one module/output only the last one will get it.
            {
                if (module.midiSplatHandler) $9f3b2ca04e3d8775$var$splatHook = module.midiSplatHandler(e.port);
            }
            break; // first module to support will "get it"; generic always supports
        }
    });
    (0, $4oKKP.WebMidi).enable().then(()=>console.log("WebMidi enabled!")).catch((err)=>console.error("WebMidi could not be enabled.", err));
}
$9f3b2ca04e3d8775$var$startupMidiSupport();
// </MIDI INIT>
const $9f3b2ca04e3d8775$var$canvas = document.getElementsByTagName('canvas')[0];
const $9f3b2ca04e3d8775$var$msgElement = document.getElementById("msg");
let $9f3b2ca04e3d8775$var$isMsgVisible = false;
let $9f3b2ca04e3d8775$var$msgTimeout = null;
// Hook up user event to make it fullscreen when it is clicked.
if ($9f3b2ca04e3d8775$var$queryStringContains("fullscreen")) {
    let makeFullScreen = ()=>{
        if ((0, $0fb704a73fce4e36$export$2e2bcd8739ae039).isEnabled) {
            if (!(0, $0fb704a73fce4e36$export$2e2bcd8739ae039).isFullscreen) (0, $0fb704a73fce4e36$export$2e2bcd8739ae039).request().then((value1)=>{
                $9f3b2ca04e3d8775$var$resizeCanvas();
                console.log("Yeah, full screen", value1);
            });
        } else console.warn("screenfull NOT ENABLED!");
    };
    $9f3b2ca04e3d8775$var$canvas.addEventListener('click', makeFullScreen);
    $9f3b2ca04e3d8775$var$canvas.addEventListener('touchstart', makeFullScreen);
}
$9f3b2ca04e3d8775$var$resizeCanvas();
function $9f3b2ca04e3d8775$var$canvasLog(...log) {
    if ($9f3b2ca04e3d8775$var$msgElement) {
        if (!$9f3b2ca04e3d8775$var$isMsgVisible) {
            $9f3b2ca04e3d8775$var$msgElement.style.display = "block";
            $9f3b2ca04e3d8775$var$isMsgVisible = true;
        }
        $9f3b2ca04e3d8775$var$msgElement.innerText = log.join(" ");
        // cancel the last timeout if it's there already
        if ($9f3b2ca04e3d8775$var$msgTimeout) clearTimeout($9f3b2ca04e3d8775$var$msgTimeout);
        // Now set a timeout to hide it again after a while
        $9f3b2ca04e3d8775$var$msgTimeout = setTimeout(()=>{
            $9f3b2ca04e3d8775$var$msgElement.style.display = "none";
            $9f3b2ca04e3d8775$var$isMsgVisible = false;
        }, 1000);
    }
}
function $9f3b2ca04e3d8775$var$pointerPrototype() {
    this.id = -1;
    this.texcoordX = 0;
    this.texcoordY = 0;
    this.deltaX = 0;
    this.deltaY = 0;
    this.down = false;
    this.color = [
        30,
        0,
        300
    ];
}
let $9f3b2ca04e3d8775$var$pointers = [];
let $9f3b2ca04e3d8775$var$splatStack = [];
$9f3b2ca04e3d8775$var$pointers.push(new $9f3b2ca04e3d8775$var$pointerPrototype());
const { gl: $9f3b2ca04e3d8775$var$gl, ext: $9f3b2ca04e3d8775$var$ext } = $9f3b2ca04e3d8775$var$getWebGLContext($9f3b2ca04e3d8775$var$canvas);
if ($9f3b2ca04e3d8775$var$isMobile()) {
    $9f3b2ca04e3d8775$var$config.DYE_RESOLUTION = $9f3b2ca04e3d8775$var$config.MOBILE_DYE_RESOLUTION;
    $9f3b2ca04e3d8775$var$config.SIM_RESOLUTION = $9f3b2ca04e3d8775$var$config.MOBILE_SIM_RESOLUTION;
}
if (!$9f3b2ca04e3d8775$var$ext.supportLinearFiltering) {
    $9f3b2ca04e3d8775$var$config.DYE_RESOLUTION = $9f3b2ca04e3d8775$var$config.MOBILE_DYE_RESOLUTION;
    $9f3b2ca04e3d8775$var$config.SIM_RESOLUTION = $9f3b2ca04e3d8775$var$config.MOBILE_SIM_RESOLUTION;
    $9f3b2ca04e3d8775$var$config.SHADING = false;
    $9f3b2ca04e3d8775$var$config.BLOOM = false;
    $9f3b2ca04e3d8775$var$config.SUNRAYS = false;
}
function $9f3b2ca04e3d8775$var$getWebGLContext(canvas) {
    const params = {
        alpha: true,
        depth: false,
        stencil: false,
        antialias: false,
        preserveDrawingBuffer: false
    };
    let gl = canvas.getContext('webgl2', params);
    const isWebGL2 = !!gl;
    if (!isWebGL2) gl = canvas.getContext('webgl', params) || canvas.getContext('experimental-webgl', params);
    let halfFloat;
    let supportLinearFiltering;
    if (isWebGL2) {
        gl.getExtension('EXT_color_buffer_float');
        supportLinearFiltering = gl.getExtension('OES_texture_float_linear');
    } else {
        halfFloat = gl.getExtension('OES_texture_half_float');
        supportLinearFiltering = gl.getExtension('OES_texture_half_float_linear');
    }
    gl.clearColor(0.0, 0.0, 0.0, 1.0);
    const halfFloatTexType = isWebGL2 ? gl.HALF_FLOAT : halfFloat.HALF_FLOAT_OES;
    let formatRGBA;
    let formatRG;
    let formatR;
    if (isWebGL2) {
        formatRGBA = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA16F, gl.RGBA, halfFloatTexType);
        formatRG = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RG16F, gl.RG, halfFloatTexType);
        formatR = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.R16F, gl.RED, halfFloatTexType);
    } else {
        formatRGBA = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA, gl.RGBA, halfFloatTexType);
        formatRG = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA, gl.RGBA, halfFloatTexType);
        formatR = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA, gl.RGBA, halfFloatTexType);
    }
    return {
        gl: gl,
        ext: {
            formatRGBA: formatRGBA,
            formatRG: formatRG,
            formatR: formatR,
            halfFloatTexType: halfFloatTexType,
            supportLinearFiltering: supportLinearFiltering
        }
    };
}
function $9f3b2ca04e3d8775$var$getSupportedFormat(gl, internalFormat, format, type) {
    if (!$9f3b2ca04e3d8775$var$supportRenderTextureFormat(gl, internalFormat, format, type)) switch(internalFormat){
        case gl.R16F:
            return $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RG16F, gl.RG, type);
        case gl.RG16F:
            return $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA16F, gl.RGBA, type);
        default:
            return null;
    }
    return {
        internalFormat: internalFormat,
        format: format
    };
}
function $9f3b2ca04e3d8775$var$supportRenderTextureFormat(gl, internalFormat, format, type) {
    let texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, 4, 4, 0, format, type, null);
    let fbo = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    return status == gl.FRAMEBUFFER_COMPLETE;
}
function $9f3b2ca04e3d8775$var$isMobile() {
    return false; // @TODO
}
class $9f3b2ca04e3d8775$var$Material {
    constructor(vertexShader, fragmentShaderSource){
        this.vertexShader = vertexShader;
        this.fragmentShaderSource = fragmentShaderSource;
        this.programs = [];
        this.activeProgram = null;
        this.uniforms = [];
    }
    setKeywords(keywords) {
        let hash = 0;
        for(let i = 0; i < keywords.length; i++)hash += $9f3b2ca04e3d8775$var$hashCode(keywords[i]);
        let program = this.programs[hash];
        if (program == null) {
            let fragmentShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, this.fragmentShaderSource, keywords);
            program = $9f3b2ca04e3d8775$var$createProgram(this.vertexShader, fragmentShader);
            this.programs[hash] = program;
        }
        if (program == this.activeProgram) return;
        this.uniforms = $9f3b2ca04e3d8775$var$getUniforms(program);
        this.activeProgram = program;
    }
    bind() {
        $9f3b2ca04e3d8775$var$gl.useProgram(this.activeProgram);
    }
}
class $9f3b2ca04e3d8775$var$Program {
    constructor(vertexShader, fragmentShader){
        this.uniforms = {};
        this.program = $9f3b2ca04e3d8775$var$createProgram(vertexShader, fragmentShader);
        this.uniforms = $9f3b2ca04e3d8775$var$getUniforms(this.program);
    }
    bind() {
        $9f3b2ca04e3d8775$var$gl.useProgram(this.program);
    }
}
function $9f3b2ca04e3d8775$var$createProgram(vertexShader, fragmentShader) {
    let program = $9f3b2ca04e3d8775$var$gl.createProgram();
    $9f3b2ca04e3d8775$var$gl.attachShader(program, vertexShader);
    $9f3b2ca04e3d8775$var$gl.attachShader(program, fragmentShader);
    $9f3b2ca04e3d8775$var$gl.linkProgram(program);
    if (!$9f3b2ca04e3d8775$var$gl.getProgramParameter(program, $9f3b2ca04e3d8775$var$gl.LINK_STATUS)) throw $9f3b2ca04e3d8775$var$gl.getProgramInfoLog(program);
    return program;
}
function $9f3b2ca04e3d8775$var$getUniforms(program) {
    let uniforms = [];
    let uniformCount = $9f3b2ca04e3d8775$var$gl.getProgramParameter(program, $9f3b2ca04e3d8775$var$gl.ACTIVE_UNIFORMS);
    for(let i = 0; i < uniformCount; i++){
        let uniformName = $9f3b2ca04e3d8775$var$gl.getActiveUniform(program, i).name;
        uniforms[uniformName] = $9f3b2ca04e3d8775$var$gl.getUniformLocation(program, uniformName);
    }
    return uniforms;
}
function $9f3b2ca04e3d8775$var$compileShader(type, source, keywords) {
    source = $9f3b2ca04e3d8775$var$addKeywords(source, keywords);
    const shader = $9f3b2ca04e3d8775$var$gl.createShader(type);
    $9f3b2ca04e3d8775$var$gl.shaderSource(shader, source);
    $9f3b2ca04e3d8775$var$gl.compileShader(shader);
    if (!$9f3b2ca04e3d8775$var$gl.getShaderParameter(shader, $9f3b2ca04e3d8775$var$gl.COMPILE_STATUS)) throw $9f3b2ca04e3d8775$var$gl.getShaderInfoLog(shader);
    return shader;
}
function $9f3b2ca04e3d8775$var$addKeywords(source, keywords) {
    if (keywords == null) return source;
    let keywordsString = '';
    keywords.forEach((keyword)=>{
        keywordsString += '#define ' + keyword + '\n';
    });
    return keywordsString + source;
}
const $9f3b2ca04e3d8775$var$baseVertexShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.VERTEX_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($b073ace211e07ca5$exports))));
const $9f3b2ca04e3d8775$var$blurVertexShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.VERTEX_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($af22a45ee2cf3058$exports))));
const $9f3b2ca04e3d8775$var$blurShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($9fe15e68bee46b24$exports))));
const $9f3b2ca04e3d8775$var$copyShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($b2937d4c01081df9$exports))));
const $9f3b2ca04e3d8775$var$clearShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($719ba1830217732e$exports))));
const $9f3b2ca04e3d8775$var$colorShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($73744113a8abb7e1$exports))));
const $9f3b2ca04e3d8775$var$checkerboardShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($abb988efd69fa6f6$exports))));
const $9f3b2ca04e3d8775$var$bloomPrefilterShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($8f5fcad1063be82d$exports))));
const $9f3b2ca04e3d8775$var$bloomBlurShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($a5ada04d393fb5d7$exports))));
const $9f3b2ca04e3d8775$var$bloomFinalShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($1ef0e73bcc342f97$exports))));
const $9f3b2ca04e3d8775$var$sunraysMaskShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($7a5947680249ab33$exports))));
const $9f3b2ca04e3d8775$var$sunraysShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($4f387349a228c2dd$exports))));
const $9f3b2ca04e3d8775$var$splatShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($3efa16d047bc35ee$exports))));
const $9f3b2ca04e3d8775$var$advectionShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($993d5df17bfe8036$exports))), $9f3b2ca04e3d8775$var$ext.supportLinearFiltering ? null : [
    'MANUAL_FILTERING'
]);
const $9f3b2ca04e3d8775$var$divergenceShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($d9cebc9ec9011904$exports))));
const $9f3b2ca04e3d8775$var$curlShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($7c890988bafebabf$exports))));
const $9f3b2ca04e3d8775$var$vorticityShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($70acace40d332cd0$exports))));
const $9f3b2ca04e3d8775$var$pressureShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($6cca967b18c9fc9f$exports))));
const $9f3b2ca04e3d8775$var$gradientSubtractShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($08cd69f8f5a4a380$exports))));
const $9f3b2ca04e3d8775$var$blit = (()=>{
    $9f3b2ca04e3d8775$var$gl.bindBuffer($9f3b2ca04e3d8775$var$gl.ARRAY_BUFFER, $9f3b2ca04e3d8775$var$gl.createBuffer());
    $9f3b2ca04e3d8775$var$gl.bufferData($9f3b2ca04e3d8775$var$gl.ARRAY_BUFFER, new Float32Array([
        -1,
        -1,
        -1,
        1,
        1,
        1,
        1,
        -1
    ]), $9f3b2ca04e3d8775$var$gl.STATIC_DRAW);
    $9f3b2ca04e3d8775$var$gl.bindBuffer($9f3b2ca04e3d8775$var$gl.ELEMENT_ARRAY_BUFFER, $9f3b2ca04e3d8775$var$gl.createBuffer());
    $9f3b2ca04e3d8775$var$gl.bufferData($9f3b2ca04e3d8775$var$gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([
        0,
        1,
        2,
        0,
        2,
        3
    ]), $9f3b2ca04e3d8775$var$gl.STATIC_DRAW);
    $9f3b2ca04e3d8775$var$gl.vertexAttribPointer(0, 2, $9f3b2ca04e3d8775$var$gl.FLOAT, false, 0, 0);
    $9f3b2ca04e3d8775$var$gl.enableVertexAttribArray(0);
    return (destination)=>{
        $9f3b2ca04e3d8775$var$gl.bindFramebuffer($9f3b2ca04e3d8775$var$gl.FRAMEBUFFER, destination);
        $9f3b2ca04e3d8775$var$gl.drawElements($9f3b2ca04e3d8775$var$gl.TRIANGLES, 6, $9f3b2ca04e3d8775$var$gl.UNSIGNED_SHORT, 0);
    };
})();
let $9f3b2ca04e3d8775$var$dye;
let $9f3b2ca04e3d8775$var$velocity;
let $9f3b2ca04e3d8775$var$divergence;
let $9f3b2ca04e3d8775$var$curl;
let $9f3b2ca04e3d8775$var$pressure;
let $9f3b2ca04e3d8775$var$bloom;
let $9f3b2ca04e3d8775$var$bloomFramebuffers = [];
let $9f3b2ca04e3d8775$var$sunrays;
let $9f3b2ca04e3d8775$var$sunraysTemp;
let $9f3b2ca04e3d8775$var$ditheringTexture = $9f3b2ca04e3d8775$var$createTextureAsync((0, {}));
const $9f3b2ca04e3d8775$var$blurProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$blurVertexShader, $9f3b2ca04e3d8775$var$blurShader);
const $9f3b2ca04e3d8775$var$copyProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$copyShader);
const $9f3b2ca04e3d8775$var$clearProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$clearShader);
const $9f3b2ca04e3d8775$var$colorProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$colorShader);
const $9f3b2ca04e3d8775$var$checkerboardProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$checkerboardShader);
const $9f3b2ca04e3d8775$var$bloomPrefilterProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$bloomPrefilterShader);
const $9f3b2ca04e3d8775$var$bloomBlurProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$bloomBlurShader);
const $9f3b2ca04e3d8775$var$bloomFinalProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$bloomFinalShader);
const $9f3b2ca04e3d8775$var$sunraysMaskProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$sunraysMaskShader);
const $9f3b2ca04e3d8775$var$sunraysProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$sunraysShader);
const $9f3b2ca04e3d8775$var$splatProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$splatShader);
const $9f3b2ca04e3d8775$var$advectionProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$advectionShader);
const $9f3b2ca04e3d8775$var$divergenceProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$divergenceShader);
const $9f3b2ca04e3d8775$var$curlProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$curlShader);
const $9f3b2ca04e3d8775$var$vorticityProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$vorticityShader);
const $9f3b2ca04e3d8775$var$pressureProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$pressureShader);
const $9f3b2ca04e3d8775$var$gradienSubtractProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$gradientSubtractShader);
const $9f3b2ca04e3d8775$var$displayMaterial = new $9f3b2ca04e3d8775$var$Material($9f3b2ca04e3d8775$var$baseVertexShader, (0, (/*@__PURE__*/$parcel$interopDefault($91e81c3e9c7f71c0$exports))));
function $9f3b2ca04e3d8775$var$initFramebuffers() {
    let simRes = $9f3b2ca04e3d8775$var$getResolution($9f3b2ca04e3d8775$var$config.SIM_RESOLUTION);
    let dyeRes = $9f3b2ca04e3d8775$var$getResolution($9f3b2ca04e3d8775$var$config.DYE_RESOLUTION);
    const texType = $9f3b2ca04e3d8775$var$ext.halfFloatTexType;
    const rgba = $9f3b2ca04e3d8775$var$ext.formatRGBA;
    const rg = $9f3b2ca04e3d8775$var$ext.formatRG;
    const r = $9f3b2ca04e3d8775$var$ext.formatR;
    const filtering = $9f3b2ca04e3d8775$var$ext.supportLinearFiltering ? $9f3b2ca04e3d8775$var$gl.LINEAR : $9f3b2ca04e3d8775$var$gl.NEAREST;
    if ($9f3b2ca04e3d8775$var$dye == null) $9f3b2ca04e3d8775$var$dye = $9f3b2ca04e3d8775$var$createDoubleFBO(dyeRes.width, dyeRes.height, rgba.internalFormat, rgba.format, texType, filtering);
    else $9f3b2ca04e3d8775$var$dye = $9f3b2ca04e3d8775$var$resizeDoubleFBO($9f3b2ca04e3d8775$var$dye, dyeRes.width, dyeRes.height, rgba.internalFormat, rgba.format, texType, filtering);
    if ($9f3b2ca04e3d8775$var$velocity == null) $9f3b2ca04e3d8775$var$velocity = $9f3b2ca04e3d8775$var$createDoubleFBO(simRes.width, simRes.height, rg.internalFormat, rg.format, texType, filtering);
    else $9f3b2ca04e3d8775$var$velocity = $9f3b2ca04e3d8775$var$resizeDoubleFBO($9f3b2ca04e3d8775$var$velocity, simRes.width, simRes.height, rg.internalFormat, rg.format, texType, filtering);
    $9f3b2ca04e3d8775$var$divergence = $9f3b2ca04e3d8775$var$createFBO(simRes.width, simRes.height, r.internalFormat, r.format, texType, $9f3b2ca04e3d8775$var$gl.NEAREST);
    $9f3b2ca04e3d8775$var$curl = $9f3b2ca04e3d8775$var$createFBO(simRes.width, simRes.height, r.internalFormat, r.format, texType, $9f3b2ca04e3d8775$var$gl.NEAREST);
    $9f3b2ca04e3d8775$var$pressure = $9f3b2ca04e3d8775$var$createDoubleFBO(simRes.width, simRes.height, r.internalFormat, r.format, texType, $9f3b2ca04e3d8775$var$gl.NEAREST);
    $9f3b2ca04e3d8775$var$initBloomFramebuffers();
    $9f3b2ca04e3d8775$var$initSunraysFramebuffers();
}
function $9f3b2ca04e3d8775$var$initBloomFramebuffers() {
    let res = $9f3b2ca04e3d8775$var$getResolution($9f3b2ca04e3d8775$var$config.BLOOM_RESOLUTION);
    const texType = $9f3b2ca04e3d8775$var$ext.halfFloatTexType;
    const rgba = $9f3b2ca04e3d8775$var$ext.formatRGBA;
    const filtering = $9f3b2ca04e3d8775$var$ext.supportLinearFiltering ? $9f3b2ca04e3d8775$var$gl.LINEAR : $9f3b2ca04e3d8775$var$gl.NEAREST;
    $9f3b2ca04e3d8775$var$bloom = $9f3b2ca04e3d8775$var$createFBO(res.width, res.height, rgba.internalFormat, rgba.format, texType, filtering);
    $9f3b2ca04e3d8775$var$bloomFramebuffers.length = 0;
    for(let i = 0; i < $9f3b2ca04e3d8775$var$config.BLOOM_ITERATIONS; i++){
        let width = res.width >> i + 1;
        let height = res.height >> i + 1;
        if (width < 2 || height < 2) break;
        let fbo = $9f3b2ca04e3d8775$var$createFBO(width, height, rgba.internalFormat, rgba.format, texType, filtering);
        $9f3b2ca04e3d8775$var$bloomFramebuffers.push(fbo);
    }
}
function $9f3b2ca04e3d8775$var$initSunraysFramebuffers() {
    let res = $9f3b2ca04e3d8775$var$getResolution($9f3b2ca04e3d8775$var$config.SUNRAYS_RESOLUTION);
    const texType = $9f3b2ca04e3d8775$var$ext.halfFloatTexType;
    const r = $9f3b2ca04e3d8775$var$ext.formatR;
    const filtering = $9f3b2ca04e3d8775$var$ext.supportLinearFiltering ? $9f3b2ca04e3d8775$var$gl.LINEAR : $9f3b2ca04e3d8775$var$gl.NEAREST;
    $9f3b2ca04e3d8775$var$sunrays = $9f3b2ca04e3d8775$var$createFBO(res.width, res.height, r.internalFormat, r.format, texType, filtering);
    $9f3b2ca04e3d8775$var$sunraysTemp = $9f3b2ca04e3d8775$var$createFBO(res.width, res.height, r.internalFormat, r.format, texType, filtering);
}
function $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param) {
    $9f3b2ca04e3d8775$var$gl.activeTexture($9f3b2ca04e3d8775$var$gl.TEXTURE0);
    let texture = $9f3b2ca04e3d8775$var$gl.createTexture();
    $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_MIN_FILTER, param);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_MAG_FILTER, param);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_WRAP_S, $9f3b2ca04e3d8775$var$gl.CLAMP_TO_EDGE);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_WRAP_T, $9f3b2ca04e3d8775$var$gl.CLAMP_TO_EDGE);
    $9f3b2ca04e3d8775$var$gl.texImage2D($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, 0, internalFormat, w, h, 0, format, type, null);
    let fbo = $9f3b2ca04e3d8775$var$gl.createFramebuffer();
    $9f3b2ca04e3d8775$var$gl.bindFramebuffer($9f3b2ca04e3d8775$var$gl.FRAMEBUFFER, fbo);
    $9f3b2ca04e3d8775$var$gl.framebufferTexture2D($9f3b2ca04e3d8775$var$gl.FRAMEBUFFER, $9f3b2ca04e3d8775$var$gl.COLOR_ATTACHMENT0, $9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture, 0);
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, w, h);
    $9f3b2ca04e3d8775$var$gl.clear($9f3b2ca04e3d8775$var$gl.COLOR_BUFFER_BIT);
    let texelSizeX = 1.0 / w;
    let texelSizeY = 1.0 / h;
    return {
        texture: texture,
        fbo: fbo,
        width: w,
        height: h,
        texelSizeX: texelSizeX,
        texelSizeY: texelSizeY,
        attach (id) {
            $9f3b2ca04e3d8775$var$gl.activeTexture($9f3b2ca04e3d8775$var$gl.TEXTURE0 + id);
            $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
            return id;
        }
    };
}
function $9f3b2ca04e3d8775$var$createDoubleFBO(w, h, internalFormat, format, type, param) {
    let fbo1 = $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param);
    let fbo2 = $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param);
    return {
        width: w,
        height: h,
        texelSizeX: fbo1.texelSizeX,
        texelSizeY: fbo1.texelSizeY,
        get read () {
            return fbo1;
        },
        set read (value){
            fbo1 = value;
        },
        get write () {
            return fbo2;
        },
        set write (value){
            fbo2 = value;
        },
        swap () {
            let temp = fbo1;
            fbo1 = fbo2;
            fbo2 = temp;
        }
    };
}
function $9f3b2ca04e3d8775$var$resizeFBO(target, w, h, internalFormat, format, type, param) {
    let newFBO = $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param);
    $9f3b2ca04e3d8775$var$copyProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$copyProgram.uniforms.uTexture, target.attach(0));
    $9f3b2ca04e3d8775$var$blit(newFBO.fbo);
    return newFBO;
}
function $9f3b2ca04e3d8775$var$resizeDoubleFBO(target, w, h, internalFormat, format, type, param) {
    if (target.width == w && target.height == h) return target;
    target.read = $9f3b2ca04e3d8775$var$resizeFBO(target.read, w, h, internalFormat, format, type, param);
    target.write = $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param);
    target.width = w;
    target.height = h;
    target.texelSizeX = 1.0 / w;
    target.texelSizeY = 1.0 / h;
    return target;
}
function $9f3b2ca04e3d8775$var$createTextureAsync(url) {
    let texture = $9f3b2ca04e3d8775$var$gl.createTexture();
    $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_MIN_FILTER, $9f3b2ca04e3d8775$var$gl.LINEAR);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_MAG_FILTER, $9f3b2ca04e3d8775$var$gl.LINEAR);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_WRAP_S, $9f3b2ca04e3d8775$var$gl.REPEAT);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_WRAP_T, $9f3b2ca04e3d8775$var$gl.REPEAT);
    $9f3b2ca04e3d8775$var$gl.texImage2D($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, 0, $9f3b2ca04e3d8775$var$gl.RGB, 1, 1, 0, $9f3b2ca04e3d8775$var$gl.RGB, $9f3b2ca04e3d8775$var$gl.UNSIGNED_BYTE, new Uint8Array([
        255,
        255,
        255
    ]));
    let obj = {
        texture: texture,
        width: 1,
        height: 1,
        attach (id) {
            $9f3b2ca04e3d8775$var$gl.activeTexture($9f3b2ca04e3d8775$var$gl.TEXTURE0 + id);
            $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
            return id;
        }
    };
    let image = new Image();
    image.onload = ()=>{
        obj.width = image.width;
        obj.height = image.height;
        $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
        $9f3b2ca04e3d8775$var$gl.texImage2D($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, 0, $9f3b2ca04e3d8775$var$gl.RGB, $9f3b2ca04e3d8775$var$gl.RGB, $9f3b2ca04e3d8775$var$gl.UNSIGNED_BYTE, image);
    };
    image.src = url;
    return obj;
}
function $9f3b2ca04e3d8775$var$updateKeywords() {
    let displayKeywords = [];
    if ($9f3b2ca04e3d8775$var$config.SHADING) displayKeywords.push("SHADING");
    if ($9f3b2ca04e3d8775$var$config.BLOOM) displayKeywords.push("BLOOM");
    if ($9f3b2ca04e3d8775$var$config.SUNRAYS) displayKeywords.push("SUNRAYS");
    $9f3b2ca04e3d8775$var$displayMaterial.setKeywords(displayKeywords);
}
$9f3b2ca04e3d8775$var$updateKeywords();
$9f3b2ca04e3d8775$var$initFramebuffers();
//multipleSplats(parseInt(Math.random() * 20) + 5);
let $9f3b2ca04e3d8775$var$lastUpdateTime = Date.now();
let $9f3b2ca04e3d8775$var$colorUpdateTimer = 0.0;
window.fluidHasStarted = false;
function $9f3b2ca04e3d8775$var$randomSplatsNow(num) {
    $9f3b2ca04e3d8775$var$multipleSplats(Math.floor(num));
}
function $9f3b2ca04e3d8775$var$startFluid() {
    if (window.fluidHasStarted) return;
    else window.fluidHasStarted = true;
    $9f3b2ca04e3d8775$var$initFramebuffers();
    $9f3b2ca04e3d8775$var$lastUpdateTime = Date.now();
    $9f3b2ca04e3d8775$var$colorUpdateTimer = 0.0;
    $9f3b2ca04e3d8775$var$update();
}
$9f3b2ca04e3d8775$var$startFluid();
function $9f3b2ca04e3d8775$var$update() {
    const dt = $9f3b2ca04e3d8775$var$calcDeltaTime();
    if ($9f3b2ca04e3d8775$var$resizeCanvas() || $9f3b2ca04e3d8775$var$config.doReinitFramebuffers) {
        $9f3b2ca04e3d8775$var$config.doReinitFramebuffers = false;
        $9f3b2ca04e3d8775$var$initFramebuffers();
    }
    $9f3b2ca04e3d8775$var$updateColors(dt);
    $9f3b2ca04e3d8775$var$applyInputs();
    if (!$9f3b2ca04e3d8775$var$config.PAUSED) $9f3b2ca04e3d8775$var$step(dt);
    $9f3b2ca04e3d8775$var$render(null);
    requestAnimationFrame($9f3b2ca04e3d8775$var$update);
}
function $9f3b2ca04e3d8775$var$calcDeltaTime() {
    let now = Date.now();
    let dt = (now - $9f3b2ca04e3d8775$var$lastUpdateTime) / 1000;
    dt = Math.min(dt, 0.016666);
    $9f3b2ca04e3d8775$var$lastUpdateTime = now;
    return dt;
}
function $9f3b2ca04e3d8775$var$resizeCanvas() {
    //console.log("Resizing canvas, ", canvas.clientWidth, canvas.clientHeight);
    let width = $9f3b2ca04e3d8775$var$scaleByPixelRatio($9f3b2ca04e3d8775$var$canvas.clientWidth);
    let height = $9f3b2ca04e3d8775$var$scaleByPixelRatio($9f3b2ca04e3d8775$var$canvas.clientHeight);
    //console.log("Resized canvas, ", width, height);
    if ($9f3b2ca04e3d8775$var$canvas.width != width || $9f3b2ca04e3d8775$var$canvas.height != height) {
        $9f3b2ca04e3d8775$var$canvas.width = width;
        $9f3b2ca04e3d8775$var$canvas.height = height;
        return true;
    }
    return false;
}
function $9f3b2ca04e3d8775$var$updateColors(dt) {
    if (!$9f3b2ca04e3d8775$var$config.COLORFUL) return;
    $9f3b2ca04e3d8775$var$colorUpdateTimer += dt * $9f3b2ca04e3d8775$var$config.COLOR_UPDATE_SPEED;
    if ($9f3b2ca04e3d8775$var$colorUpdateTimer >= 1) {
        $9f3b2ca04e3d8775$var$colorUpdateTimer = $9f3b2ca04e3d8775$var$wrap($9f3b2ca04e3d8775$var$colorUpdateTimer, 0, 1);
        $9f3b2ca04e3d8775$var$pointers.forEach((p)=>{
            p.color = $9f3b2ca04e3d8775$var$generateColor();
        });
    }
}
function $9f3b2ca04e3d8775$var$applyInputs() {
    if ($9f3b2ca04e3d8775$var$splatStack.length > 0) $9f3b2ca04e3d8775$var$multipleSplats($9f3b2ca04e3d8775$var$splatStack.pop());
    $9f3b2ca04e3d8775$var$pointers.forEach((p)=>{
        if (p.moved) {
            p.moved = false;
            $9f3b2ca04e3d8775$var$send_splatPointer(p);
        }
    });
}
function $9f3b2ca04e3d8775$var$step(dt) {
    $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, $9f3b2ca04e3d8775$var$velocity.width, $9f3b2ca04e3d8775$var$velocity.height);
    $9f3b2ca04e3d8775$var$curlProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$curlProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$curlProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$curl.fbo);
    $9f3b2ca04e3d8775$var$vorticityProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.uCurl, $9f3b2ca04e3d8775$var$curl.attach(1));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.curl, $9f3b2ca04e3d8775$var$config.CURL);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.dt, dt);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$velocity.write.fbo);
    $9f3b2ca04e3d8775$var$velocity.swap();
    $9f3b2ca04e3d8775$var$divergenceProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$divergenceProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$divergenceProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$divergence.fbo);
    $9f3b2ca04e3d8775$var$clearProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$clearProgram.uniforms.uTexture, $9f3b2ca04e3d8775$var$pressure.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$clearProgram.uniforms.value, $9f3b2ca04e3d8775$var$config.PRESSURE);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$pressure.write.fbo);
    $9f3b2ca04e3d8775$var$pressure.swap();
    $9f3b2ca04e3d8775$var$pressureProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$pressureProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$pressureProgram.uniforms.uDivergence, $9f3b2ca04e3d8775$var$divergence.attach(0));
    for(let i = 0; i < $9f3b2ca04e3d8775$var$config.PRESSURE_ITERATIONS; i++){
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$pressureProgram.uniforms.uPressure, $9f3b2ca04e3d8775$var$pressure.read.attach(1));
        $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$pressure.write.fbo);
        $9f3b2ca04e3d8775$var$pressure.swap();
    }
    $9f3b2ca04e3d8775$var$gradienSubtractProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$gradienSubtractProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$gradienSubtractProgram.uniforms.uPressure, $9f3b2ca04e3d8775$var$pressure.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$gradienSubtractProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(1));
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$velocity.write.fbo);
    $9f3b2ca04e3d8775$var$velocity.swap();
    $9f3b2ca04e3d8775$var$advectionProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    if (!$9f3b2ca04e3d8775$var$ext.supportLinearFiltering) $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dyeTexelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    let velocityId = $9f3b2ca04e3d8775$var$velocity.read.attach(0);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$advectionProgram.uniforms.uVelocity, velocityId);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$advectionProgram.uniforms.uSource, velocityId);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dt, dt);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dissipation, $9f3b2ca04e3d8775$var$config.VELOCITY_DISSIPATION);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$velocity.write.fbo);
    $9f3b2ca04e3d8775$var$velocity.swap();
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, $9f3b2ca04e3d8775$var$dye.width, $9f3b2ca04e3d8775$var$dye.height);
    if (!$9f3b2ca04e3d8775$var$ext.supportLinearFiltering) $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dyeTexelSize, $9f3b2ca04e3d8775$var$dye.texelSizeX, $9f3b2ca04e3d8775$var$dye.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$advectionProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$advectionProgram.uniforms.uSource, $9f3b2ca04e3d8775$var$dye.read.attach(1));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dissipation, $9f3b2ca04e3d8775$var$config.DENSITY_DISSIPATION);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$dye.write.fbo);
    $9f3b2ca04e3d8775$var$dye.swap();
}
function $9f3b2ca04e3d8775$var$render(target) {
    if ($9f3b2ca04e3d8775$var$config.BLOOM) $9f3b2ca04e3d8775$var$applyBloom($9f3b2ca04e3d8775$var$dye.read, $9f3b2ca04e3d8775$var$bloom);
    if ($9f3b2ca04e3d8775$var$config.SUNRAYS) {
        $9f3b2ca04e3d8775$var$applySunrays($9f3b2ca04e3d8775$var$dye.read, $9f3b2ca04e3d8775$var$dye.write, $9f3b2ca04e3d8775$var$sunrays);
        $9f3b2ca04e3d8775$var$blur($9f3b2ca04e3d8775$var$sunrays, $9f3b2ca04e3d8775$var$sunraysTemp, 1);
    }
    if (target == null || !$9f3b2ca04e3d8775$var$config.TRANSPARENT) {
        $9f3b2ca04e3d8775$var$gl.blendFunc($9f3b2ca04e3d8775$var$gl.ONE, $9f3b2ca04e3d8775$var$gl.ONE_MINUS_SRC_ALPHA);
        $9f3b2ca04e3d8775$var$gl.enable($9f3b2ca04e3d8775$var$gl.BLEND);
    } else $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    let width = target == null ? $9f3b2ca04e3d8775$var$gl.drawingBufferWidth : target.width;
    let height = target == null ? $9f3b2ca04e3d8775$var$gl.drawingBufferHeight : target.height;
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, width, height);
    let fbo = target == null ? null : target.fbo;
    if (!$9f3b2ca04e3d8775$var$config.TRANSPARENT) $9f3b2ca04e3d8775$var$drawColor(fbo, $9f3b2ca04e3d8775$var$normalizeColor($9f3b2ca04e3d8775$var$config.BACK_COLOR));
    //if (target == null && config.TRANSPARENT)
    //    drawCheckerboard(fbo);
    $9f3b2ca04e3d8775$var$drawDisplay(fbo, width, height);
}
function $9f3b2ca04e3d8775$var$drawColor(fbo, color) {
    $9f3b2ca04e3d8775$var$colorProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform4f($9f3b2ca04e3d8775$var$colorProgram.uniforms.color, color.r, color.g, color.b, 1);
    $9f3b2ca04e3d8775$var$blit(fbo);
}
function $9f3b2ca04e3d8775$var$drawCheckerboard(fbo) {
    $9f3b2ca04e3d8775$var$checkerboardProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$checkerboardProgram.uniforms.aspectRatio, $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height);
    $9f3b2ca04e3d8775$var$blit(fbo);
}
function $9f3b2ca04e3d8775$var$drawDisplay(fbo, width, height) {
    $9f3b2ca04e3d8775$var$displayMaterial.bind();
    if ($9f3b2ca04e3d8775$var$config.SHADING) $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$displayMaterial.uniforms.texelSize, 1.0 / width, 1.0 / height);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$displayMaterial.uniforms.uTexture, $9f3b2ca04e3d8775$var$dye.read.attach(0));
    if ($9f3b2ca04e3d8775$var$config.BLOOM) {
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$displayMaterial.uniforms.uBloom, $9f3b2ca04e3d8775$var$bloom.attach(1));
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$displayMaterial.uniforms.uDithering, $9f3b2ca04e3d8775$var$ditheringTexture.attach(2));
        let scale = $9f3b2ca04e3d8775$var$getTextureScale($9f3b2ca04e3d8775$var$ditheringTexture, width, height);
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$displayMaterial.uniforms.ditherScale, scale.x, scale.y);
    }
    if ($9f3b2ca04e3d8775$var$config.SUNRAYS) $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$displayMaterial.uniforms.uSunrays, $9f3b2ca04e3d8775$var$sunrays.attach(3));
    $9f3b2ca04e3d8775$var$blit(fbo);
}
function $9f3b2ca04e3d8775$var$applyBloom(source, destination) {
    if ($9f3b2ca04e3d8775$var$bloomFramebuffers.length < 2) return;
    let last = destination;
    $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    $9f3b2ca04e3d8775$var$bloomPrefilterProgram.bind();
    let knee = $9f3b2ca04e3d8775$var$config.BLOOM_THRESHOLD * $9f3b2ca04e3d8775$var$config.BLOOM_SOFT_KNEE + 0.0001;
    let curve0 = $9f3b2ca04e3d8775$var$config.BLOOM_THRESHOLD - knee;
    let curve1 = knee * 2;
    let curve2 = 0.25 / knee;
    $9f3b2ca04e3d8775$var$gl.uniform3f($9f3b2ca04e3d8775$var$bloomPrefilterProgram.uniforms.curve, curve0, curve1, curve2);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$bloomPrefilterProgram.uniforms.threshold, $9f3b2ca04e3d8775$var$config.BLOOM_THRESHOLD);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$bloomPrefilterProgram.uniforms.uTexture, source.attach(0));
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, last.width, last.height);
    $9f3b2ca04e3d8775$var$blit(last.fbo);
    $9f3b2ca04e3d8775$var$bloomBlurProgram.bind();
    for(let i = 0; i < $9f3b2ca04e3d8775$var$bloomFramebuffers.length; i++){
        let dest = $9f3b2ca04e3d8775$var$bloomFramebuffers[i];
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$bloomBlurProgram.uniforms.texelSize, last.texelSizeX, last.texelSizeY);
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$bloomBlurProgram.uniforms.uTexture, last.attach(0));
        $9f3b2ca04e3d8775$var$gl.viewport(0, 0, dest.width, dest.height);
        $9f3b2ca04e3d8775$var$blit(dest.fbo);
        last = dest;
    }
    $9f3b2ca04e3d8775$var$gl.blendFunc($9f3b2ca04e3d8775$var$gl.ONE, $9f3b2ca04e3d8775$var$gl.ONE);
    $9f3b2ca04e3d8775$var$gl.enable($9f3b2ca04e3d8775$var$gl.BLEND);
    for(let i = $9f3b2ca04e3d8775$var$bloomFramebuffers.length - 2; i >= 0; i--){
        let baseTex = $9f3b2ca04e3d8775$var$bloomFramebuffers[i];
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$bloomBlurProgram.uniforms.texelSize, last.texelSizeX, last.texelSizeY);
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$bloomBlurProgram.uniforms.uTexture, last.attach(0));
        $9f3b2ca04e3d8775$var$gl.viewport(0, 0, baseTex.width, baseTex.height);
        $9f3b2ca04e3d8775$var$blit(baseTex.fbo);
        last = baseTex;
    }
    $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    $9f3b2ca04e3d8775$var$bloomFinalProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$bloomFinalProgram.uniforms.texelSize, last.texelSizeX, last.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$bloomFinalProgram.uniforms.uTexture, last.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$bloomFinalProgram.uniforms.intensity, $9f3b2ca04e3d8775$var$config.BLOOM_INTENSITY);
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, destination.width, destination.height);
    $9f3b2ca04e3d8775$var$blit(destination.fbo);
}
function $9f3b2ca04e3d8775$var$applySunrays(source, mask, destination) {
    $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    $9f3b2ca04e3d8775$var$sunraysMaskProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$sunraysMaskProgram.uniforms.uTexture, source.attach(0));
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, mask.width, mask.height);
    $9f3b2ca04e3d8775$var$blit(mask.fbo);
    $9f3b2ca04e3d8775$var$sunraysProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$sunraysProgram.uniforms.weight, $9f3b2ca04e3d8775$var$config.SUNRAYS_WEIGHT);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$sunraysProgram.uniforms.uTexture, mask.attach(0));
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, destination.width, destination.height);
    $9f3b2ca04e3d8775$var$blit(destination.fbo);
}
function $9f3b2ca04e3d8775$var$blur(target, temp, iterations) {
    $9f3b2ca04e3d8775$var$blurProgram.bind();
    for(let i = 0; i < iterations; i++){
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$blurProgram.uniforms.texelSize, target.texelSizeX, 0.0);
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$blurProgram.uniforms.uTexture, target.attach(0));
        $9f3b2ca04e3d8775$var$blit(temp.fbo);
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$blurProgram.uniforms.texelSize, 0.0, target.texelSizeY);
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$blurProgram.uniforms.uTexture, temp.attach(0));
        $9f3b2ca04e3d8775$var$blit(target.fbo);
    }
}
function $9f3b2ca04e3d8775$var$send_splatPointer(pointer) {
    let dx = pointer.deltaX * $9f3b2ca04e3d8775$var$config.SPLAT_FORCE;
    let dy = pointer.deltaY * $9f3b2ca04e3d8775$var$config.SPLAT_FORCE;
    $9f3b2ca04e3d8775$var$send_splat(pointer.texcoordX, pointer.texcoordY, dx, dy, pointer.color);
}
function $9f3b2ca04e3d8775$var$multipleSplats(amount) {
    for(let i = 0; i < amount; i++){
        const color = $9f3b2ca04e3d8775$var$generateColor();
        color.r *= 10.0;
        color.g *= 10.0;
        color.b *= 10.0;
        const x = Math.random();
        const y = Math.random();
        const dx = 1000 * (Math.random() - 0.5);
        const dy = 1000 * (Math.random() - 0.5);
        $9f3b2ca04e3d8775$var$send_splat(x, y, dx, dy, color);
    }
}
function $9f3b2ca04e3d8775$var$send_splat(x, y, dx, dy, color) {
    $9f3b2ca04e3d8775$var$connection.invoke('splat', x, y, dx, dy, JSON.stringify(color));
}
$9f3b2ca04e3d8775$var$connection.on('broadSplat', (x, y, dx, dy, color)=>{
    let realColor = JSON.parse(color);
    //console.log("broadSplat", x, y, dx, dy, realColor);
    if ($9f3b2ca04e3d8775$var$splatHook) $9f3b2ca04e3d8775$var$splatHook(x, y, dx, dy, realColor);
    $9f3b2ca04e3d8775$var$splat(x, y, dx, dy, realColor);
});
$9f3b2ca04e3d8775$var$connection.on('broadConfig', (jsonConfig)=>{
    let realConfig = JSON.parse(jsonConfig);
    //console.log("broadConfig", realConfig);
    if ($9f3b2ca04e3d8775$var$queryStringContains("transparent")) realConfig.TRANSPARENT = true;
    $9f3b2ca04e3d8775$var$config = realConfig;
});
function $9f3b2ca04e3d8775$var$queryStringContains(txt) {
    return window.location.search && window.location.search.includes(txt);
}
function $9f3b2ca04e3d8775$var$splat(x, y, dx, dy, color) {
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, $9f3b2ca04e3d8775$var$velocity.width, $9f3b2ca04e3d8775$var$velocity.height);
    $9f3b2ca04e3d8775$var$splatProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$splatProgram.uniforms.uTarget, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$splatProgram.uniforms.aspectRatio, $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height);
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$splatProgram.uniforms.point, x, y);
    $9f3b2ca04e3d8775$var$gl.uniform3f($9f3b2ca04e3d8775$var$splatProgram.uniforms.color, dx, dy, 0.0);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$splatProgram.uniforms.radius, $9f3b2ca04e3d8775$var$correctRadius($9f3b2ca04e3d8775$var$config.SPLAT_RADIUS / 100.0));
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$velocity.write.fbo);
    $9f3b2ca04e3d8775$var$velocity.swap();
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, $9f3b2ca04e3d8775$var$dye.width, $9f3b2ca04e3d8775$var$dye.height);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$splatProgram.uniforms.uTarget, $9f3b2ca04e3d8775$var$dye.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform3f($9f3b2ca04e3d8775$var$splatProgram.uniforms.color, color.r, color.g, color.b);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$dye.write.fbo);
    $9f3b2ca04e3d8775$var$dye.swap();
}
function $9f3b2ca04e3d8775$var$correctRadius(radius) {
    let aspectRatio = $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height;
    if (aspectRatio > 1) radius *= aspectRatio;
    return radius;
}
$9f3b2ca04e3d8775$var$canvas.addEventListener('mousedown', (e)=>{
    let posX = $9f3b2ca04e3d8775$var$scaleByPixelRatio(e.offsetX);
    let posY = $9f3b2ca04e3d8775$var$scaleByPixelRatio(e.offsetY);
    let pointer = $9f3b2ca04e3d8775$var$pointers.find((p)=>p.id == -1);
    if (pointer == null) pointer = new $9f3b2ca04e3d8775$var$pointerPrototype();
    $9f3b2ca04e3d8775$var$updatePointerDownData(pointer, -1, posX, posY);
});
$9f3b2ca04e3d8775$var$canvas.addEventListener('mousemove', (e)=>{
    let pointer = $9f3b2ca04e3d8775$var$pointers[0];
    if (!pointer.down) return;
    let posX = $9f3b2ca04e3d8775$var$scaleByPixelRatio(e.offsetX);
    let posY = $9f3b2ca04e3d8775$var$scaleByPixelRatio(e.offsetY);
    $9f3b2ca04e3d8775$var$updatePointerMoveData(pointer, posX, posY);
});
window.addEventListener('mouseup', ()=>{
    $9f3b2ca04e3d8775$var$updatePointerUpData($9f3b2ca04e3d8775$var$pointers[0]);
});
$9f3b2ca04e3d8775$var$canvas.addEventListener('touchstart', (e)=>{
    e.preventDefault();
    const touches = e.targetTouches;
    while(touches.length >= $9f3b2ca04e3d8775$var$pointers.length)$9f3b2ca04e3d8775$var$pointers.push(new $9f3b2ca04e3d8775$var$pointerPrototype());
    for(let i = 0; i < touches.length; i++){
        let posX = $9f3b2ca04e3d8775$var$scaleByPixelRatio(touches[i].pageX);
        let posY = $9f3b2ca04e3d8775$var$scaleByPixelRatio(touches[i].pageY);
        $9f3b2ca04e3d8775$var$updatePointerDownData($9f3b2ca04e3d8775$var$pointers[i + 1], touches[i].identifier, posX, posY);
    }
});
$9f3b2ca04e3d8775$var$canvas.addEventListener('touchmove', (e)=>{
    e.preventDefault();
    const touches = e.targetTouches;
    for(let i = 0; i < touches.length; i++){
        let pointer = $9f3b2ca04e3d8775$var$pointers[i + 1];
        if (!pointer.down) continue;
        let posX = $9f3b2ca04e3d8775$var$scaleByPixelRatio(touches[i].pageX);
        let posY = $9f3b2ca04e3d8775$var$scaleByPixelRatio(touches[i].pageY);
        $9f3b2ca04e3d8775$var$updatePointerMoveData(pointer, posX, posY);
    }
}, false);
window.addEventListener('touchend', (e)=>{
    const touches = e.changedTouches;
    for(let i = 0; i < touches.length; i++){
        let pointer = $9f3b2ca04e3d8775$var$pointers.find((p)=>p.id == touches[i].identifier);
        if (pointer == null) continue;
        $9f3b2ca04e3d8775$var$updatePointerUpData(pointer);
    }
});
window.addEventListener('keydown', (e)=>{
    if (e.code === 'KeyP') $9f3b2ca04e3d8775$var$config.PAUSED = !$9f3b2ca04e3d8775$var$config.PAUSED;
    if (e.code === 'KeyJ') console.log(JSON.stringify($9f3b2ca04e3d8775$var$config, null, "\t"));
    if (e.key === ' ') $9f3b2ca04e3d8775$var$randomSplatsNow(parseInt(Math.random() * 20) + 5);
});
function $9f3b2ca04e3d8775$var$updatePointerDownData(pointer, id, posX, posY) {
    pointer.id = id;
    pointer.down = true;
    pointer.moved = false;
    pointer.texcoordX = posX / $9f3b2ca04e3d8775$var$canvas.width;
    pointer.texcoordY = 1.0 - posY / $9f3b2ca04e3d8775$var$canvas.height;
    pointer.prevTexcoordX = pointer.texcoordX;
    pointer.prevTexcoordY = pointer.texcoordY;
    pointer.deltaX = 0;
    pointer.deltaY = 0;
    pointer.color = $9f3b2ca04e3d8775$var$generateColor();
}
function $9f3b2ca04e3d8775$var$updatePointerMoveData(pointer, posX, posY) {
    pointer.prevTexcoordX = pointer.texcoordX;
    pointer.prevTexcoordY = pointer.texcoordY;
    pointer.texcoordX = posX / $9f3b2ca04e3d8775$var$canvas.width;
    pointer.texcoordY = 1.0 - posY / $9f3b2ca04e3d8775$var$canvas.height;
    pointer.deltaX = $9f3b2ca04e3d8775$var$correctDeltaX(pointer.texcoordX - pointer.prevTexcoordX);
    pointer.deltaY = $9f3b2ca04e3d8775$var$correctDeltaY(pointer.texcoordY - pointer.prevTexcoordY);
    pointer.moved = Math.abs(pointer.deltaX) > 0 || Math.abs(pointer.deltaY) > 0;
}
function $9f3b2ca04e3d8775$var$updatePointerUpData(pointer) {
    pointer.down = false;
}
function $9f3b2ca04e3d8775$var$correctDeltaX(delta) {
    let aspectRatio = $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height;
    if (aspectRatio < 1) delta *= aspectRatio;
    return delta;
}
function $9f3b2ca04e3d8775$var$correctDeltaY(delta) {
    let aspectRatio = $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height;
    if (aspectRatio > 1) delta /= aspectRatio;
    return delta;
}
function $9f3b2ca04e3d8775$var$generateColor() {
    let c = $9f3b2ca04e3d8775$var$HSVtoRGB(Math.random(), 1.0, 1.0);
    c.r *= 0.15;
    c.g *= 0.15;
    c.b *= 0.15;
    return c;
}
function $9f3b2ca04e3d8775$var$HSVtoRGB(h, s, v) {
    let r, g, b, i, f, p, q, t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch(i % 6){
        case 0:
            r = v, g = t, b = p;
            break;
        case 1:
            r = q, g = v, b = p;
            break;
        case 2:
            r = p, g = v, b = t;
            break;
        case 3:
            r = p, g = q, b = v;
            break;
        case 4:
            r = t, g = p, b = v;
            break;
        case 5:
            r = v, g = p, b = q;
            break;
    }
    return {
        r: r,
        g: g,
        b: b
    };
}
function $9f3b2ca04e3d8775$var$normalizeColor(input) {
    let output = {
        r: input.r / 255,
        g: input.g / 255,
        b: input.b / 255
    };
    return output;
}
function $9f3b2ca04e3d8775$var$wrap(value1, min, max) {
    let range = max - min;
    if (range == 0) return min;
    return (value1 - min) % range + min;
}
function $9f3b2ca04e3d8775$var$getResolution(resolution) {
    let aspectRatio = $9f3b2ca04e3d8775$var$gl.drawingBufferWidth / $9f3b2ca04e3d8775$var$gl.drawingBufferHeight;
    if (aspectRatio < 1) aspectRatio = 1.0 / aspectRatio;
    let min = Math.round(resolution);
    let max = Math.round(resolution * aspectRatio);
    if ($9f3b2ca04e3d8775$var$gl.drawingBufferWidth > $9f3b2ca04e3d8775$var$gl.drawingBufferHeight) return {
        width: max,
        height: min
    };
    else return {
        width: min,
        height: max
    };
}
function $9f3b2ca04e3d8775$var$getTextureScale(texture, width, height) {
    return {
        x: width / texture.width,
        y: height / texture.height
    };
}
function $9f3b2ca04e3d8775$var$scaleByPixelRatio(input) {
    let pixelRatio = window.devicePixelRatio || 1;
    return Math.floor(input * pixelRatio);
}
function $9f3b2ca04e3d8775$var$hashCode(s) {
    if (s.length == 0) return 0;
    let hash = 0;
    for(let i = 0; i < s.length; i++){
        hash = (hash << 5) - hash + s.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}


//# sourceMappingURL=js.31683e53.js.map
